export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: number; output: number; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  Upload: { input: any; output: any; }
};

export type Abilities = {
  __typename?: 'Abilities';
  canAddToCart: Scalars['Boolean']['output'];
  canViewInventory: Scalars['Boolean']['output'];
  canViewOnlineOrder: Scalars['Boolean']['output'];
  canViewOnlineQuote: Scalars['Boolean']['output'];
};

export type AccessoryServicePowerCordItem = {
  __typename?: 'AccessoryServicePowerCordItem';
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type AccessoryServicePowerCordItemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type AddCoworkerToGroupInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddItemsToCartInput = {
  action?: InputMaybe<CartRequestAction>;
  items: Array<CartItemInput>;
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddQuickOrderItemsInput = {
  quickOrderItems: Array<QuickOrderItem>;
};

export type AddSavedCartItemsInput = {
  cartId: Scalars['ID']['input'];
  items: Array<SavedCartItemInput>;
};

export type AddSoftwareSavedCartItemsInput = {
  items: Array<SavedCartItemInput>;
};

export type AddToCartAssay = {
  Amplicon?: InputMaybe<Scalars['String']['input']>;
  amplicon_size?: InputMaybe<Scalars['Int']['input']>;
  assay_id?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  exons?: InputMaybe<Scalars['String']['input']>;
  gene_id?: InputMaybe<Scalars['Int']['input']>;
  gene_sym?: InputMaybe<Scalars['String']['input']>;
  i_seq?: InputMaybe<Scalars['String']['input']>;
  l_seq?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  r_seq?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  ref_seq?: InputMaybe<Scalars['String']['input']>;
  search_by?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type AddToProtocolsLibraryInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AddressInfoType = {
  email?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  addressId: Scalars['String']['input'];
  attentionTo: Scalars['String']['input'];
  buildingRoom: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  department: Scalars['String']['input'];
  district: Scalars['String']['input'];
  email: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  fax: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  officeRegistrationNumber: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  organizationProperty?: InputMaybe<Scalars['String']['input']>;
  postOfficeBox?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  principalInvestigator?: InputMaybe<Scalars['String']['input']>;
  salesRepresentative?: InputMaybe<Scalars['String']['input']>;
  salutation: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2: Scalars['String']['input'];
  street3: Scalars['String']['input'];
  street4: Scalars['String']['input'];
  telephone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddressPartners = {
  __typename?: 'AddressPartners';
  billTo?: Maybe<PartnerObject>;
  blueCustomerDetails?: Maybe<Array<Maybe<BlueCustomerDetails>>>;
  contact?: Maybe<PartnerObject>;
  distChannel?: Maybe<Scalars['String']['output']>;
  erpSystemId?: Maybe<Scalars['String']['output']>;
  partnersIndexId?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<PartnerObject>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<PartnerObject>;
  soldTo?: Maybe<PartnerObject>;
  zzPartner?: Maybe<Scalars['String']['output']>;
};

export type AddressPartnersInput = {
  billTo?: InputMaybe<PartnerObjectInput>;
  blueCustomerDetails?: InputMaybe<Array<InputMaybe<BlueCustomerDetailsInput>>>;
  contact?: InputMaybe<PartnerObjectInput>;
  distChannel?: InputMaybe<Scalars['String']['input']>;
  erpSystemId?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  partnersIndexId?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<PartnerObjectInput>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<PartnerObjectInput>;
  soldTo?: InputMaybe<PartnerObjectInput>;
  storeId: Scalars['Int']['input'];
  zzPartner?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPartnersInfo = {
  __typename?: 'AdminPartnersInfo';
  isDefault: Scalars['Boolean']['output'];
  partners?: Maybe<Array<Maybe<AddressPartners>>>;
  storeId: Scalars['Int']['output'];
};

export type AdminPartnersInfoInput = {
  adminPartnersInfo?: InputMaybe<AdminPartnersInput>;
};

export type AdminPartnersInput = {
  partners?: InputMaybe<Array<InputMaybe<AddressPartnersInput>>>;
};

export type AemFooter = {
  __typename?: 'AemFooter';
  brandLogo?: Maybe<AemFooterBrandLogo>;
  footerLeftContent?: Maybe<Array<Maybe<AemFooterLeftContent>>>;
  footerRightContent?: Maybe<Array<Maybe<AemFooterRightContent>>>;
  legalLinks?: Maybe<Array<Maybe<AemFooterLinksItem>>>;
  portfolioLinks?: Maybe<Array<Maybe<AemFooterLinksItem>>>;
  socialContent?: Maybe<Array<Maybe<AemFooterSocialContent>>>;
  trademarkBoldText?: Maybe<Scalars['String']['output']>;
  trademarkSmallText?: Maybe<Scalars['String']['output']>;
};

export type AemFooterBrandLogo = {
  __typename?: 'AemFooterBrandLogo';
  alt?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  widths?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type AemFooterLeftContent = {
  __typename?: 'AemFooterLeftContent';
  items?: Maybe<Array<Maybe<AemFooterLinksItem>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AemFooterLinksItem = {
  __typename?: 'AemFooterLinksItem';
  externalUrl?: Maybe<Scalars['Boolean']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
};

export type AemFooterRightContent = {
  __typename?: 'AemFooterRightContent';
  contentType?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  rightText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AemFooterSocialContent = {
  __typename?: 'AemFooterSocialContent';
  contentType?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<AemFooterBrandLogo>>>;
  socialLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AemHeader = {
  __typename?: 'AemHeader';
  topnav?: Maybe<Array<Maybe<AemTopNav>>>;
};

export type AemHeaderFooter = {
  __typename?: 'AemHeaderFooter';
  footer?: Maybe<AemFooter>;
  header?: Maybe<AemHeader>;
};

export type AemSitewideMessage = {
  __typename?: 'AemSitewideMessage';
  id: Scalars['ID']['output'];
  isLoggedInMessage?: Maybe<Scalars['Boolean']['output']>;
  priority: MessagePriority;
  text: Scalars['String']['output'];
};

export type AemSitewideMessageInput = {
  loggedIn: Scalars['Boolean']['input'];
  path: Scalars['String']['input'];
};

export type AemTopNav = {
  __typename?: 'AemTopNav';
  additionalColumnHeading?: Maybe<Scalars['String']['output']>;
  additionalLinks?: Maybe<Array<Maybe<AemTopNavAdditionalLink>>>;
  fullWidthDrawer?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<AemTopNavItem>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AemTopNavAdditionalLink = {
  __typename?: 'AemTopNavAdditionalLink';
  altText?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  openNewTab?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AemTopNavItem = {
  __typename?: 'AemTopNavItem';
  childrens?: Maybe<Array<Maybe<AemTopNavItem>>>;
  menuItem?: Maybe<Scalars['Boolean']['output']>;
  openNewTab?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AffiliateAccountDetails = {
  __typename?: 'AffiliateAccountDetails';
  attention?: Maybe<Scalars['String']['output']>;
  buildingRooms?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customerAccountGroup?: Maybe<Scalars['String']['output']>;
  customerAdditionalName?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  partnerType?: Maybe<Scalars['String']['output']>;
  poBox?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  searchTerm?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
  street4?: Maybe<Scalars['String']['output']>;
  street5?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AffiliateAccountResponse = {
  __typename?: 'AffiliateAccountResponse';
  billToAddress: AffiliateAccountDetails;
  payerAddress: AffiliateAccountDetails;
  shipToAddress: AffiliateAccountDetails;
  soldToAddress: AffiliateAccountDetails;
};

export type Alias = {
  __typename?: 'Alias';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Aliquot = {
  __typename?: 'Aliquot';
  Mul1X200?: Maybe<Scalars['String']['output']>;
  Mul2X50?: Maybe<Scalars['String']['output']>;
  Mul2X100?: Maybe<Scalars['String']['output']>;
  Mul4X25?: Maybe<Scalars['String']['output']>;
  Mul4X50?: Maybe<Scalars['String']['output']>;
  Mul5X20?: Maybe<Scalars['String']['output']>;
  Mul5X200?: Maybe<Scalars['String']['output']>;
  Mul8X25?: Maybe<Scalars['String']['output']>;
  Mul10X20?: Maybe<Scalars['String']['output']>;
  Mul10X100?: Maybe<Scalars['String']['output']>;
  Mul10X200?: Maybe<Scalars['String']['output']>;
  Mul20X50?: Maybe<Scalars['String']['output']>;
  Mul20X100?: Maybe<Scalars['String']['output']>;
  Mul25X200?: Maybe<Scalars['String']['output']>;
  Mul40X25?: Maybe<Scalars['String']['output']>;
  Mul40X50?: Maybe<Scalars['String']['output']>;
  Mul50X20?: Maybe<Scalars['String']['output']>;
  Mul50X100?: Maybe<Scalars['String']['output']>;
  Mul80X25?: Maybe<Scalars['String']['output']>;
  Mul100X20?: Maybe<Scalars['String']['output']>;
  Mul100X50?: Maybe<Scalars['String']['output']>;
  Mul200X25?: Maybe<Scalars['String']['output']>;
};

export type AlternateMaterials = {
  __typename?: 'AlternateMaterials';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
};

export type AlternateProduct = {
  __typename?: 'AlternateProduct';
  brand: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
};

export type Amount = {
  __typename?: 'Amount';
  hundred?: Maybe<Scalars['String']['output']>;
  one?: Maybe<Scalars['String']['output']>;
  ten?: Maybe<Scalars['String']['output']>;
  twentyFive?: Maybe<Scalars['String']['output']>;
};

export type AmsQuotesInput = {
  quoteNumber: Scalars['String']['input'];
};

export type AmsQuotesPayload = {
  __typename?: 'AmsQuotesPayload';
  avgPrice: Scalars['Float']['output'];
  avgPriceInDollar: Scalars['Float']['output'];
  cartId: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  email: Scalars['String']['output'];
  exchangeRate: Scalars['Float']['output'];
  expiryDate: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastUpdatedDate: Scalars['Date']['output'];
  partnumber?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  quoteId: Scalars['String']['output'];
  quoteNumber: Scalars['String']['output'];
  sampleCount: Scalars['Int']['output'];
  shipWindow: Scalars['Int']['output'];
  soldTo: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
  totalPriceInDollar: Scalars['Float']['output'];
};

export enum AnalyticsDispType {
  Cp007 = 'CP007',
  S002 = 'S002',
  S003 = 'S003',
  S007 = 'S007',
  S012 = 'S012',
  S015 = 'S015',
  S017 = 'S017',
  S020 = 'S020',
  S022 = 'S022',
  S029 = 'S029',
  S053 = 'S053',
  S064 = 'S064',
  S071 = 'S071',
  S103 = 'S103',
  S107 = 'S107',
  S111 = 'S111',
  S114 = 'S114',
  S125 = 'S125',
  S138 = 'S138',
  S140 = 'S140',
  S151 = 'S151',
  S194 = 'S194',
  S198 = 'S198',
  S199 = 'S199',
  S241 = 'S241',
  S280 = 'S280',
  S307 = 'S307',
  S315 = 'S315',
  S319 = 'S319',
  S324 = 'S324',
  S348 = 'S348',
  S366 = 'S366',
  S372 = 'S372',
  S395 = 'S395',
  S402 = 'S402',
  S863 = 'S863',
  BestSellers = 'best_sellers',
  BiaHm = 'biaHM',
  BiaSc = 'biaSC',
  CompareTablePdp = 'compareTablePDP',
  CustomersAlsoViewedApi = 'customersAlsoViewedAPI',
  MTrackApi = 'mTrackAPI',
  MTrackApIv1 = 'mTrackAPIv1',
  NewProducts = 'new_products',
  PopularProducts = 'popular_products',
  QuickOrderApi = 'quickOrderAPI',
  RecentlyViewedAccountDashboard = 'recentlyViewedAccountDashboard',
  RecentlyViewedAdvancedSearch = 'recentlyViewedAdvancedSearch',
  RecentlyViewedDocumentSearch = 'recentlyViewedDocumentSearch',
  RecentlyViewedPdp = 'recentlyViewedPDP',
  RecentlyViewedQuickOrder = 'recentlyViewedQuickOrder',
  RecentlyViewedRchp = 'recentlyViewedRCHP',
  RecentlyViewedSrp = 'recentlyViewedSRP',
  RecommendedProductsPdp = 'recommendedProductsPDP',
  SrpPromoApi = 'srpPromoAPI',
  SrpRecsApi = 'srpRecsAPI',
  StratosScFbtApi = 'stratosScFbtAPI'
}

export type AnalyticsProductAttribute = {
  __typename?: 'AnalyticsProductAttribute';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AntisenceSeq = {
  __typename?: 'AntisenceSeq';
  antisenceSeq?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type AntiseraPeptideModel = {
  amount?: InputMaybe<Scalars['String']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  cterminalMod?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listPeptideCarrierProtein?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nterminalMod?: InputMaybe<Scalars['String']['input']>;
  peptideAddSpecification: Scalars['String']['input'];
  peptideCarrierProtein?: InputMaybe<Scalars['String']['input']>;
  peptideName: Scalars['String']['input'];
  projectType?: InputMaybe<Scalars['String']['input']>;
  purityLevel?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalConsolidationModel = {
  __typename?: 'ApprovalConsolidationModel';
  activate?: Maybe<Scalars['Boolean']['output']>;
  delegateApproverId?: Maybe<Scalars['String']['output']>;
  delegationApprovalExpirationDate?: Maybe<Scalars['String']['output']>;
  isDelegateEnabled?: Maybe<Scalars['Boolean']['output']>;
  participantApprovers?: Maybe<Array<Maybe<ParticipantApprover>>>;
};

export enum ApprovalTypeId {
  /** General Approval */
  Ga = 'GA',
  /** Item Amount Approval */
  Ia = 'IA',
  /** Transaction Amount Approval */
  Ta = 'TA'
}

export type ApprovalTypes = {
  __typename?: 'ApprovalTypes';
  approvalTypeDesc: Scalars['String']['output'];
  approvalTypeId: ApprovalTypeId;
  approvalTypeKey: Scalars['String']['output'];
};

export type Approver = {
  __typename?: 'Approver';
  approverId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Assay = {
  __typename?: 'Assay';
  Amplicon?: Maybe<Scalars['String']['output']>;
  amplicon_size?: Maybe<Scalars['Int']['output']>;
  assay_id?: Maybe<Scalars['String']['output']>;
  exons?: Maybe<Scalars['String']['output']>;
  gene_id?: Maybe<Scalars['Int']['output']>;
  gene_sym?: Maybe<Scalars['String']['output']>;
  i_seq?: Maybe<Scalars['String']['output']>;
  l_seq?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  r_seq?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  ref_seq?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type AssayModel = {
  allAnalytesSelected?: InputMaybe<Scalars['String']['input']>;
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assayType?: InputMaybe<Scalars['String']['input']>;
  customPremixSelection?: InputMaybe<Scalars['String']['input']>;
  customPremixedAvailable?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionTableVer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSampleType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSearchResultModelErrors?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listWarnings?: InputMaybe<Array<InputMaybe<ListWarningInput>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  mutualAnalytesList?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  panelName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productTotal?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  requireSample?: InputMaybe<Scalars['String']['input']>;
  researchAreaOracle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampleType?: InputMaybe<Scalars['String']['input']>;
  selectedAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceSaver?: InputMaybe<Scalars['String']['input']>;
  spaceSaverSelection?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AssayTypeItem = {
  __typename?: 'AssayTypeItem';
  assayType: Scalars['String']['output'];
  plateType: Array<Scalars['String']['output']>;
  speciesResearchArea: Array<SpeciesItem>;
};

export type Assessment = {
  code: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type Assessments = {
  assessments: Array<InputMaybe<Assessment>>;
  comment: Scalars['String']['input'];
  grade: Scalars['Int']['input'];
  visible: Scalars['Boolean']['input'];
};

export type AssistantInput = {
  messages: Array<UserMessage>;
};

export type AssistantResponse = {
  __typename?: 'AssistantResponse';
  alert?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Scalars['String']['output']>>;
  recommendedProducts?: Maybe<Array<RecommendedProduct>>;
  response: Scalars['String']['output'];
  suggestedQuestions?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssociatedProducts = {
  __typename?: 'AssociatedProducts';
  products: Array<Product>;
};

export type AutoCompleteCertificateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AutoCompleteCertificateItem = {
  __typename?: 'AutoCompleteCertificateItem';
  count?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type AutoCompleteCertificateResponse = {
  __typename?: 'AutoCompleteCertificateResponse';
  results?: Maybe<Array<AutoCompleteCertificateItem>>;
  term: Scalars['String']['output'];
};

export type AvailabilityMsg = {
  __typename?: 'AvailabilityMsg';
  availabilityOverwriteMessage?: Maybe<AvailabilityOverwriteMessage>;
  contactInfo?: Maybe<ContactInfo>;
  displayFromLink?: Maybe<Scalars['Boolean']['output']>;
  displayInquireLink?: Maybe<Scalars['Boolean']['output']>;
  primaryMsg?: Maybe<AvailabilityMsgEntry>;
  promotionalMessage?: Maybe<AvailabilityOverwriteMessage>;
  secondaryMsg?: Maybe<Array<Maybe<AvailabilityMsgEntry>>>;
  supplementaryMessage?: Maybe<SupplementaryMessage>;
};

export type AvailabilityMsgEntry = {
  __typename?: 'AvailabilityMsgEntry';
  date?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  plantLoc?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type AvailabilityOverwriteMessage = {
  __typename?: 'AvailabilityOverwriteMessage';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
};

export type AzureTokenInput = {
  code: Scalars['String']['input'];
  session_state: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type AzureTokenResponse = {
  __typename?: 'AzureTokenResponse';
  access_token?: Maybe<Scalars['String']['output']>;
};

export type B2BChannelInformation = {
  __typename?: 'B2BChannelInformation';
  htmlFileName?: Maybe<Scalars['String']['output']>;
  isB2B: Scalars['Boolean']['output'];
  logoDirectory?: Maybe<Scalars['String']['output']>;
};

export type B2BUserParticipantSitePreference = {
  __typename?: 'B2BUserParticipantSitePreference';
  websiteLocale?: Maybe<Scalars['String']['output']>;
};

export type B2bShoppingCartDataResponse = {
  __typename?: 'B2bShoppingCartDataResponse';
  isDecodeNeeded?: Maybe<Scalars['Boolean']['output']>;
  isSapOci?: Maybe<Scalars['Boolean']['output']>;
  postBackURL?: Maybe<Scalars['String']['output']>;
  punchoutResponseMsg?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type B2bUserMetadata = {
  __typename?: 'B2bUserMetadata';
  country?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
};

export type B2bUserResponse = {
  __typename?: 'B2bUserResponse';
  metadata?: Maybe<B2bUserMetadata>;
  participantSitePreference?: Maybe<B2BUserParticipantSitePreference>;
  userProfile?: Maybe<B2bUserResponseProfile>;
};

export type B2bUserResponseProfile = {
  __typename?: 'B2bUserResponseProfile';
  logonId?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
};

export type BbeMaterialAvailability = {
  __typename?: 'BBEMaterialAvailability';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
};

export type BankDetails = {
  __typename?: 'BankDetails';
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
};

export type BasePrice = {
  __typename?: 'BasePrice';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type BiTubeData = {
  __typename?: 'BiTubeData';
  data: Array<DuplexDetails>;
};

export type BiTubeWellList = {
  __typename?: 'BiTubeWellList';
  additionalComments?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  antisenceBaseCount?: Maybe<Scalars['Int']['output']>;
  antisenceFiveMod?: Maybe<Scalars['String']['output']>;
  antisenceName?: Maybe<Scalars['String']['output']>;
  antisenceSequence?: Maybe<Scalars['String']['output']>;
  antisenceThreeMod?: Maybe<Scalars['String']['output']>;
  antisenseGcContent?: Maybe<Scalars['String']['output']>;
  antisenseMeltingTemparature?: Maybe<Scalars['String']['output']>;
  antisenseMolecularWeight?: Maybe<Scalars['String']['output']>;
  antisensePrimerDimer?: Maybe<Scalars['String']['output']>;
  antisenseSecondaryStructure?: Maybe<Scalars['String']['output']>;
  autoGenerateOligo?: Maybe<Scalars['Boolean']['output']>;
  autoValidation?: Maybe<Scalars['Boolean']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  column: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerAntisenseOverHang?: Maybe<Scalars['String']['output']>;
  customerOverhang?: Maybe<Scalars['String']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listWarning?: Maybe<Array<Maybe<ListWarning>>>;
  meltingTemparature?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItemId?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  row: Scalars['String']['output'];
  scale?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  senseNameCheck?: Maybe<Scalars['Boolean']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Scalars['String']['output']>;
  technicalAntisenceSequence?: Maybe<Scalars['String']['output']>;
  technicalSequence?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['Boolean']['output']>;
  threeMod?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['Int']['output']>;
};

export type BiTubeWellListInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  antisenceBaseCount?: InputMaybe<Scalars['Int']['input']>;
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  antisenseGcContent?: InputMaybe<Scalars['String']['input']>;
  antisenseMeltingTemparature?: InputMaybe<Scalars['String']['input']>;
  antisenseMolecularWeight?: InputMaybe<Scalars['String']['input']>;
  antisensePrimerDimer?: InputMaybe<Scalars['String']['input']>;
  antisenseSecondaryStructure?: InputMaybe<Scalars['String']['input']>;
  autoGenerateOligo?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidation?: InputMaybe<Scalars['Boolean']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  column: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  gcContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listWarning?: InputMaybe<Array<InputMaybe<ListWarningInput>>>;
  meltingTemparature?: InputMaybe<Scalars['String']['input']>;
  molecularWeight?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderItemId?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  primerDimer?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['String']['input'];
  scale?: InputMaybe<Scalars['String']['input']>;
  secondaryStructure?: InputMaybe<Scalars['String']['input']>;
  senseNameCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['String']['input']>;
  technicalAntisenceSequence?: InputMaybe<Scalars['String']['input']>;
  technicalSequence?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['Int']['input']>;
};

export type BiTubeWellListUploadInput = {
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
};

export type BiTubeWelllistResponse = {
  __typename?: 'BiTubeWelllistResponse';
  countryCode?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listWarning?: Maybe<Array<Maybe<ListWarning>>>;
  oligoId?: Maybe<Scalars['Int']['output']>;
};

export type BigDataQueryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  document_type: Scalars['String']['input'];
  document_url: Scalars['String']['input'];
  email_domain?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  portfolio_brand?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  product_name_suffix?: InputMaybe<Scalars['String']['input']>;
  product_number?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['String']['input'];
};

export type BitubeTotalValidationResponse = {
  __typename?: 'BitubeTotalValidationResponse';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  listErrors?: Maybe<Array<Maybe<ListError>>>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type BlueCustomerDetails = {
  __typename?: 'BlueCustomerDetails';
  blueSoldTo?: Maybe<Scalars['String']['output']>;
  blueSysId?: Maybe<Scalars['String']['output']>;
  globalCustomerNumber?: Maybe<Scalars['String']['output']>;
};

export type BlueCustomerDetailsInput = {
  blueSoldTo?: InputMaybe<Scalars['String']['input']>;
  blueSysId?: InputMaybe<Scalars['String']['input']>;
  globalCustomerNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum BlueSystemSysIds {
  Orc = 'ORC',
  TempoEu = 'TEMPO_EU',
  TempoLa = 'TEMPO_LA',
  TempoNa = 'TEMPO_NA',
  Emerald = 'emerald',
  Iscala = 'iscala'
}

export type Brand = {
  __typename?: 'Brand';
  cells?: Maybe<CatalogImage>;
  color?: Maybe<Scalars['String']['output']>;
  erpKey: Scalars['String']['output'];
  key: Scalars['ID']['output'];
  logo?: Maybe<CatalogImage>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BrowserMetadata = {
  __typename?: 'BrowserMetadata';
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CalculatedValues = {
  __typename?: 'CalculatedValues';
  amount?: Maybe<Scalars['String']['output']>;
  daughterPlateRange?: Maybe<Scalars['Int']['output']>;
  maxAmount?: Maybe<Scalars['Float']['output']>;
  maxConcentration?: Maybe<Scalars['Float']['output']>;
  maxVolume?: Maybe<Scalars['Float']['output']>;
  minVolume?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
};

export type CardAttribute = {
  __typename?: 'CardAttribute';
  application: Array<Scalars['String']['output']>;
  citationCount?: Maybe<Scalars['String']['output']>;
};

export enum CarrierId {
  Dpd = 'dpd',
  Fedex = 'fedex'
}

export type Cart = {
  __typename?: 'Cart';
  approvers: Array<Approver>;
  bankDetails?: Maybe<BankDetails>;
  billingAddress?: Maybe<CartAddress>;
  blanketPoNumber?: Maybe<Scalars['String']['output']>;
  cartEligibleForBuyItNow: Scalars['Boolean']['output'];
  cartIdAlias?: Maybe<Scalars['String']['output']>;
  cartType?: Maybe<Scalars['String']['output']>;
  chargebackCodes: Array<ChargebackCode>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  creditCardTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currency?: Maybe<Scalars['String']['output']>;
  customerInfo?: Maybe<CustomerInfo>;
  customerRequestId?: Maybe<Scalars['String']['output']>;
  customerServiceInstructions?: Maybe<Scalars['String']['output']>;
  deaItemExists: Scalars['Boolean']['output'];
  deaMaterials: Array<Scalars['String']['output']>;
  dealers: Array<Dealer>;
  destination?: Maybe<Scalars['String']['output']>;
  displayDirectShipmentCheckbox: Scalars['Boolean']['output'];
  displayPromoCode: Scalars['Boolean']['output'];
  displayRejectAllRequestButton: Scalars['Boolean']['output'];
  displayRejectThisRequestButton: Scalars['Boolean']['output'];
  displaySaveCartButton: Scalars['Boolean']['output'];
  displaySubmitCartButton: Scalars['Boolean']['output'];
  displaySubmitQuoteButton: Scalars['Boolean']['output'];
  displaySubmitRequestButton: Scalars['Boolean']['output'];
  eurVolatileMassCharge?: Maybe<Scalars['Float']['output']>;
  hasHazardousMaterial?: Maybe<Scalars['Boolean']['output']>;
  hasQuotePriceItem: Scalars['Boolean']['output'];
  headerSAPError?: Maybe<SapError>;
  hidePrice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDirectShipment: Scalars['Boolean']['output'];
  isEmproveProductExists: Scalars['Boolean']['output'];
  items: Array<CartItem>;
  merchantLocation?: Maybe<Scalars['String']['output']>;
  netTotal?: Maybe<Scalars['Float']['output']>;
  orderingPartyAddress?: Maybe<CartAddress>;
  packingSlipNote?: Maybe<Scalars['String']['output']>;
  partners: CartPartners;
  paymentMethods?: Maybe<CartPaymentMethods>;
  pin?: Maybe<Scalars['String']['output']>;
  promoSavings?: Maybe<Scalars['Float']['output']>;
  salesOrderSource?: Maybe<SalesOrderSource>;
  selectedPaymentMethod?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CartAddress>;
  shippingPreference?: Maybe<ShippingPreference>;
  supportedPaymentMethods: Array<Scalars['String']['output']>;
  totals?: Maybe<CartTotals>;
  transSurchargeMessage?: Maybe<Scalars['String']['output']>;
  znPartnerAddress?: Maybe<CartAddress>;
  zzPartnerAddress?: Maybe<CartAddress>;
};

export type CartAdditionalInfo = {
  __typename?: 'CartAdditionalInfo';
  carrierRestriction?: Maybe<Scalars['String']['output']>;
  casNumber?: Maybe<Scalars['String']['output']>;
  jfcCode?: Maybe<Scalars['String']['output']>;
  netSurcharge?: Maybe<Scalars['Float']['output']>;
  pdcCode?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
  tariff?: Maybe<Scalars['String']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
};

export type CartAddress = {
  __typename?: 'CartAddress';
  attentionTo?: Maybe<LockableValue>;
  buildingRoom?: Maybe<LockableValue>;
  ccForOrderConfEmailIds?: Maybe<LockableValue>;
  city?: Maybe<LockableValue>;
  country?: Maybe<LockableValue>;
  department?: Maybe<LockableValue>;
  district?: Maybe<LockableValue>;
  email?: Maybe<LockableValue>;
  extension?: Maybe<LockableValue>;
  fax?: Maybe<LockableValue>;
  firstName?: Maybe<LockableValue>;
  lastName?: Maybe<LockableValue>;
  mobile?: Maybe<LockableValue>;
  organizationName?: Maybe<LockableValue>;
  postOfficeBox?: Maybe<LockableValue>;
  postalCode?: Maybe<LockableValue>;
  recipientName?: Maybe<LockableValue>;
  state?: Maybe<LockableValue>;
  street1?: Maybe<LockableValue>;
  street3?: Maybe<LockableValue>;
  street4?: Maybe<LockableValue>;
  street5?: Maybe<LockableValue>;
  telephone?: Maybe<LockableValue>;
};

export type CartAddressInput = {
  attentionTo?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  ccForOrderConfEmailIds?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  postOfficeBox?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street3?: InputMaybe<Scalars['String']['input']>;
  street4?: InputMaybe<Scalars['String']['input']>;
  street5?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  additionalInfo?: Maybe<CartAdditionalInfo>;
  availabilityMessages: Array<Maybe<CartItemAvailabilityMessages>>;
  availabilityOverwriteMessage?: Maybe<BbeMaterialAvailability>;
  availableQtyInStock?: Maybe<Scalars['Int']['output']>;
  /** The lot/batch number if this item was added from a quote */
  batchNumber?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  bundleItems: Array<PromotionalBundleItemPricing>;
  carrierName?: Maybe<Scalars['String']['output']>;
  complianceMessages: Array<Scalars['String']['output']>;
  complianceRegulationMappingList: Array<ComplianceObj>;
  configuration: Array<ProductConfiguration>;
  configurationId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerOrderInfo?: Maybe<CustomerOrderInfo>;
  dealerId?: Maybe<Scalars['String']['output']>;
  deviceSerialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discontinuedPricingInfo?: Maybe<DiscontinuedMaterialPricing>;
  displayEditButton: Scalars['Boolean']['output'];
  distrChainStatus?: Maybe<Scalars['String']['output']>;
  emproveDossierInfo?: Maybe<EmproveDossierItem>;
  errors: Array<SapError>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importLicense?: Maybe<Scalars['String']['output']>;
  isBlockedProduct: Scalars['Boolean']['output'];
  isItemSingleLotEnabled?: Maybe<Scalars['Boolean']['output']>;
  isKit: Scalars['Boolean']['output'];
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  isSingleLotSelected?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<Scalars['String']['output']>;
  kitItems: Array<CartKitItem>;
  leadTime?: Maybe<Scalars['Int']['output']>;
  listPriceCurrency?: Maybe<Scalars['String']['output']>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  marketplaceShippingMethod?: Maybe<Scalars['String']['output']>;
  marketplaceShippingPreference?: Maybe<MarketplaceShippingPreference>;
  material: Material;
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  plant?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<CartItemPricing>;
  product?: Maybe<Scalars['String']['output']>;
  productNote?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promotionalMessage?: Maybe<CartItemPromotionalMessage>;
  quantity: Scalars['Int']['output'];
  quoteDocType?: Maybe<Scalars['String']['output']>;
  /** Only returned if this item was added from a quote */
  quoteItemNumber?: Maybe<Scalars['String']['output']>;
  /** Only returned if this item was added from a quote */
  quoteNumber?: Maybe<Scalars['String']['output']>;
  redirectLinkForEdit?: Maybe<Scalars['String']['output']>;
  /** The remaining qty that can be added from the quote this was added from */
  remainingReserveQuantity?: Maybe<Scalars['Int']['output']>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  routeInfo?: Maybe<Scalars['String']['output']>;
  sharedListData?: Maybe<CartItemSharedListInfoOutput>;
  shipMode?: Maybe<Scalars['String']['output']>;
  subscriptionFrequency?: Maybe<Scalars['String']['output']>;
  supplementaryMessage?: Maybe<SupplementaryMessage>;
  /** The total qty originally quoted */
  totalReserveQuantity?: Maybe<Scalars['Int']['output']>;
  type: CartItemType;
  vendorNumber?: Maybe<Scalars['String']['output']>;
  yourReference?: Maybe<Scalars['String']['output']>;
};

export type CartItemAvailabilityMessages = {
  __typename?: 'CartItemAvailabilityMessages';
  date?: Maybe<Scalars['Date']['output']>;
  key: Scalars['String']['output'];
  plantLoc?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type CartItemInput = {
  /** Used only when converting a quote to an order in Aldrich Market Select */
  amsQuoteNumber?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<CartItemInputAvailability>;
  /** Used only for materials where the material endpoint returns nothing */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Used only for deleting an item */
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  /** Used only for configurable cart items (type must be Configurator) */
  configurationId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Used only for configurable cart items in quote to order conversion */
  customerPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Used only for dtaq customers */
  dealerId?: InputMaybe<Scalars['String']['input']>;
  /** Used only for Emprove documents */
  emproveDossierInfo?: InputMaybe<EmproveDossierInfo>;
  /** Used to associate items in a standing order (cart item id) */
  groupId?: InputMaybe<Scalars['String']['input']>;
  isQuotePriceItem?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleLotSelected?: InputMaybe<Scalars['Boolean']['input']>;
  itemDeletionFlag?: InputMaybe<Scalars['Boolean']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  marketplaceOfferId?: InputMaybe<Scalars['String']['input']>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  productNote?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  /** Used only when converting a quote to an order */
  quoteDocType?: InputMaybe<Scalars['String']['input']>;
  /** Used only when converting a quote to an order */
  quoteItemNumber?: InputMaybe<Scalars['String']['input']>;
  /** Used only when converting a quote to an order */
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  /** Used only adding an item from a Shared List */
  sharedListData?: InputMaybe<CartItemSharedListInfo>;
  /** Used only when converting a quote to an order */
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionFrequency?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CartItemType>;
  yourReference?: InputMaybe<Scalars['String']['input']>;
};

export type CartItemInputAvailability = {
  date?: InputMaybe<Scalars['Date']['input']>;
  key: Scalars['String']['input'];
  plantLoc?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartItemPricing = {
  __typename?: 'CartItemPricing';
  listPrice?: Maybe<Scalars['Float']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type CartItemPromotionalMessage = {
  __typename?: 'CartItemPromotionalMessage';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
};

export type CartItemSharedListInfo = {
  sharedListId: Scalars['String']['input'];
  sharedListItemId: Scalars['String']['input'];
};

export type CartItemSharedListInfoOutput = {
  __typename?: 'CartItemSharedListInfoOutput';
  sharedListId: Scalars['String']['output'];
  sharedListItemId: Scalars['String']['output'];
};

export enum CartItemType {
  Ams = 'AMS',
  Configurator = 'Configurator',
  Contract = 'Contract',
  Emprove = 'Emprove',
  License = 'License',
  Prepack = 'Prepack',
  PromotionalBundle = 'PromotionalBundle',
  ThirdPartyProvider = 'ThirdPartyProvider'
}

export type CartItemUpdateInput = {
  cartItemId: Scalars['ID']['input'];
  productNote?: InputMaybe<Scalars['String']['input']>;
  promoCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  yourReference?: InputMaybe<Scalars['String']['input']>;
};

export type CartKitItem = {
  __typename?: 'CartKitItem';
  listPrice: Scalars['Float']['output'];
  materialDescription: Scalars['String']['output'];
  materialNumber: Scalars['String']['output'];
  netPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type CartPartners = {
  __typename?: 'CartPartners';
  SalesOrg?: Maybe<Scalars['String']['output']>;
  billTo?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  znPartner?: Maybe<Scalars['String']['output']>;
  zzPartner?: Maybe<Scalars['String']['output']>;
};

export type CartPartnersInput = {
  SalesOrg?: InputMaybe<Scalars['String']['input']>;
  billTo?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  znPartner?: InputMaybe<Scalars['String']['input']>;
  zzPartner?: InputMaybe<Scalars['String']['input']>;
};

export type CartPaymentMethods = {
  __typename?: 'CartPaymentMethods';
  creditCard?: Maybe<CreditCardPaymentMethod>;
  labContract?: Maybe<PaymentMethod>;
  purchaseOrder?: Maybe<PaymentMethod>;
  requisition?: Maybe<PaymentMethod>;
};

export type CartPaymentMethodsInput = {
  labContract?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  requisition?: InputMaybe<Scalars['String']['input']>;
};

export type CartPreferences = {
  __typename?: 'CartPreferences';
  cartAddresses: CartValues;
  cartOrderText: CartValues;
  cartPaymentInfo: CartValues;
  cartShippingMethods: CartValues;
  defaultOpenLines: Scalars['Int']['output'];
  defaultOpenLinesEnabled: Scalars['Boolean']['output'];
  defaultOpenLinesLocked: Scalars['Boolean']['output'];
  enableFDDForB2B?: Maybe<Scalars['Boolean']['output']>;
  enableProductBlocking: Scalars['Boolean']['output'];
  enableSingleLotB2B?: Maybe<Scalars['Boolean']['output']>;
  fddLevelB2B?: Maybe<Scalars['String']['output']>;
  orderText: CartValues;
  participantId: Scalars['String']['output'];
  promotionalCodeField: CartValues;
  tariffCode: CartValues;
  unNumber: CartValues;
  yourReferenceField: CartValues;
  yourReferenceLabel?: Maybe<Scalars['String']['output']>;
};

export enum CartRequestAction {
  Bluecart = 'bluecart',
  Bluecartmini = 'bluecartmini',
  Bluesavedcart = 'bluesavedcart',
  Buyitnowcart = 'buyitnowcart',
  Buyitnowcartmini = 'buyitnowcartmini',
  Contractcart = 'contractcart',
  Dealercartmini = 'dealercartmini',
  Marketplace = 'marketplace',
  Marketplacebuyitnowcart = 'marketplacebuyitnowcart',
  Mini = 'mini',
  Orc = 'orc',
  Orcmini = 'orcmini',
  Quotefullyconvertcart = 'quotefullyconvertcart',
  Quotefullyconvertcartmini = 'quotefullyconvertcartmini',
  Savedcart = 'savedcart',
  Savedcartmini = 'savedcartmini'
}

export type CartSubmission = {
  __typename?: 'CartSubmission';
  errors: Array<SapError>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  orderTimedOut: Scalars['Boolean']['output'];
  paymentRedirectURL?: Maybe<Scalars['String']['output']>;
};

export type CartTotals = {
  __typename?: 'CartTotals';
  alcTax: Scalars['Float']['output'];
  complianceFee: Scalars['Float']['output'];
  dutyTotal: Scalars['Float']['output'];
  electricalFee: Scalars['Float']['output'];
  eurVolatileMassCharge?: Maybe<Scalars['Float']['output']>;
  iceCharge: Scalars['Float']['output'];
  packageCharge: Scalars['Float']['output'];
  shipping: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  tariffSurcharge?: Maybe<Scalars['Float']['output']>;
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export enum CartType {
  Active = 'ACTIVE',
  BuyItNow = 'BUY_IT_NOW',
  Marketplace = 'MARKETPLACE'
}

export type CartValues = {
  __typename?: 'CartValues';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
};

export type CatalogImage = {
  __typename?: 'CatalogImage';
  altText?: Maybe<Scalars['String']['output']>;
  brandKey?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  largeUrl: Scalars['String']['output'];
  mediumUrl: Scalars['String']['output'];
  productKey?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  smallUrl: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export enum CatalogType {
  B2b = 'b2b',
  Buildingblocks = 'buildingblocks',
  Marketplace = 'marketplace',
  Pm = 'pm',
  Sial = 'sial',
  Sialblue = 'sialblue',
  Sialpurple = 'sialpurple'
}

export type Category = {
  __typename?: 'Category';
  categoryDisplayName?: Maybe<Scalars['String']['output']>;
  categoryName: Scalars['String']['output'];
  categoryType?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  modifications: Array<CategoryModifications>;
  order?: Maybe<Scalars['String']['output']>;
};

export type CategoryModifications = {
  __typename?: 'CategoryModifications';
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  isDefault: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CategoryOption = {
  __typename?: 'CategoryOption';
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Certificate = CertificateText | CertificateUrl;

export type CertificateContent = {
  __typename?: 'CertificateContent';
  content?: Maybe<Array<Maybe<DocumentationContent>>>;
  documentType?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Content>;
};

export type CertificateContentInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type CertificateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  control?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  lotNumber: Scalars['String']['input'];
  productNumber: Scalars['String']['input'];
  sendLotNumber?: InputMaybe<Scalars['Boolean']['input']>;
  useCount?: InputMaybe<Scalars['Boolean']['input']>;
  useFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateText = {
  __typename?: 'CertificateText';
  brand: Scalars['String']['output'];
  lotNumber: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  signatureUrl: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  testSpecifications?: Maybe<Array<TestSpec>>;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum CertificateType {
  Coa = 'COA',
  Coo = 'COO',
  Coq = 'COQ'
}

export type CertificateUrl = {
  __typename?: 'CertificateUrl';
  brand: Scalars['String']['output'];
  product: Product;
  streamData?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebackCode = {
  __typename?: 'ChargebackCode';
  chargebackCode?: Maybe<Scalars['String']['output']>;
  chargebackLabel?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['Boolean']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ChargebackCodeInput = {
  chargebackCode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebackInputList = {
  chargebackCode?: InputMaybe<Scalars['String']['input']>;
  chargebackLabel?: InputMaybe<Scalars['String']['input']>;
  isDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isOnEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  partners?: InputMaybe<ChargebackPartnerInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebackPartnerInput = {
  chargeback_bill_to?: InputMaybe<Scalars['String']['input']>;
  chargeback_payer?: InputMaybe<Scalars['String']['input']>;
  chargeback_ship_to?: InputMaybe<Scalars['String']['input']>;
  chargeback_sold_to?: InputMaybe<Scalars['String']['input']>;
};

export type ChatConfigResponse = {
  __typename?: 'ChatConfigResponse';
  baseCoreURL?: Maybe<Scalars['String']['output']>;
  baseLiveAgentContentURL?: Maybe<Scalars['String']['output']>;
  baseLiveAgentURL?: Maybe<Scalars['String']['output']>;
  buttonId?: Maybe<Scalars['String']['output']>;
  chatType?: Maybe<Scalars['String']['output']>;
  communityEndpointURL?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  defaultMinimizedText?: Maybe<Scalars['String']['output']>;
  deploymentId?: Maybe<Scalars['String']['output']>;
  disabledMinimizedText?: Maybe<Scalars['String']['output']>;
  displayHelpButton?: Maybe<Scalars['String']['output']>;
  enabledFeatures?: Maybe<Scalars['String']['output']>;
  entryFeature?: Maybe<Scalars['String']['output']>;
  environments?: Maybe<Scalars['String']['output']>;
  eswLiveAgentDevName?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  loadingText?: Maybe<Scalars['String']['output']>;
  offlineSupportMinimizedText?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  routes: Array<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
};

export type CloneInformation = {
  __typename?: 'CloneInformation';
  cellType?: Maybe<Scalars['String']['output']>;
  cloneName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  knockdown?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  oligoSeq?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  refSeq?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  searchTrcVersion?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetSeq?: Maybe<Scalars['String']['output']>;
  trcId?: Maybe<Scalars['String']['output']>;
  trcVersion?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['String']['output']>;
};

export type CompanionProducts = {
  __typename?: 'CompanionProducts';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Compliance = {
  __typename?: 'Compliance';
  images: Array<CatalogImage>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ComplianceDocument = {
  __typename?: 'ComplianceDocument';
  itemComplianceDocuments?: Maybe<Array<Maybe<ItemComplianceDocument>>>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ComplianceJp = {
  __typename?: 'ComplianceJp';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ComplianceObj = {
  __typename?: 'ComplianceObj';
  actionRequired: Scalars['String']['output'];
  controlClass: Scalars['String']['output'];
  description: Scalars['String']['output'];
  regulationCode: Scalars['String']['output'];
};

export type ComplianceReach = {
  __typename?: 'ComplianceReach';
  casNos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ComponentType {
  Bulletin = 'bulletin',
  KitOnly = 'kitOnly',
  KitSoldSeparate = 'kitSoldSeparate'
}

export type ConfContactDetailsResponse = {
  __typename?: 'ConfContactDetailsResponse';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ConfigurableOption = {
  __typename?: 'ConfigurableOption';
  five_prime?: Maybe<FivePrime>;
};

export type Configurations = {
  __typename?: 'Configurations';
  errorType?: Maybe<Scalars['String']['output']>;
  modifications: Array<Modifications>;
  oligoComplementName?: Maybe<Scalars['String']['output']>;
  oligoComplementSequence?: Maybe<Scalars['String']['output']>;
  productDetails?: Maybe<Scalars['String']['output']>;
  specifications: Array<Specifications>;
};

export type ConfiguratorMilliplexAddToCartResponse = {
  __typename?: 'ConfiguratorMilliplexAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type ConfiguratorMiniCartResponse = {
  __typename?: 'ConfiguratorMiniCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type ConfiguratorPlates = {
  __typename?: 'ConfiguratorPlates';
  modifications: Array<Modifications>;
};

export type ConfiguratorProductInput = {
  cartId?: InputMaybe<Scalars['String']['input']>;
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guestParticipantId?: InputMaybe<Scalars['String']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isRegUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ConfiguratorProductUserInput = {
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isRegUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmAffiliationInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  blueCustomerDetails?: InputMaybe<Array<InputMaybe<BlueCustomerDetailsInput>>>;
  contact?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmOrderQuoteInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  sapOrderNo?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ConsolidateOrdersIntoActiveCartInput = {
  orderIds: Array<Scalars['String']['input']>;
};

export type ConsolidationHistory = {
  __typename?: 'ConsolidationHistory';
  billTo: Scalars['String']['output'];
  consolidatorId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  numberOfItems: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderTotal: Scalars['Float']['output'];
  participantId: Scalars['String']['output'];
  requester: Scalars['String']['output'];
  shipTo: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  submittedDate: Scalars['Date']['output'];
};

export type ConsolidationOrder = {
  __typename?: 'ConsolidationOrder';
  billTo?: Maybe<Scalars['String']['output']>;
  billToAddress: CartAddress;
  consolidationHistoryList: Array<ConsolidationHistory>;
  shipTo?: Maybe<Scalars['String']['output']>;
  shipToAddress: CartAddress;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactMail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  salesOfficeCode?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  email: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
};

export type ContactSellerInput = {
  offerMessage?: InputMaybe<OfferMessage>;
  orderMessage?: InputMaybe<OrderMessage>;
  sellerMessage?: InputMaybe<SellerMessage>;
};

export type ContactSellerResponse = {
  __typename?: 'ContactSellerResponse';
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type Content = {
  __typename?: 'Content';
  owner?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ContentDocumentSearchResponse = SearchResults & {
  __typename?: 'ContentDocumentSearchResponse';
  facets: Array<Facet>;
  items: Array<TechnicalDocument>;
  metadata: SearchResultsMetadata;
};

export type ContentProductDocument = {
  __typename?: 'ContentProductDocument';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentProductDocumentsInput = {
  term: Scalars['String']['input'];
};

export type ContentProductDocumentsResponse = {
  __typename?: 'ContentProductDocumentsResponse';
  items: Array<ContentProductDocument>;
};

export type ContentSearchInput = {
  contentSearchType: ContentSearchType;
  facetSet?: InputMaybe<Array<FacetSetInput>>;
  facets?: InputMaybe<Array<FacetInput>>;
  filterSite?: InputMaybe<Scalars['String']['input']>;
  pagination?: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentSearchType {
  Documents = 'documents',
  SiteContent = 'siteContent'
}

export type ContractCardTransactionsInput = {
  cardType: ContractType;
  contractNumber: Scalars['String']['input'];
  pin: Scalars['String']['input'];
};

export type ContractCardTransactionsPayload = {
  __typename?: 'ContractCardTransactionsPayload';
  balance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  transactionHistory: Array<TransactionHistory>;
  validTo: Scalars['Date']['output'];
};

export type ContractPaymentMethod = {
  __typename?: 'ContractPaymentMethod';
  amounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contactInformation?: Maybe<ContactInformation>;
  contractType?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
};

export enum ContractType {
  Blanketpo = 'BLANKETPO',
  Mpower = 'MPOWER',
  Rapidred = 'RAPIDRED'
}

export type Controls = {
  __typename?: 'Controls';
  currency?: Maybe<Scalars['String']['output']>;
  efficiencyScore?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  grnaId?: Maybe<Scalars['String']['output']>;
  moreInformation?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  recommendedStatus?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  specificityScore?: Maybe<Scalars['String']['output']>;
};

export type CountryAccountSetup = {
  __typename?: 'CountryAccountSetup';
  erpSystemId?: Maybe<Scalars['String']['output']>;
  guestShoppingType?: Maybe<Scalars['String']['output']>;
  salesOfficeCode?: Maybe<Scalars['String']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
};

export type CountryResponse = {
  __typename?: 'CountryResponse';
  countryCode: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  guestShoppingType?: Maybe<Scalars['String']['output']>;
  regionCode: Scalars['String']['output'];
  regionName: Scalars['String']['output'];
};

export type CountryStates = {
  __typename?: 'CountryStates';
  countryCode?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
};

export type CoworkerGroupDetailResponse = {
  __typename?: 'CoworkerGroupDetailResponse';
  coWorkers?: Maybe<Array<Maybe<CoworkersResponse>>>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<CoworkerGroupPartner>;
};

export type CoworkerGroupPartner = {
  __typename?: 'CoworkerGroupPartner';
  billTo: Array<CoworkerGroupPartnerType>;
  payer: Array<CoworkerGroupPartnerType>;
  shipTo: Array<CoworkerGroupPartnerType>;
  soldTo: Scalars['String']['output'];
};

export type CoworkerGroupPartnerType = {
  __typename?: 'CoworkerGroupPartnerType';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type CoworkerGroupResponse = {
  __typename?: 'CoworkerGroupResponse';
  coWorkers?: Maybe<Array<Maybe<CoworkersResponse>>>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
};

export type CoworkersResponse = {
  __typename?: 'CoworkersResponse';
  coworkerIds?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreateApproverCartInput = {
  orderId: Scalars['String']['input'];
};

export type CreateContractCartInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  contractAmount: Scalars['String']['input'];
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  contractPin: Scalars['String']['input'];
  isRefill?: InputMaybe<Scalars['Boolean']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<GroupPartner>;
};

export type CreateGroupResponse = {
  __typename?: 'CreateGroupResponse';
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
};

export type CreateSharedListInput = {
  coOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invitations: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reminderFrequencyDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  sharedListItems?: InputMaybe<Array<SharedListItemInput>>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  customerType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

export type CreditCardInput = {
  cardExpiryDate?: InputMaybe<Scalars['String']['input']>;
  cardNameValue?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  ccLegalTermsAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  maskedCardNumber?: InputMaybe<Scalars['String']['input']>;
  saveAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  tokenizedCCNumber?: InputMaybe<Scalars['String']['input']>;
  transientCCToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardPaymentInvoiceResponse = {
  __typename?: 'CreditCardPaymentInvoiceResponse';
  lineItemList: Array<Invoice>;
};

export type CreditCardPaymentMethod = {
  __typename?: 'CreditCardPaymentMethod';
  cardExpiryDate: Scalars['String']['output'];
  cardNameLabel?: Maybe<Scalars['String']['output']>;
  cardNameValue: Scalars['String']['output'];
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardType: Scalars['String']['output'];
  displayableInCart?: Maybe<Scalars['Boolean']['output']>;
  displayableInEmail?: Maybe<Scalars['Boolean']['output']>;
  editableInCart?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  maskedCardNumber: Scalars['String']['output'];
  participantId?: Maybe<Scalars['String']['output']>;
  saveAsDefault?: Maybe<Scalars['Boolean']['output']>;
  tokenizedCCNumber?: Maybe<Scalars['String']['output']>;
  verificationValue?: Maybe<Scalars['String']['output']>;
};

export type CreditCardPaymentSearchInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Field names coming from 3rd party system and need to pass same fileds to BE */
export type CreditCardPaymentUpdateInput = {
  FLAG?: InputMaybe<Scalars['String']['input']>;
  approval_no?: InputMaybe<Scalars['String']['input']>;
  approval_time?: InputMaybe<Scalars['String']['input']>;
  cancel?: InputMaybe<Scalars['String']['input']>;
  invNoList?: InputMaybe<Scalars['String']['input']>;
  result: Scalars['Int']['input'];
  result_date?: InputMaybe<Scalars['String']['input']>;
  sequence_no?: InputMaybe<Scalars['String']['input']>;
  sigma_businessid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totamount?: InputMaybe<Scalars['String']['input']>;
  tranxno: Scalars['String']['input'];
};

export type CreditCardPaymentUpdateResponse = {
  __typename?: 'CreditCardPaymentUpdateResponse';
  approvalNumber?: Maybe<Scalars['String']['output']>;
  transactionNumber?: Maybe<Scalars['String']['output']>;
};

export type CreditCardResponse = {
  __typename?: 'CreditCardResponse';
  creditCards: Array<CreditCard>;
};

export type CrisprPrice = {
  __typename?: 'CrisprPrice';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  listSubModels?: Maybe<Array<Maybe<ListSubModel>>>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
};

export type CrisprPriceResponse = {
  __typename?: 'CrisprPriceResponse';
  response?: Maybe<Array<Maybe<CrisprPrice>>>;
  serverError?: Maybe<ListError>;
};

export type CrisprSessionData = {
  __typename?: 'CrisprSessionData';
  aliquoting?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  lentiviralBackbone?: Maybe<Scalars['String']['output']>;
  listAliquotings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listLentiviralBackbones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listModification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPhysicalMaterials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSpecies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listStructure?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSubModels?: Maybe<Array<Maybe<ListSubModel>>>;
  listVectors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listViralTiters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listVolumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  material?: Maybe<Scalars['String']['output']>;
  mergedSession?: Maybe<Scalars['Boolean']['output']>;
  modification?: Maybe<Scalars['String']['output']>;
  modifiedSequence?: Maybe<Scalars['String']['output']>;
  modifiedTechnicalSequence?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  physicalMaterial?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['Boolean']['output']>;
  vector?: Maybe<Scalars['String']['output']>;
  viralTiter?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
};

export type CrisprSessionResponse = {
  __typename?: 'CrisprSessionResponse';
  data: Array<CrisprSessionData>;
};

export type CrisprSpecificatios = {
  __typename?: 'CrisprSpecificatios';
  aliquot?: Maybe<Array<Maybe<Aliquot>>>;
  amount?: Maybe<Array<Maybe<Amount>>>;
  companionProducts?: Maybe<Array<Maybe<CompanionProducts>>>;
  format?: Maybe<Array<Maybe<Format>>>;
  lentivirusBackbone?: Maybe<Array<Maybe<LentivirusBackbone>>>;
  modification?: Maybe<Array<Maybe<Modification>>>;
  physicalMaterial?: Maybe<Array<Maybe<PhysicalMaterial>>>;
  purification?: Maybe<Array<Maybe<Purification>>>;
  scale?: Maybe<Array<Maybe<Scale>>>;
  serverError?: Maybe<ServerError>;
  species?: Maybe<Array<Maybe<Species>>>;
  structure?: Maybe<Array<Maybe<Structure>>>;
  titer?: Maybe<Array<Maybe<Titer>>>;
  vector?: Maybe<Array<Maybe<Vector>>>;
  volume?: Maybe<Array<Maybe<Volume>>>;
};

export type CrisprgRnaPriceCall = {
  __typename?: 'CrisprgRnaPriceCall';
  result?: Maybe<Array<Maybe<CrisprgRnaPriceCallResponse>>>;
  serverError?: Maybe<ServerError>;
};

export type CrisprgRnaPriceCallInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  reagents?: InputMaybe<Array<InputMaybe<ReagentsInput>>>;
};

export type CrisprgRnaPriceCallResponse = {
  __typename?: 'CrisprgRnaPriceCallResponse';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  efficiencyScore?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  grnaId?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  moreInformation?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  recommendedStatus?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  specificityScore?: Maybe<Scalars['String']['output']>;
};

export type CrisprgrnaAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  reagents?: InputMaybe<Array<InputMaybe<ReagentsInput>>>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CrisprgrnaAddToCartResponse = {
  __typename?: 'CrisprgrnaAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type CustomBundleItem = {
  materialNumber: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CustomCrisprSessionInput = {
  aliquoting?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  lentiviralBackbone?: InputMaybe<Scalars['String']['input']>;
  listAliquotings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listAmount?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listLentiviralBackbones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listModification?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listPhysicalMaterials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listPurification?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listScale?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSpecies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listStructure?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSubModels?: InputMaybe<Array<InputMaybe<ListSubModelInput>>>;
  listVectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listViralTiters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listVolumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  modification?: InputMaybe<Scalars['String']['input']>;
  modifiedSequence?: InputMaybe<Scalars['String']['input']>;
  modifiedTechnicalSequence?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
  viralTiter?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCrisprTotalValidationResponse = {
  __typename?: 'CustomCrisprTotalValidationResponse';
  aliquoting?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  lentiviralBackbone?: Maybe<Scalars['String']['output']>;
  listAliquotings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listCompanionProducts?: Maybe<Array<Maybe<ListCompanionProducts>>>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listFormat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listLentiviralBackbones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listModification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPhysicalMaterials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSpecies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listStructure?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSubModels?: Maybe<Array<Maybe<ListSubModel>>>;
  listVectors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listViralTiters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listVolumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  material?: Maybe<Scalars['String']['output']>;
  modification?: Maybe<Scalars['String']['output']>;
  modifiedSequence?: Maybe<Scalars['String']['output']>;
  modifiedTechnicalSequence?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  physicalMaterial?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  species?: Maybe<Scalars['String']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
  vector?: Maybe<Scalars['String']['output']>;
  viralTiter?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
};

export type CustomOligoProductResponse = {
  __typename?: 'CustomOligoProductResponse';
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CustomPromotionalBundleInput = {
  bundleDescription: Scalars['String']['input'];
  bundleItems: Array<CustomBundleItem>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  billingAddress?: Maybe<CustomerInfoAddress>;
  contactInfo?: Maybe<CustomerInfoAddress>;
  customerPONumber?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerInfoAddress>;
};

export type CustomerInfoAddress = {
  __typename?: 'CustomerInfoAddress';
  attentionTo?: Maybe<Scalars['String']['output']>;
  buildingRoom?: Maybe<Scalars['String']['output']>;
  ccForOrderConfEmailIds?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  postOfficeBox?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
  street4?: Maybe<Scalars['String']['output']>;
  street5?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderInfo = {
  __typename?: 'CustomerOrderInfo';
  currency?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type CustomerSearchInput = {
  attentionTo?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  requestType: RequestType;
  salesOrderSource?: InputMaybe<SalesOrderSource>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  soldToCountry: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerServiceContactInfo = {
  __typename?: 'CustomerServiceContactInfo';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  salesOfficeCode?: Maybe<Scalars['String']['output']>;
};

export type CybersourcePayerAuthEnrollInput = {
  cardExpiryDate?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  deviceInformation: DeviceInformationInput;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  tokenizedCCNumber?: InputMaybe<Scalars['String']['input']>;
  transientCCToken?: InputMaybe<Scalars['String']['input']>;
};

export type CybersourcePayerAuthResultInput = {
  authenticationTransactionId: Scalars['String']['input'];
  cardType?: InputMaybe<Scalars['String']['input']>;
};

export type CybersourcePayerAuthSetupInput = {
  cardExpiryDate?: InputMaybe<Scalars['String']['input']>;
  cardName?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  maskedCardNumber?: InputMaybe<Scalars['String']['input']>;
  tokenizedCCNumber?: InputMaybe<Scalars['String']['input']>;
  transientCCToken?: InputMaybe<Scalars['String']['input']>;
};

export type Dealer = {
  __typename?: 'Dealer';
  address?: Maybe<Scalars['String']['output']>;
  approvalNeeded?: Maybe<Scalars['Boolean']['output']>;
  approverDealerLogonid?: Maybe<Scalars['String']['output']>;
  attentionTo?: Maybe<Scalars['String']['output']>;
  availableProducts?: Maybe<Scalars['String']['output']>;
  billToPartner?: Maybe<Scalars['String']['output']>;
  buildingRoom?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dealerReadableOrderId?: Maybe<Scalars['String']['output']>;
  dealerType?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPreferredDealer?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lineItemCount?: Maybe<Scalars['Int']['output']>;
  orderStatus?: Maybe<DealerOrderStatus>;
  organizationName?: Maybe<Scalars['String']['output']>;
  payerPartner?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Array<Scalars['String']['output']>>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  shipToPartner?: Maybe<Scalars['String']['output']>;
  soldToPartner?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
  street4?: Maybe<Scalars['String']['output']>;
  street5?: Maybe<Scalars['String']['output']>;
};

export type DealerApprover = {
  __typename?: 'DealerApprover';
  approvalAmount?: Maybe<Scalars['Float']['output']>;
  approvalProductType: Scalars['String']['output'];
  approvalTypeId: ApprovalTypeId;
  emailId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type DealerInput = {
  approvalNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  approverDealerLogonid?: InputMaybe<Scalars['String']['input']>;
  attentionTo?: InputMaybe<Scalars['String']['input']>;
  availableProducts?: InputMaybe<Scalars['String']['input']>;
  billToPartner?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dealerType?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPreferredDealer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  payerPartner?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  shipToPartner?: InputMaybe<Scalars['String']['input']>;
  soldToPartner?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street3?: InputMaybe<Scalars['String']['input']>;
  street4?: InputMaybe<Scalars['String']['input']>;
  street5?: InputMaybe<Scalars['String']['input']>;
};

export enum DealerOrderStatus {
  Approved = 'Approved',
  LocallyRejected = 'LocallyRejected',
  PartiallyApproved = 'PartiallyApproved',
  Pending = 'Pending',
  PendingFromApprover = 'PendingFromApprover',
  PendingReview = 'PendingReview',
  Rejected = 'Rejected'
}

export type DealerRequest = {
  __typename?: 'DealerRequest';
  address?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerRequestNumber: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderTotal: Scalars['String']['output'];
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
  status: DealerOrderStatus;
  userOrganizationName?: Maybe<Scalars['String']['output']>;
  userPO?: Maybe<Scalars['String']['output']>;
};

export type DealerRequestsSearchInput = {
  createdOn?: InputMaybe<Scalars['Date']['input']>;
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DealerOrderStatus>;
};

export type DealerTermsResponse = {
  __typename?: 'DealerTermsResponse';
  dealerId?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  tc?: Maybe<Scalars['String']['output']>;
};

export type DelegateApproverInput = {
  activate: Scalars['Boolean']['input'];
  delegateApproverId: Scalars['String']['input'];
  delegationApprovalExpirationDate?: InputMaybe<Scalars['String']['input']>;
  isDelegateEnabled: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteCoworkerGroupInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteMyNetworkGroupInput = {
  groupId: Scalars['String']['input'];
};

export type DeleteQuickOrderItemInput = {
  itemId: Scalars['String']['input'];
};

export type DeleteSaveForLaterInput = {
  cartType: Scalars['String']['input'];
  materialNumber: Scalars['String']['input'];
};

export type DependentCatalogQuantity = {
  __typename?: 'DependentCatalogQuantity';
  catalogId?: Maybe<Scalars['String']['output']>;
  increment?: Maybe<Scalars['Int']['output']>;
  productDetails: Product;
};

export type DeviceInformationInput = {
  httpAcceptContent?: InputMaybe<Scalars['String']['input']>;
  httpBrowserColorDepth?: InputMaybe<Scalars['String']['input']>;
  httpBrowserJavaEnabled?: InputMaybe<Scalars['String']['input']>;
  httpBrowserJavaScriptEnabled?: InputMaybe<Scalars['String']['input']>;
  httpBrowserLanguage?: InputMaybe<Scalars['String']['input']>;
  httpBrowserScreenHeight?: InputMaybe<Scalars['String']['input']>;
  httpBrowserScreenWidth?: InputMaybe<Scalars['String']['input']>;
  httpBrowserTimeDifference?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  userAgentBrowserValue?: InputMaybe<Scalars['String']['input']>;
};

export type DidYouMeanTerm = {
  __typename?: 'DidYouMeanTerm';
  count: Scalars['Int']['output'];
  term: Scalars['String']['output'];
};

export type DiscontinuedMaterialPricing = {
  __typename?: 'DiscontinuedMaterialPricing';
  alternateMaterials?: Maybe<Array<Maybe<Material>>>;
  displaySimilarProductLabel?: Maybe<Scalars['Boolean']['output']>;
  errorMsg: Scalars['String']['output'];
  hideReplacementProductLink?: Maybe<Scalars['Boolean']['output']>;
  hideTechnicalServiceLink?: Maybe<Scalars['Boolean']['output']>;
  paramList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replacementProducts?: Maybe<Array<Product>>;
};

export type DocLibInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  daterangeindays?: InputMaybe<Scalars['String']['input']>;
  lotnumber?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ordernumber?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perpage?: InputMaybe<Scalars['Int']['input']>;
  ponumber?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  sapOrderNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
};

export type DocLibPayload = {
  __typename?: 'DocLibPayload';
  count?: Maybe<Scalars['Int']['output']>;
  documents: Array<DocLibScheduleLine>;
  orderBy?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  perpage?: Maybe<Scalars['Int']['output']>;
  sapOrderNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sortColumn?: Maybe<Scalars['String']['output']>;
};

export type DocLibSavedDocsItemResponse = {
  __typename?: 'DocLibSavedDocsItemResponse';
  brand: Scalars['String']['output'];
  certificateOfAnalysis?: Maybe<Certificate>;
  certificateOfOrigin?: Maybe<Certificate>;
  images?: Maybe<Array<Maybe<CatalogImage>>>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
  sdsLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  specificationSheet?: Maybe<SpecificationSheet>;
};

export type DocLibSavedDocsResponse = {
  __typename?: 'DocLibSavedDocsResponse';
  count: Scalars['Int']['output'];
  documents: Array<DocLibSavedDocsItemResponse>;
  orderBy?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
  sortColumn?: Maybe<Scalars['String']['output']>;
};

export type DocLibScheduleLine = {
  __typename?: 'DocLibScheduleLine';
  brand?: Maybe<Scalars['String']['output']>;
  certificateOfAnalysis?: Maybe<Certificate>;
  certificateOfOrigin?: Maybe<Certificate>;
  createdDate: Scalars['Date']['output'];
  deliveryItemNumber?: Maybe<Scalars['String']['output']>;
  deliveryNumber?: Maybe<Scalars['String']['output']>;
  dsSalesDocument?: Maybe<Scalars['String']['output']>;
  dsSalesOrg?: Maybe<Scalars['String']['output']>;
  dsSystemId?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<CatalogImage>>>;
  itemNumber?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialDesc?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
  sdsLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  specificationSheet?: Maybe<SpecificationSheet>;
  status?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['String']['output']>;
  trackingDetails?: Maybe<DocLibTrackingDetail>;
};

export type DocLibTrackingDetail = {
  __typename?: 'DocLibTrackingDetail';
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type Document = {
  __typename?: 'Document';
  label: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentLink = {
  __typename?: 'DocumentLink';
  anchorTag: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type DocumentationContent = {
  __typename?: 'DocumentationContent';
  brand?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lotNumber?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Content>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DossierInfo = {
  __typename?: 'DossierInfo';
  dossierId: Scalars['String']['output'];
  dossierTitle: Scalars['String']['output'];
  materialNo: Scalars['String']['output'];
  skuId: Scalars['String']['output'];
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

export type DropDownListInput = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  modification?: InputMaybe<Scalars['String']['input']>;
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type DropshipAddress = {
  __typename?: 'DropshipAddress';
  addressId: Scalars['String']['output'];
  buildingRoom?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type DuplexDetails = {
  __typename?: 'DuplexDetails';
  additionalComments?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  antisenceBaseCount?: Maybe<Scalars['Int']['output']>;
  antisenceFiveMod?: Maybe<Scalars['String']['output']>;
  antisenceName?: Maybe<Scalars['String']['output']>;
  antisenceSequence?: Maybe<Scalars['String']['output']>;
  antisenceThreeMod?: Maybe<Scalars['String']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  autoGenerateOligo?: Maybe<Scalars['Boolean']['output']>;
  autoValidation?: Maybe<Scalars['String']['output']>;
  baseCount?: Maybe<Scalars['Float']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  customerAntisenseOverHang?: Maybe<Scalars['String']['output']>;
  customerOverhang?: Maybe<Scalars['String']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  name?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  orderItemId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  senseNameCheck?: Maybe<Scalars['Boolean']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  threeMod?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['String']['output']>;
};

export type EmailCartInput = {
  cartId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  savedCart?: InputMaybe<Scalars['Boolean']['input']>;
  sendMeCopy: Scalars['Boolean']['input'];
  toEmail: Array<Scalars['String']['input']>;
};

export type EmproveDoc = {
  __typename?: 'EmproveDoc';
  assetId: Scalars['String']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  displayType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  product: Scalars['String']['output'];
  productBrand: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum EmproveDomainStatus {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  New = 'NEW',
  Pending = 'PENDING'
}

export type EmproveDossierInfo = {
  dossierId?: InputMaybe<Scalars['String']['input']>;
  dossierMaterialNumber?: InputMaybe<Scalars['String']['input']>;
  dossierSubLength?: InputMaybe<Scalars['Int']['input']>;
  dossierSubType?: InputMaybe<Scalars['String']['input']>;
};

export type EmproveDossierItem = {
  __typename?: 'EmproveDossierItem';
  dossierId?: Maybe<Scalars['String']['output']>;
  dossierMaterialNumber?: Maybe<Scalars['String']['output']>;
  dossierSubLength?: Maybe<Scalars['Int']['output']>;
  dossierSubType?: Maybe<Scalars['String']['output']>;
};

export enum EmproveItemType {
  All = 'all',
  Single = 'single'
}

export enum EmproveSubscriptionType {
  All = 'ALL',
  Single = 'SINGLE'
}

export type EmproveSuiteDoc = {
  __typename?: 'EmproveSuiteDoc';
  date: Scalars['Date']['output'];
  fileInfo: EmproveDoc;
  materialDescription: Scalars['String']['output'];
  materialNumber: Scalars['String']['output'];
  materialType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EmproveSuiteDocsInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EmproveSuiteFilter>;
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type EmproveSuiteDocsResponse = {
  __typename?: 'EmproveSuiteDocsResponse';
  docsPerPage: Scalars['Int']['output'];
  emproveSuiteDocs: Array<EmproveSuiteDoc>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum EmproveSuiteFilter {
  Cedo1 = 'CEDO1',
  Cedo2 = 'CEDO2',
  Cedo3 = 'CEDO3',
  Cedo4 = 'CEDO4',
  Cedo5 = 'CEDO5',
  Edo = 'EDO'
}

export type EmproveUserData = {
  __typename?: 'EmproveUserData';
  activeSubscription: Scalars['Boolean']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  domainId: Scalars['String']['output'];
  domainStatus: Scalars['String']['output'];
  dossierItemInfo?: Maybe<Array<Maybe<DossierInfo>>>;
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

export type EmproveUserDataInput = {
  userDomain: Scalars['String']['input'];
};

export enum EncodingType {
  Base64 = 'base64',
  Binary = 'binary'
}

export enum ErrorCodes {
  AddressFirstNameEmpty = 'ADDRESS_FIRST_NAME_EMPTY',
  CatalogHttpError = 'CATALOG_HTTP_ERROR',
  ContactTelephoneEmpty = 'CONTACT_TELEPHONE_EMPTY',
  EcommerceHttpError = 'ECOMMERCE_HTTP_ERROR',
  HttpError = 'HTTP_ERROR',
  PaymentPoNumberEmpty = 'PAYMENT_PO_NUMBER_EMPTY',
  PaymentRequisitionNumberEmpty = 'PAYMENT_REQUISITION_NUMBER_EMPTY',
  PricingAndAvailabilityUnavailable = 'PRICING_AND_AVAILABILITY_UNAVAILABLE',
  SelectTermsAndConditionsOfSales = 'SELECT_TERMS_AND_CONDITIONS_OF_SALES',
  ShippingAttentionToEmpty = 'SHIPPING_ATTENTION_TO_EMPTY',
  UserDuplicateLogonId = 'USER_DUPLICATE_LOGON_ID',
  UserNotAuthorizedOrTokenExpired = 'USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED'
}

export type ErrorMsg = {
  __typename?: 'ErrorMsg';
  displaySimilarProductLabel?: Maybe<Scalars['Boolean']['output']>;
  hideReplacementProductLink?: Maybe<Scalars['Boolean']['output']>;
  hideTechnicalServiceLink?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  paramList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replacementProduct?: Maybe<Scalars['String']['output']>;
  sapMessages?: Maybe<Scalars['String']['output']>;
};

export type ErrorValues = {
  __typename?: 'ErrorValues';
  key?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['String']['output']>;
  validationType?: Maybe<Scalars['String']['output']>;
};

export type Faq = {
  __typename?: 'FAQ';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type FfCertificateProduct = {
  __typename?: 'FFCertificateProduct';
  aliases?: Maybe<Array<Maybe<FfMetadata>>>;
  attributes?: Maybe<Array<Maybe<FfMetadata>>>;
  brand?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<CatalogImage>;
  productName?: Maybe<Scalars['String']['output']>;
  productNameSuffix?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
};

export type FfMetadata = {
  __typename?: 'FFMetadata';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Facet = {
  __typename?: 'Facet';
  isCollapsed?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  multiSelect?: Maybe<Scalars['Boolean']['output']>;
  numToDisplay?: Maybe<Scalars['Int']['output']>;
  options: Array<FacetOptions>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type FacetInput = {
  key: Scalars['String']['input'];
  options: Array<Scalars['String']['input']>;
};

export type FacetOptions = {
  __typename?: 'FacetOptions';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type FacetSearchInput = {
  catalogType?: InputMaybe<CatalogType>;
  facetSet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetInput>>>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductSearchType>;
};

export type FacetSearchResponse = {
  __typename?: 'FacetSearchResponse';
  facets: Array<Facet>;
};

export type FacetSetInput = {
  facets: Array<Scalars['String']['input']>;
};

export type Fapiao = {
  __typename?: 'Fapiao';
  customerName: Scalars['String']['output'];
  expressCompany?: Maybe<Scalars['String']['output']>;
  expressNumber?: Maybe<Scalars['String']['output']>;
  fapiaoDate: Scalars['Date']['output'];
  fapiaoNumber: Scalars['String']['output'];
  fapiaoPdfUrl?: Maybe<Scalars['String']['output']>;
  fapiaoTotal: Scalars['Float']['output'];
  fapiaoType: Scalars['String']['output'];
  invoiceNumbers: Array<Scalars['String']['output']>;
  orderNumbers: Array<Scalars['String']['output']>;
  sendTime?: Maybe<Scalars['String']['output']>;
  taxNumber: Scalars['String']['output'];
};

export type FapiaoSearchInput = {
  fapiaoNo?: InputMaybe<Scalars['String']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  issueFrom: Scalars['String']['input'];
  issueTo: Scalars['String']['input'];
  orderNo?: InputMaybe<Scalars['String']['input']>;
};

export type FapiaoSearchPayload = {
  __typename?: 'FapiaoSearchPayload';
  fapiaoSearchList: Array<Fapiao>;
};

export type FastDuplexValidateInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  antisenceBaseCount?: InputMaybe<Scalars['Int']['input']>;
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  autoGenerateOligo?: InputMaybe<Scalars['Boolean']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  researcher?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  senseNameCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['String']['input']>;
};

export type FastDuplexValidateResponse = {
  __typename?: 'FastDuplexValidateResponse';
  antisenseBaseCount?: Maybe<Scalars['String']['output']>;
  antisenseGcContent?: Maybe<Scalars['String']['output']>;
  antisenseMeltingTemperature?: Maybe<Scalars['String']['output']>;
  antisenseMolecularWeight?: Maybe<Scalars['String']['output']>;
  antisensePrimerDimer?: Maybe<Scalars['String']['output']>;
  antisenseSecondaryStructure?: Maybe<Scalars['String']['output']>;
  baseCount?: Maybe<Scalars['String']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConcentration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listCterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listErrors?: Maybe<Array<Maybe<ListError>>>;
  listFiveMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listFormat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listInternalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMinimumYield?: Maybe<Scalars['Float']['output']>;
  listModification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listNterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOverhang?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurityLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listQuantitation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listThreeMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listTubes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meltingTemperature?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type Features = {
  __typename?: 'Features';
  featureId?: Maybe<Scalars['String']['output']>;
  labWaterSystemAttributes: Array<Maybe<LabWaterSystemAttribute>>;
  overAllRating?: Maybe<Scalars['String']['output']>;
};

export type FedexNotificationSubscriptionResponse = {
  __typename?: 'FedexNotificationSubscriptionResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FetchOrganizationResponse = {
  __typename?: 'FetchOrganizationResponse';
  organizationApprovers: Array<OrganizationApprover>;
};

export type FiltersResponse = {
  __typename?: 'FiltersResponse';
  fullRegistrationIndustry: Array<LabelValue>;
  fullRegistrationOrganizationType: Array<LabelValue>;
  fullRegistrationSafetyEquipment: Array<LabelValue>;
  fullRegistrationYourPosition: Array<LabelValue>;
  language: Array<LabelValue>;
  productEntryPreference: Array<LabelValue>;
  sdsLanguage: Array<LabelValue>;
};

export type FivePrime = {
  __typename?: 'FivePrime';
  KSPRA2015_FAM?: Maybe<Scalars['String']['output']>;
  KSPRA2015_HEX?: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordResponseType = {
  __typename?: 'ForgotPasswordResponseType';
  message?: Maybe<Scalars['String']['output']>;
};

export type ForgotPinInput = {
  contractNumber: Scalars['String']['input'];
  contractType: ContractType;
};

export type Form = {
  __typename?: 'Form';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Format = {
  __typename?: 'Format';
  dry?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type FullRegistrationInput = {
  billingAddress?: InputMaybe<AddressInput>;
  contactAddress?: InputMaybe<AddressInput>;
  officeAddress?: InputMaybe<AddressInput>;
  participantCommunicationSetting?: InputMaybe<InvoiceEmailInput>;
  participantComplianceInformation?: InputMaybe<UserParticipantComplianceInformationInput>;
  participantSitePreference?: InputMaybe<ParticipantSitePreferenceInput>;
  paymentAddress?: InputMaybe<AddressInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  userProfile?: InputMaybe<FullRegistrationUserProfileInput>;
};

export type FullRegistrationUserProfileInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GtinMaterialPdp = {
  __typename?: 'GTINMaterialPDP';
  gtinNumber?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
};

export type Gene = {
  __typename?: 'Gene';
  name?: Maybe<Scalars['String']['output']>;
  peerPapers: Papers;
  relatedCategories: Array<GeneCategory>;
  speciesReactivityFacets: Array<FacetOptions>;
  summary?: Maybe<Scalars['String']['output']>;
  swissProt: Array<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  synonyms: Array<Scalars['String']['output']>;
  variants: Array<GeneVariant>;
};


export type GenePeerPapersArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type GeneArrayInputParams = {
  facet?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
};

export type GeneArrayPlateList = {
  __typename?: 'GeneArrayPlateList';
  plateName?: Maybe<Scalars['String']['output']>;
  wells?: Maybe<Array<Maybe<GeneArrayWellData>>>;
};

export type GeneArrayPlateListInput = {
  plateName?: InputMaybe<Scalars['String']['input']>;
  wells?: InputMaybe<Array<InputMaybe<GeneArrayWellDataInput>>>;
};

export type GeneArrayPriceDetails = {
  __typename?: 'GeneArrayPriceDetails';
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type GeneArrayPriceDetailsInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type GeneArraySearchData = {
  __typename?: 'GeneArraySearchData';
  arrayName?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  isArrayModified?: Maybe<Scalars['Boolean']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  plates?: Maybe<Array<Maybe<GeneArrayPlateList>>>;
  pricing?: Maybe<GeneArrayPriceDetails>;
  serverError?: Maybe<ServerError>;
  species?: Maybe<Scalars['String']['output']>;
  speciesErrorMessage?: Maybe<Scalars['String']['output']>;
  stepNo?: Maybe<Scalars['Int']['output']>;
  wellType?: Maybe<Scalars['Int']['output']>;
  wellTypeErrorMessage?: Maybe<Scalars['String']['output']>;
};

export type GeneArraySearchInput = {
  arrayName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneArrayWellData = {
  __typename?: 'GeneArrayWellData';
  ampliconSize?: Maybe<Scalars['Int']['output']>;
  arrayName?: Maybe<Scalars['String']['output']>;
  arrayType?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['String']['output']>;
  exons?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  primerPairId?: Maybe<Scalars['String']['output']>;
  primerSeqFwd?: Maybe<Scalars['String']['output']>;
  primerSeqRev?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  refSeq?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  wellId?: Maybe<Scalars['Int']['output']>;
};

export type GeneArrayWellDataInput = {
  ampliconSize?: InputMaybe<Scalars['Int']['input']>;
  arrayName?: InputMaybe<Scalars['String']['input']>;
  arrayType?: InputMaybe<Scalars['String']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  exons?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  primerPairId?: InputMaybe<Scalars['String']['input']>;
  primerSeqFwd?: InputMaybe<Scalars['String']['input']>;
  primerSeqRev?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  refSeq?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  wellId?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneArrayWellSearchData = {
  __typename?: 'GeneArrayWellSearchData';
  count?: Maybe<Scalars['Int']['output']>;
  pricing?: Maybe<GeneArrayPriceDetails>;
  results?: Maybe<Array<Maybe<GeneArrayWellsResponse>>>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GeneArrayWellSearchInput = {
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<GeneArrayInputParams>;
  sequence?: InputMaybe<Scalars['String']['input']>;
};

export type GeneArrayWellsResponse = {
  __typename?: 'GeneArrayWellsResponse';
  ampliconSize?: Maybe<Scalars['String']['output']>;
  exons?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  primerPairId?: Maybe<Scalars['String']['output']>;
  primerSeqFwd?: Maybe<Scalars['String']['output']>;
  primerSeqRev?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  refSeq?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type GeneCategory = {
  __typename?: 'GeneCategory';
  name: Scalars['String']['output'];
  products: Array<Product>;
  type?: Maybe<Scalars['ID']['output']>;
};

export type GeneSearchInput = {
  facetSet?: InputMaybe<Array<FacetSetInput>>;
  facets?: InputMaybe<Array<FacetInput>>;
  pagination?: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<GeneSearchType>;
};

export type GeneSearchResults = SearchResults & {
  __typename?: 'GeneSearchResults';
  facets: Array<Facet>;
  items: Array<Gene>;
  metadata: SearchResultsMetadata;
};

export enum GeneSearchType {
  Gene = 'GENE',
  GeneDesc = 'GENE_DESC',
  GeneId = 'GENE_ID',
  GeneProduct = 'GENE_PRODUCT',
  GeneSymbol = 'GENE_SYMBOL',
  Refseq = 'REFSEQ',
  TrcNumber = 'TRC_NUMBER'
}

export type GeneVariant = {
  __typename?: 'GeneVariant';
  commonName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  geneClass?: Maybe<Scalars['String']['output']>;
  geneId: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  taxonId: Scalars['Int']['output'];
};

export type Get2c2pPaymentResponse = {
  __typename?: 'Get2c2pPaymentResponse';
  /** UUID format */
  orderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetAemDiscountedProductsInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  disp?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type GetBestSellerProductsByRegionInput = {
  disp?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type GetBestSellerProductsInput = {
  disp?: InputMaybe<AnalyticsDispType>;
  erpType?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type GetBuyItAgainProductsInput = {
  participantId: Scalars['String']['input'];
};

export type GetCartRecommendedProductsInput = {
  erpType?: InputMaybe<Scalars['String']['input']>;
  materialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetCompareSimilarItemsInput = {
  orgId?: InputMaybe<Scalars['String']['input']>;
  productInputs: Array<ProductInput>;
};

export type GetComplianceRegMappingListInput = {
  materialIds: Array<Scalars['String']['input']>;
};

export type GetCoworkerDetailsInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomerPricingForProductInput = {
  products: Array<GetPricingCustomerSpecificProductInput>;
};

export type GetCustomersAlsoViewedProductsInput = {
  brand: Scalars['String']['input'];
  erpType?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type GetDealerRequestsPayload = {
  __typename?: 'GetDealerRequestsPayload';
  count?: Maybe<Scalars['Int']['output']>;
  dealerOrderSearchModels: Array<DealerRequest>;
};

/** input for getting Chinese FapiaoList */
export type GetFapiaoListInput = {
  invoiceNumber: Scalars['String']['input'];
};

/** payload of Chinese FapiaoList */
export type GetFapiaoListPayload = {
  __typename?: 'GetFapiaoListPayload';
  fapiaoList: Array<Maybe<Fapiao>>;
  hasFapiaoList: Scalars['Boolean']['output'];
};

export type GetGtinMaterialsInput = {
  catalogType?: InputMaybe<CatalogType>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetGroupInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMaterialDetailInput = {
  catalogType?: InputMaybe<CatalogType>;
  filter?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
};

export type GetMaterialsDetailInput = {
  catalogType?: InputMaybe<CatalogType>;
  filter?: InputMaybe<Scalars['String']['input']>;
  materialNumbers: Array<Scalars['String']['input']>;
};

export type GetMilliqSqSessionInput = {
  guestParticipantId?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMynetworkInput = {
  group?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrderDetailInput = {
  checkDeliveryDate?: InputMaybe<Scalars['Boolean']['input']>;
  isAcknowledgement: Scalars['Boolean']['input'];
  orderIdentifier: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  sharedToken?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  sysId?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrderDetailPayload = {
  __typename?: 'GetOrderDetailPayload';
  order: OrderDetails;
};

export type GetPartnersInput = {
  billTos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payer?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestType?: InputMaybe<RequestType>;
  salesOrderSource?: InputMaybe<SalesOrderSource>;
  shipTos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  soldTos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetPricingCustomerSpecificProductInput = {
  dealerId: Scalars['String']['input'];
  items: Array<GetProductCustomerSpecificItemInput>;
};

export type GetPricingForMaterialInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  checkBuyNow?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  useSimulate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPricingForMultipleProductInput = {
  productDetails: Array<GetPricingForProductInput>;
};

export type GetPricingForProductInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  cachedPriceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  checkBuyNow?: InputMaybe<Scalars['Boolean']['input']>;
  checkForPb?: InputMaybe<Scalars['Boolean']['input']>;
  dealerId?: InputMaybe<Scalars['String']['input']>;
  displaySDS?: InputMaybe<Scalars['Boolean']['input']>;
  erp_type?: InputMaybe<Array<Scalars['String']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  productKey?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  useSimulate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPricingForPromotionalBundle = {
  promotionalBundleId: Scalars['String']['input'];
};

export type GetProductComparisonInput = {
  brand: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  erpType?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type GetProductCustomerSpecificItemInput = {
  brand: Scalars['String']['input'];
  listPrice: Scalars['Float']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type GetProductInput = {
  brandKey: Scalars['String']['input'];
  catalogType?: InputMaybe<CatalogType>;
  country?: InputMaybe<Scalars['String']['input']>;
  displayLanguage?: InputMaybe<Scalars['String']['input']>;
  isMarketplaceCatalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  productKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetProductNumberSearchSuggestions = {
  __typename?: 'GetProductNumberSearchSuggestions';
  count: Scalars['Int']['output'];
  suggestions: Array<ProductNumberSuggestions>;
};

export type GetProductNumberSearchSuggestionsInput = {
  overrideMarketplaceByTag?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type GetProductPapersInput = {
  productId: Scalars['String']['input'];
};

export type GetProductProtocolsAndArticlesInput = {
  term: Scalars['String']['input'];
};

export type GetPromotionalBundlesForProduct = {
  brand: Scalars['String']['input'];
  catalogType?: InputMaybe<CatalogType>;
  erp_type?: InputMaybe<Array<Scalars['String']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type GetQualityDocumentInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  documentType: QualityDocumentType;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type GetQualityDocumentSearchInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  documentType: QualityDocumentType;
  lotNumber: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GetQuickOrderRecommendedProductsInput = {
  erpType?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['String']['input'];
};

export type GetQuotesCountPayload = {
  __typename?: 'GetQuotesCountPayload';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GetRecentOrdersCountPayload = {
  __typename?: 'GetRecentOrdersCountPayload';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GetRecentlyViewedProductsInput = {
  brand: Scalars['String']['input'];
  dispType: AnalyticsDispType;
  erpType?: InputMaybe<Scalars['String']['input']>;
  productKey: Scalars['String']['input'];
};

export type GetRecommendedProductsAltInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  get?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
};

export type GetRecommendedProductsInput = {
  brand: Scalars['String']['input'];
  erpType?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type GetRequestersInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetRequestersPayload = {
  __typename?: 'GetRequestersPayload';
  approvalTypes: Array<ApprovalTypes>;
  count: Scalars['Int']['output'];
  perPage?: Maybe<Scalars['Int']['output']>;
  requesters?: Maybe<Array<Maybe<Requester>>>;
};

export type GetSearchSuggestionResponse = {
  __typename?: 'GetSearchSuggestionResponse';
  count: Scalars['Int']['output'];
  suggestions: GroupedSuggestions;
};

export type GetSearchSuggestionsInput = {
  catalogType?: InputMaybe<CatalogType>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  overrideMarketplaceByTag?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
  types?: InputMaybe<Array<SearchSuggestionType>>;
};

export type GetSharedListsInput = {
  orderby?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perpage?: InputMaybe<Scalars['Int']['input']>;
  sortcolumn?: InputMaybe<Scalars['String']['input']>;
};

export type GetShipmentTrackingRecommendedProductsInput = {
  materialNumbers: Array<Scalars['String']['input']>;
};

export type GetSrpRecommendedProductsInput = {
  erpType?: InputMaybe<Scalars['String']['input']>;
  searchKey: Scalars['String']['input'];
};

export type GetSubstanceByIdInput = {
  catalogType?: InputMaybe<CatalogType>;
  facets?: InputMaybe<Array<InputMaybe<FacetInput>>>;
  id: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
};

/** input for getting Chinese logitics info */
export type GetTrackingInfoInput = {
  shipperCode?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

/** payload of Chinese logitics info */
export type GetTrackingInfoPayload = {
  __typename?: 'GetTrackingInfoPayload';
  ebusinessID: Scalars['String']['output'];
  location: Scalars['String']['output'];
  logisticCode: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  shipperCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  stateEx: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  trace: Array<TrackingTracesDetail>;
};

export type GetUserByToken = {
  token: Scalars['String']['input'];
};

export type GqlUserInfoInput = {
  accessToken: Scalars['String']['input'];
  country: Scalars['String']['input'];
  guid: Scalars['String']['input'];
  isMarketplaceCartEnabled: Scalars['Boolean']['input'];
  isMarketplaceCatalogEnabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  store: Scalars['String']['input'];
};

export type GroupPartner = {
  allPartnerSelected: Scalars['Boolean']['input'];
  billTo?: InputMaybe<Array<InputMaybe<PartnerType>>>;
  payer?: InputMaybe<Array<InputMaybe<PartnerType>>>;
  shipTo?: InputMaybe<Array<InputMaybe<PartnerType>>>;
};

export type GroupedSuggestions = {
  __typename?: 'GroupedSuggestions';
  casNumber: Array<Suggestion>;
  materialNumber: Array<Suggestion>;
  pinyin: Array<Suggestion>;
  productName: Array<Suggestion>;
  productNumber: Array<Suggestion>;
  relatedCategories: Array<RelatedCategory>;
};

export type GuestUser = {
  __typename?: 'GuestUser';
  abilities: Abilities;
  metadata: UserMetadata;
  type: UserType;
  userErpType: UserErpType;
};

export type HolidayCalendar = {
  __typename?: 'HolidayCalendar';
  holidayData?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  plant?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type HwSelection = {
  __typename?: 'HwSelection';
  categoryDisplayName: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  categoryOptions: Array<CategoryOption>;
  categoryType?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
};

export type IncidentMessageInput = {
  openIncidentMessages: Array<InputMaybe<OpenIncidentMessage>>;
};

export type IncidentMessageResponse = {
  __typename?: 'IncidentMessageResponse';
  messageId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type InstrumentTypeItem = {
  __typename?: 'InstrumentTypeItem';
  instrumentType: Array<Scalars['String']['output']>;
  plateType: Scalars['String']['output'];
};

export type InventoryDetail = {
  __typename?: 'InventoryDetail';
  availableQuantity: Scalars['Int']['output'];
  batch: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  glbInvDesc: Scalars['String']['output'];
  glbInvStatus?: Maybe<Scalars['String']['output']>;
  plant: Scalars['String']['output'];
  shelfLifeDays: Scalars['Int']['output'];
};

export type InvitationPartner = {
  allPartnerSelected: Scalars['Boolean']['input'];
  billTo?: InputMaybe<Array<InputMaybe<PartnerType>>>;
  payer?: InputMaybe<Array<InputMaybe<PartnerType>>>;
  shipTo?: InputMaybe<Array<InputMaybe<PartnerType>>>;
  soldTo: Scalars['String']['input'];
};

export type InvitationRequestBody = {
  emailId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteToMyNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  inviterParticipantId?: InputMaybe<Scalars['String']['input']>;
  isExternalRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<InvitationPartner>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InviteCoworkerResponse = {
  __typename?: 'InviteCoworkerResponse';
  countryCode: Scalars['String']['output'];
  emailId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
  isNewInvitee: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type InviteEligibilityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  soldToCountry?: InputMaybe<Scalars['String']['input']>;
};

export type InviteRequesterInput = {
  approvalAmount?: InputMaybe<Scalars['Int']['input']>;
  approvalTypeId?: InputMaybe<ApprovalTypeId>;
  emailId: Scalars['String']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dbCrIND?: Maybe<Scalars['String']['output']>;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  invoiceDate: Scalars['Date']['output'];
  invoiceNo: Scalars['String']['output'];
  migratedInvoiceNo?: Maybe<Scalars['String']['output']>;
  migratedTaxInvoiceNo?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  taxInvoiceNo?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAutoSuggestResponse = {
  __typename?: 'InvoiceAutoSuggestResponse';
  companyVatInfoModelList: Array<VatInfoItem>;
  pageSize: Scalars['Int']['output'];
};

export type InvoiceEmailInput = {
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceInput = {
  transactionNumber: Scalars['String']['input'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Int']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNo: Scalars['Int']['output'];
  payer: Scalars['Int']['output'];
  soldTo: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  transactionNo: Scalars['String']['output'];
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  accountingDocumentNumber: Scalars['String']['output'];
  arrears?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  dbCrIndicator: Scalars['String']['output'];
  docType: Scalars['String']['output'];
  invoiceAmount: Scalars['String']['output'];
  invoiceDate: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  paymentTerms: Scalars['String']['output'];
  postingDate: Scalars['String']['output'];
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
};

export type InvoiceListInput = {
  fromdate?: InputMaybe<Scalars['String']['input']>;
  invoicenumber?: InputMaybe<Scalars['String']['input']>;
  ordernumber?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  ponumber?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  todate?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceListItem = {
  __typename?: 'InvoiceListItem';
  currency?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['Date']['output'];
  invoiceAmount?: Maybe<Scalars['Float']['output']>;
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  salesDocNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type InvoiceListResponse = {
  __typename?: 'InvoiceListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  fromDate?: Maybe<Scalars['String']['output']>;
  invoiceList: Array<InvoiceListItem>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['String']['output']>;
};

export type InvoicePdfInput = {
  invoiceNumber: Scalars['String']['input'];
  logisticId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  invoices: Array<InvoiceItem>;
};

export type ItemComplianceDocument = {
  __typename?: 'ItemComplianceDocument';
  classification?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  formLabel?: Maybe<Scalars['String']['output']>;
  legalRegulationID?: Maybe<Scalars['String']['output']>;
};

export type ItemToQuote = {
  ccForOrderConfEmailIds?: InputMaybe<Scalars['String']['input']>;
  configurationDetail?: InputMaybe<Scalars['JSONObject']['input']>;
  configurationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  productConfiguration?: InputMaybe<Scalars['JSONObject']['input']>;
  quantity: Scalars['Int']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CartItemType>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KicqStartAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  assays?: InputMaybe<Array<InputMaybe<AddToCartAssay>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type KicqStartAddToCartResponse = {
  __typename?: 'KicqStartAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type KicqStartGeneArraySessionInput = {
  arrayName?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  isArrayModified?: InputMaybe<Scalars['Boolean']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  plates?: InputMaybe<Array<InputMaybe<GeneArrayPlateListInput>>>;
  pricing?: InputMaybe<GeneArrayPriceDetailsInput>;
  species?: InputMaybe<Scalars['String']['input']>;
  speciesErrorMessage?: InputMaybe<Scalars['String']['input']>;
  stepNo?: InputMaybe<Scalars['Int']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
  wellTypeErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type KicqStartPrimerData = {
  __typename?: 'KicqStartPrimerData';
  currency?: Maybe<Scalars['String']['output']>;
  inputSearchTerm?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mergedSession?: Maybe<Scalars['Boolean']['output']>;
  results?: Maybe<Array<Maybe<SessionResponseResults>>>;
  resultsFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resultsPage?: Maybe<Scalars['Int']['output']>;
  resultsPerPage?: Maybe<Scalars['Int']['output']>;
  resultsSortById?: Maybe<Scalars['String']['output']>;
  resultsSortByOrder?: Maybe<Scalars['String']['output']>;
  stepNo?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type KicqStartPrimerSessionData = {
  __typename?: 'KicqStartPrimerSessionData';
  data: Array<KicqStartPrimerData>;
};

export type KicqStartPrimerSessionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  inputSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mergedSession?: InputMaybe<Scalars['Boolean']['input']>;
  results?: InputMaybe<Array<InputMaybe<SessionResults>>>;
  resultsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resultsPage?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  resultsSortById?: InputMaybe<Scalars['String']['input']>;
  resultsSortByOrder?: InputMaybe<Scalars['String']['input']>;
  stepNo?: InputMaybe<Scalars['Int']['input']>;
  totalResults?: InputMaybe<Scalars['Int']['input']>;
};

export type KicqStartPrimersAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  reagents?: InputMaybe<Array<InputMaybe<SessionResults>>>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type KicqStartPrimersAddToCartResponse = {
  __typename?: 'KicqStartPrimersAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type KitsItem = {
  __typename?: 'KitsItem';
  allAnalytesSelected?: Maybe<Scalars['String']['output']>;
  analytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assayType?: Maybe<Scalars['String']['output']>;
  customPremixSelection?: Maybe<Scalars['String']['output']>;
  customPremixedAvailable?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  decisionTableVer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  listAnalytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSampleType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSearchResultModelErrors?: Maybe<Array<Maybe<ListError>>>;
  listWarnings?: Maybe<Array<Maybe<ListWarning>>>;
  material?: Maybe<Scalars['String']['output']>;
  mutualAnalytesList?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  name?: Maybe<Scalars['String']['output']>;
  panelId?: Maybe<Scalars['String']['output']>;
  panelName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productTotal?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  requireSample?: Maybe<Scalars['String']['output']>;
  researchAreaOracle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  researchAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleType?: Maybe<Scalars['String']['output']>;
  selectedAnalytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  spaceSaver?: Maybe<Scalars['String']['output']>;
  spaceSaverSelection?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LabWaterAccessoriesConsumablesServices = {
  __typename?: 'LabWaterAccessoriesConsumablesServices';
  configuratorData: LabWaterAccessoriesConsumablesServicesConfiguratorData;
  hardwareSku: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  productDetails: Array<Maybe<Product>>;
  topFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LabWaterAccessoriesConsumablesServicesConfiguratorData = {
  __typename?: 'LabWaterAccessoriesConsumablesServicesConfiguratorData';
  accessories: Array<LabWaterAccessoriesConsumablesServicesData>;
  consumables: Array<LabWaterAccessoriesConsumablesServicesData>;
  services: Array<LabWaterAccessoriesConsumablesServicesData>;
};

export type LabWaterAccessoriesConsumablesServicesData = {
  __typename?: 'LabWaterAccessoriesConsumablesServicesData';
  catalogNo: Scalars['String']['output'];
  dependentCatalogQuantityList: Array<Maybe<DependentCatalogQuantity>>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  pairedWithCatalog?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MaterialPricing>;
  productDetails?: Maybe<Product>;
  productGroup: Scalars['String']['output'];
  productSubGroup: Scalars['String']['output'];
  requirement: Scalars['String']['output'];
  sbuCode: Scalars['Int']['output'];
  sfdcQuantity: Scalars['Int']['output'];
};

export type LabWaterAccessoriesConsumablesServicesInput = {
  hardwareSkus: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
};

export type LabWaterAccessoryConsumableAndService = {
  catalogDescription?: InputMaybe<Scalars['String']['input']>;
  catalogNo?: InputMaybe<Scalars['String']['input']>;
  catalogQuantity?: InputMaybe<Scalars['String']['input']>;
  customerPrice?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type LabWaterAccessoryConsumableAndServiceOut = {
  __typename?: 'LabWaterAccessoryConsumableAndServiceOut';
  catalogDescription?: Maybe<Scalars['String']['output']>;
  catalogNo?: Maybe<Scalars['String']['output']>;
  catalogQuantity?: Maybe<Scalars['String']['output']>;
};

export type LabWaterSelection = {
  __typename?: 'LabWaterSelection';
  hwSelections: Array<HwSelection>;
  productType: Scalars['String']['output'];
};

export type LabWaterSendEmailInput = {
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type LabWaterSession = {
  __typename?: 'LabWaterSession';
  accessories?: Maybe<Array<Maybe<LabWaterAccessoryConsumableAndServiceOut>>>;
  applications?: Maybe<Array<Maybe<LabWaterSessionApplications>>>;
  commentForLWSpecialist?: Maybe<Scalars['String']['output']>;
  consumables?: Maybe<Array<Maybe<LabWaterAccessoryConsumableAndServiceOut>>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dailyWaterUsage?: Maybe<Scalars['String']['output']>;
  feedWaterType?: Maybe<Scalars['String']['output']>;
  listApplication?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMaxwaterUsage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOutputWater?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listRegulated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSubapplication?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSystem?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listWarnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listfeed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  otherApplication?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  regulatedEnvironment?: Maybe<Scalars['String']['output']>;
  regulatoryRequirement?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<LabWaterAccessoryConsumableAndServiceOut>>>;
  subApplication?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  system?: Maybe<Scalars['String']['output']>;
  typeOfWater?: Maybe<Scalars['String']['output']>;
};

export type LabWaterSessionApplications = {
  __typename?: 'LabWaterSessionApplications';
  application?: Maybe<Scalars['String']['output']>;
  subApplications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LabWaterSessionApplicationsInput = {
  application?: InputMaybe<Scalars['String']['input']>;
  subApplications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LabWaterSessionInput = {
  guestParticipantId?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type LabWaterSubApplications = {
  __typename?: 'LabWaterSubApplications';
  application: Scalars['String']['output'];
  subApplications: Array<Scalars['String']['output']>;
};

export type LabWaterSystemAttribute = {
  __typename?: 'LabWaterSystemAttribute';
  labWaterSystemAttributeId?: Maybe<Scalars['String']['output']>;
  labWaterSystemAttributeValue?: Maybe<Scalars['String']['output']>;
};

export type LabWaterSystemFeatures = {
  __typename?: 'LabWaterSystemFeatures';
  features?: Maybe<Array<Maybe<Features>>>;
  productId?: Maybe<Scalars['String']['output']>;
};

export type LabWaterSystemFeaturesInput = {
  hardwareSkus: Array<InputMaybe<Scalars['String']['input']>>;
};

export type LabWaterValidation = {
  __typename?: 'LabWaterValidation';
  listDefaultApplicationPack?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listDefaultTank?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMaxwaterUsage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOutputWater?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listRegulated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSubapplication?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSystem?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSystems: Array<ListSystem>;
  listTopFeatures?: Maybe<Array<Maybe<ListTopFeatures>>>;
  listWarnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listfeed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LabWaterValidationInput = {
  application: Array<InputMaybe<Scalars['String']['input']>>;
  dailyWaterUsage?: InputMaybe<Scalars['String']['input']>;
  feedWaterType?: InputMaybe<Scalars['String']['input']>;
  regulatedEnvironment?: InputMaybe<Scalars['String']['input']>;
  regulatoryRequirement?: InputMaybe<Scalars['String']['input']>;
  subApplication: Array<InputMaybe<Scalars['String']['input']>>;
  typeOfWater?: InputMaybe<Scalars['String']['input']>;
};

export type LabelValue = {
  __typename?: 'LabelValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LentivirusBackbone = {
  __typename?: 'LentivirusBackbone';
  LV01?: Maybe<Scalars['String']['output']>;
  LV02?: Maybe<Scalars['String']['output']>;
  LV03?: Maybe<Scalars['String']['output']>;
  LV04?: Maybe<Scalars['String']['output']>;
  LV05?: Maybe<Scalars['String']['output']>;
  LV08?: Maybe<Scalars['String']['output']>;
  LV13?: Maybe<Scalars['String']['output']>;
  LV14?: Maybe<Scalars['String']['output']>;
  LV15?: Maybe<Scalars['String']['output']>;
  LV16?: Maybe<Scalars['String']['output']>;
  LV17?: Maybe<Scalars['String']['output']>;
};

export type ListCompanionProducts = {
  __typename?: 'ListCompanionProducts';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ListCompanionProductsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ListError = {
  __typename?: 'ListError';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ListErrorInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ListKits = {
  __typename?: 'ListKits';
  analytes: Array<Scalars['String']['output']>;
  appendToMaterialNumber?: Maybe<Scalars['String']['output']>;
  assayType: Scalars['String']['output'];
  assayTypeSelection?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customPremixedAvailable?: Maybe<Array<Scalars['String']['output']>>;
  listSampleType?: Maybe<Array<Scalars['String']['output']>>;
  listWarnings?: Maybe<Array<Maybe<ListWarning>>>;
  minimumAnalytesCount?: Maybe<Scalars['Int']['output']>;
  panelId: Scalars['String']['output'];
  panelName: Scalars['String']['output'];
  plateType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productTotal?: Maybe<Scalars['String']['output']>;
  requireSample?: Maybe<Scalars['Boolean']['output']>;
  researchAreas: Array<Maybe<Scalars['String']['output']>>;
  sampleType?: Maybe<Scalars['String']['output']>;
  spaceSaver?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListSpecies = {
  __typename?: 'ListSpecies';
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ListSubModel = {
  __typename?: 'ListSubModel';
  baseCount?: Maybe<Scalars['Int']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCurrentForm?: Maybe<Scalars['Boolean']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listSubModelErrors?: Maybe<Array<Maybe<ListError>>>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
};

export type ListSubModelInput = {
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCurrentForm?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  listSubModelErrors?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
};

export type ListSystem = {
  __typename?: 'ListSystem';
  features: Array<Scalars['String']['output']>;
  mostRecommended?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productDetails: Array<Product>;
  productNumber: Scalars['String']['output'];
};

export type ListTopFeatures = {
  __typename?: 'ListTopFeatures';
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productId?: Maybe<Scalars['String']['output']>;
};

export type ListWarning = {
  __typename?: 'ListWarning';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ListWarningInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LockableValue = {
  __typename?: 'LockableValue';
  locked?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LoggedInUser = {
  __typename?: 'LoggedInUser';
  abilities: Abilities;
  adminPartnersInfo?: Maybe<Array<Maybe<AdminPartnersInfo>>>;
  allowBlankStreet: Scalars['Boolean']['output'];
  approvalConsolidationModel?: Maybe<ApprovalConsolidationModel>;
  b2bChannelInformation: B2BChannelInformation;
  billingAddress?: Maybe<UserAddress>;
  cartPreferences: CartPreferences;
  contactAddress: UserAddress;
  createdDate?: Maybe<Scalars['Date']['output']>;
  dropshipAddress?: Maybe<Array<DropshipAddress>>;
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteCoWorkerAffiliation?: Maybe<Scalars['Boolean']['output']>;
  isDarmstadtUser: Scalars['Boolean']['output'];
  isDirectCustomer?: Maybe<Scalars['String']['output']>;
  isPreferredDealerCustomer?: Maybe<Scalars['Boolean']['output']>;
  isPriceUpliftCustomer?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  logonId: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  metadata: UserMetadata;
  mobilePhone: Scalars['String']['output'];
  mobileVerifiedFlag?: Maybe<Scalars['Boolean']['output']>;
  multiCountryPartnersInfo: Array<Maybe<MultiCountryPartnersInfo>>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  participantCommunicationSetting: UserParticipantCommunicationSetting;
  participantComplianceInformation: UserParticipantComplianceInformation;
  participantShippingPreference: UserParticipantShippingPreference;
  participantSitePreference: UserParticipantSitePreference;
  paymentMethods: UserPaymentMethods;
  profileType: ProfileType;
  roleNames: Scalars['String']['output'];
  roles: Roles;
  savedRegistration?: Maybe<UserSavedRegistration>;
  shippingAddress?: Maybe<UserAddress>;
  soldToNumber: Scalars['String']['output'];
  soldToPartners: Array<SoldToPartner>;
  telephone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: UserType;
  useShipToAddressForAllOrders: Scalars['Boolean']['output'];
  userAdLink?: Maybe<Scalars['String']['output']>;
  userErpType: UserErpType;
  userStatus?: Maybe<UserStatus>;
  weChatId?: Maybe<Scalars['String']['output']>;
};

export type Login = {
  __typename?: 'Login';
  accessToken?: Maybe<Scalars['String']['output']>;
  isGeneralTermsConditionDateExpired?: Maybe<Scalars['Boolean']['output']>;
  isSiteUseTermsDateExpired?: Maybe<Scalars['Boolean']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  piiDataConsentAcceptance?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<LoginUserRes>;
};

export type LoginUserRes = {
  __typename?: 'LoginUserRes';
  userAdLink?: Maybe<Scalars['String']['output']>;
};

export type MPortalLinks = {
  __typename?: 'MPortalLinks';
  invoice?: Maybe<Scalars['String']['output']>;
  orderTracking?: Maybe<Scalars['String']['output']>;
};

export type MappedProductComponent = {
  __typename?: 'MappedProductComponent';
  analyte?: Maybe<Array<Maybe<ProductComponent>>>;
  bulletin?: Maybe<Array<Maybe<ProductComponent>>>;
  kitOnly?: Maybe<Array<Maybe<ProductComponent>>>;
  kitSoldSeparate?: Maybe<Array<Maybe<ProductComponent>>>;
  solvent?: Maybe<Array<Maybe<ProductComponent>>>;
};

export type MarketplaceInvoice = {
  __typename?: 'MarketplaceInvoice';
  id?: Maybe<Scalars['String']['output']>;
  marketplaceOrderId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketplaceShippingPreference = {
  __typename?: 'MarketplaceShippingPreference';
  participantId?: Maybe<Scalars['String']['output']>;
  participantShippingMethods: Array<ParticipantShippingMethods>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
};

export type Material = {
  __typename?: 'Material';
  brand: Brand;
  casNumber?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySellerName?: Maybe<Scalars['String']['output']>;
  empiricalFormula?: Maybe<Scalars['String']['output']>;
  erpType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  freeFreight?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image: CatalogImage;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  linearFormula?: Maybe<Scalars['String']['output']>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  marketplaceSellerId?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  packageQuantity?: Maybe<Scalars['String']['output']>;
  packageSize?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  productKey?: Maybe<Scalars['String']['output']>;
  promotionalMessage?: Maybe<PromotionalMessage>;
  shipsToday?: Maybe<Scalars['Boolean']['output']>;
  substanceKey?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorNumber?: Maybe<Scalars['String']['output']>;
};

export type MaterialAvailabilities = {
  __typename?: 'MaterialAvailabilities';
  materialAvailabilities?: Maybe<ValidMaterialAvailability>;
};

export type MaterialAvailability = {
  __typename?: 'MaterialAvailability';
  availabilityOverwriteMessage?: Maybe<AvailabilityOverwriteMessage>;
  contactInfo?: Maybe<MaterialContactInfo>;
  date?: Maybe<Scalars['Date']['output']>;
  displayFromLink?: Maybe<Scalars['Boolean']['output']>;
  displayInquireLink?: Maybe<Scalars['Boolean']['output']>;
  key: MaterialAvailabilityKey;
  messageType?: Maybe<Scalars['String']['output']>;
  plantLoc?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  supplementaryMessage?: Maybe<MaterialSupplementaryMessage>;
};

export enum MaterialAvailabilityKey {
  ApoNoStock = 'APO_NO_STOCK',
  AvailabilityUnknown = 'AVAILABILITY_UNKNOWN',
  AvailableToShipOn = 'AVAILABLE_TO_SHIP_ON',
  AvailableToShipOnDynamic = 'AVAILABLE_TO_SHIP_ON_DYNAMIC',
  AvailableToShipOnDynamicWithoutPlantLoc = 'AVAILABLE_TO_SHIP_ON_DYNAMIC_WITHOUT_PLANT_LOC',
  CheckCartForAvailability = 'CHECK_CART_FOR_AVAILABILITY',
  ContactForAvailability = 'CONTACT_FOR_AVAILABILITY',
  EstimatedDeliveryOn = 'ESTIMATED_DELIVERY_ON',
  EstimatedToShipOn = 'ESTIMATED_TO_SHIP_ON',
  EstimatedToShipOnDynamic = 'ESTIMATED_TO_SHIP_ON_DYNAMIC',
  EstimatedToShipOnDynamicWithoutPlantLoc = 'ESTIMATED_TO_SHIP_ON_DYNAMIC_WITHOUT_PLANT_LOC',
  FulfilmentDeliveryDelayed = 'FULFILMENT_DELIVERY_DELAYED',
  InquireForPriceAndAvailability = 'INQUIRE_FOR_PRICE_AND_AVAILABILITY',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OnlyFewLeftInStock = 'ONLY_FEW_LEFT_IN_STOCK',
  OutOfStockKey = 'OUT_OF_STOCK_KEY',
  PricingAndAvailabilityUnavailable = 'PRICING_AND_AVAILABILITY_UNAVAILABLE',
  ShippingDateNotAvailable = 'SHIPPING_DATE_NOT_AVAILABLE',
  ShipsOnFrom = 'SHIPS_ON_FROM',
  TppAvailabilityMessage = 'TPP_AVAILABILITY_MESSAGE',
  UnknownAvailability = 'UNKNOWN_AVAILABILITY',
  UntilSuppliesRunOut = 'UNTIL_SUPPLIES_RUN_OUT'
}

export type MaterialContactInfo = {
  __typename?: 'MaterialContactInfo';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
};

export type MaterialOfferInput = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

/**
 * Pricing for a single material, which will return one pricing object and
 * optionally one object describing the material's replacement materials, if it
 * is discontinued.
 */
export type MaterialPricing = {
  __typename?: 'MaterialPricing';
  discontinuedPricingInfo?: Maybe<DiscontinuedMaterialPricing>;
  materialPricing?: Maybe<ValidMaterialPricing>;
};

export type MaterialSupplementaryMessage = {
  __typename?: 'MaterialSupplementaryMessage';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
};

export type MaterialsDirectComments = {
  __typename?: 'MaterialsDirectComments';
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type MaterialsDirectCsvInput = {
  contactParty?: InputMaybe<Scalars['String']['input']>;
  customerMaterialNo?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  lotNo?: InputMaybe<Scalars['String']['input']>;
  orderNo?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  poNo?: InputMaybe<Scalars['String']['input']>;
  shipToList?: InputMaybe<Array<Scalars['String']['input']>>;
  soldTo: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MaterialsDirectCsvResponse = {
  __typename?: 'MaterialsDirectCsvResponse';
  contentType: Scalars['String']['output'];
  fileContent: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type MaterialsDirectDeliveryDetails = {
  __typename?: 'MaterialsDirectDeliveryDetails';
  lotNo: Scalars['String']['output'];
  qty: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['String']['output']>;
};

export type MaterialsDirectInput = {
  contactParty?: InputMaybe<Scalars['String']['input']>;
  customerMaterialNo?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  lotNo?: InputMaybe<Scalars['String']['input']>;
  orderNo?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  poNo?: InputMaybe<Scalars['String']['input']>;
  shipToList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  soldTo: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MaterialsDirectItems = {
  __typename?: 'MaterialsDirectItems';
  comments?: Maybe<Array<Maybe<MaterialsDirectComments>>>;
  contactParty?: Maybe<Scalars['String']['output']>;
  custReqDate?: Maybe<Scalars['String']['output']>;
  customerMaterialNo?: Maybe<Scalars['String']['output']>;
  estShipDate?: Maybe<Scalars['String']['output']>;
  hasDelivery: Scalars['Boolean']['output'];
  itemNo: Scalars['String']['output'];
  lotNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  materialNo?: Maybe<Scalars['String']['output']>;
  orderNo: Scalars['String']['output'];
  orderedDate: Scalars['String']['output'];
  poNo?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<MaterialsDirectQuantity>;
  shipToDesc?: Maybe<Scalars['String']['output']>;
  shipToNo?: Maybe<Scalars['String']['output']>;
  soldToDesc?: Maybe<Scalars['String']['output']>;
  soldToNo: Scalars['String']['output'];
  status?: Maybe<MaterialsDirectStatusType>;
};

export type MaterialsDirectOrderCommentsInput = {
  itemNo: Scalars['String']['input'];
  orderNo: Scalars['String']['input'];
};

export type MaterialsDirectOrderCommentsResponse = {
  __typename?: 'MaterialsDirectOrderCommentsResponse';
  comments?: Maybe<Array<Maybe<MaterialsDirectComments>>>;
  itemNo: Scalars['String']['output'];
  orderNo: Scalars['String']['output'];
};

export type MaterialsDirectOrderDeliveryInput = {
  itemNo: Scalars['String']['input'];
  orderNo: Scalars['String']['input'];
};

export type MaterialsDirectOrderDeliveryResponse = {
  __typename?: 'MaterialsDirectOrderDeliveryResponse';
  deliveries?: Maybe<Array<Maybe<MaterialsDirectDeliveryDetails>>>;
  itemNo: Scalars['String']['output'];
  orderNo: Scalars['String']['output'];
};

export type MaterialsDirectPackingSlipInput = {
  deliveryNo: Scalars['String']['input'];
  docType: Scalars['String']['input'];
  itemNo: Scalars['String']['input'];
  orderNo: Scalars['String']['input'];
};

export type MaterialsDirectPackingSlipResponse = {
  __typename?: 'MaterialsDirectPackingSlipResponse';
  contentType: Scalars['String']['output'];
  fileContent: Scalars['String']['output'];
};

export type MaterialsDirectPage = {
  __typename?: 'MaterialsDirectPage';
  number: Scalars['Float']['output'];
  size: Scalars['Float']['output'];
  totalElements: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type MaterialsDirectQuantity = {
  __typename?: 'MaterialsDirectQuantity';
  confirmed?: Maybe<Scalars['String']['output']>;
  ordered?: Maybe<Scalars['String']['output']>;
};

export type MaterialsDirectResponse = {
  __typename?: 'MaterialsDirectResponse';
  items?: Maybe<Array<Maybe<MaterialsDirectItems>>>;
  page: MaterialsDirectPage;
};

export enum MaterialsDirectStatusType {
  Cancelled = 'CANCELLED',
  Invoiced = 'INVOICED',
  Open = 'OPEN',
  Shipped = 'SHIPPED'
}

export enum MessagePriority {
  Critical = 'Critical',
  Emergency = 'Emergency',
  Informational = 'Informational',
  Promotional = 'Promotional',
  Standard = 'Standard'
}

export type MililiQsku = {
  __typename?: 'MililiQSKU';
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MilliQSqBasePriceData = {
  __typename?: 'MilliQSqBasePriceData';
  price?: Maybe<MilliQSqPriceData>;
};

export type MilliQSqBasePriceInput = {
  productList: Array<GetPricingForProductInput>;
};

export type MilliQSqData = {
  __typename?: 'MilliQSqData';
  configuratorData?: Maybe<MilliQSqProductData>;
};

export type MilliQSqInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  numberOfModules?: InputMaybe<Scalars['Int']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  pwTankQuantity?: InputMaybe<Scalars['String']['input']>;
  systemType: Scalars['String']['input'];
  upwModuleQuantity?: InputMaybe<Scalars['String']['input']>;
};

export type MilliQSqPriceData = {
  __typename?: 'MilliQSqPriceData';
  errorMsg?: Maybe<Scalars['String']['output']>;
  priceData?: Maybe<Array<Maybe<BasePrice>>>;
};

export type MilliQSqProductData = {
  __typename?: 'MilliQSqProductData';
  accessories: Array<MilliQSqProductDataItem>;
  powerCodes: Array<MilliQSqProductDataItem>;
  services: Array<MilliQSqProductDataItem>;
};

export type MilliQSqProductDataItem = {
  __typename?: 'MilliQSqProductDataItem';
  catalogNo: Scalars['String']['output'];
  fixedQuantity: Scalars['Int']['output'];
  imageId: Scalars['String']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<MaterialPricing>;
  productDetails?: Maybe<Product>;
  productGroup: Scalars['String']['output'];
  requirement: Scalars['String']['output'];
};

export type MilliplexAssayModel = {
  assays?: InputMaybe<Array<InputMaybe<AssayModel>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  requestDate?: InputMaybe<Scalars['String']['input']>;
  responseDate?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termCount?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexDealerConfirmationEmailInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexInput = {
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  instrumentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kits?: InputMaybe<Array<InputMaybe<MilliplexKitInput>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  panelIdList?: InputMaybe<Array<InputMaybe<MilliplexKitPanelListInput>>>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  previouslyViewedPanelId?: InputMaybe<Scalars['String']['input']>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedAssayType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexKitAndSampleTypeInput = {
  allAnalytesSelected?: InputMaybe<Scalars['String']['input']>;
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appendToMaterialNumber?: InputMaybe<Scalars['String']['input']>;
  assayTypeSelection?: InputMaybe<Scalars['String']['input']>;
  customPremixSelection?: InputMaybe<Scalars['String']['input']>;
  instrumentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  priceCallRequired?: InputMaybe<Scalars['Boolean']['input']>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampleType?: InputMaybe<Scalars['String']['input']>;
  selectedAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceSaverSelection?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexKitAndSampleTypeResponse = {
  __typename?: 'MilliplexKitAndSampleTypeResponse';
  instrumentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listAnalytes?: Maybe<Array<Scalars['String']['output']>>;
  listSampleType?: Maybe<Array<Scalars['String']['output']>>;
  listWarnings?: Maybe<Array<ListWarning>>;
  panelId: Scalars['String']['output'];
  priceData?: Maybe<MilliplexKitPrice>;
  sampleType?: Maybe<Scalars['String']['output']>;
  selectedAnalytes?: Maybe<Array<Scalars['String']['output']>>;
  selectedInstrumentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MilliplexKitAndSampleTypeResponsePriceDataArgs = {
  input?: InputMaybe<MilliplexKitAndSampleTypeInput>;
};

export type MilliplexKitInput = {
  material?: InputMaybe<Scalars['String']['input']>;
  panelId: Scalars['String']['input'];
  panelName: Scalars['String']['input'];
};

export type MilliplexKitPanelListInput = {
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customPremixSelection?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexKitPrice = {
  __typename?: 'MilliplexKitPrice';
  currency?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
};

export type MilliplexKitsResponse = {
  __typename?: 'MilliplexKitsResponse';
  count: Scalars['Int']['output'];
  listKits: Array<ListKits>;
};


export type MilliplexKitsResponseListKitsArgs = {
  input?: InputMaybe<MilliplexInput>;
};

export type MilliplexPriceResponse = {
  __typename?: 'MilliplexPriceResponse';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  listMilliplexAssayModel?: Maybe<Array<Maybe<MilliplexSearchResponse>>>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type MilliplexProductInput = {
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexResponse = {
  __typename?: 'MilliplexResponse';
  listAnalytes: Array<Maybe<Scalars['String']['output']>>;
  listResearchAreas: Array<Maybe<Scalars['String']['output']>>;
  listSpecies: Array<ListSpecies>;
};

export type MilliplexSearchCriteriaResponse = {
  __typename?: 'MilliplexSearchCriteriaResponse';
  assayTypePlateType: Array<AssayTypeItem>;
  listSpeciesResearchAreas: Array<SpeciesItem>;
  plateInstrumentType: Array<InstrumentTypeItem>;
};

export type MilliplexSearchResponse = {
  __typename?: 'MilliplexSearchResponse';
  assays?: Maybe<Array<Maybe<KitsItem>>>;
  count?: Maybe<Scalars['Int']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  termCount?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MilliplexSessionData = {
  __typename?: 'MilliplexSessionData';
  Bovineplatform?: Maybe<Scalars['String']['output']>;
  analytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  checkedProductIdList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  listMilliplexAssayModel?: Maybe<Array<Maybe<MilliplexSearchResponse>>>;
  mapMates?: Maybe<Scalars['String']['output']>;
  milliplexcheckedProductIdList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  researchAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleVolume?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sensitivity?: Maybe<Scalars['String']['output']>;
  singlePlexPlatform?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  species?: Maybe<Scalars['String']['output']>;
};

export type MilliplexSessionDataResponse = {
  __typename?: 'MilliplexSessionDataResponse';
  milliplexData?: Maybe<Array<Maybe<MilliplexSessionData>>>;
};

export type MilliqSqSendEmailInput = {
  milliqSqSession?: InputMaybe<MilliqSqSessionInput>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type MilliqSqSessionInput = {
  accessories?: InputMaybe<Array<InputMaybe<AccessoryServicePowerCordItemInput>>>;
  commentForMSQSpecialist?: InputMaybe<Scalars['String']['input']>;
  finalFilter?: InputMaybe<WaterSystemInput>;
  milliQWaterSystem?: InputMaybe<MilliQWaterSystemInput>;
  milliQWaterSystemSkuList?: InputMaybe<Array<MilliQWaterSystemSkuItemInput>>;
  powerCord?: InputMaybe<AccessoryServicePowerCordItemInput>;
  preFilter?: InputMaybe<WaterSystemInput>;
  pureWaterSystem?: InputMaybe<WaterSystemInput>;
  selectedPlacement?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<InputMaybe<AccessoryServicePowerCordItemInput>>>;
  ultraPureWaterSystem?: InputMaybe<WaterSystemInput>;
  upwCartridge?: InputMaybe<WaterSystemInput>;
};

export type MilliqSqSessionResponse = {
  __typename?: 'MilliqSqSessionResponse';
  accessories?: Maybe<Array<Maybe<AccessoryServicePowerCordItem>>>;
  commentForMSQSpecialist?: Maybe<Scalars['String']['output']>;
  finalFilter?: Maybe<WaterSystem>;
  powerCord?: Maybe<AccessoryServicePowerCordItem>;
  preFilter?: Maybe<WaterSystem>;
  pureWaterSystem?: Maybe<WaterSystem>;
  selectedPlacement?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<AccessoryServicePowerCordItem>>>;
  ultraPureWaterSystem?: Maybe<WaterSystem>;
  upwCartridge?: Maybe<WaterSystem>;
};

export type Modification = {
  __typename?: 'Modification';
  no?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
  yes?: Maybe<Scalars['String']['output']>;
};

export type Modifications = {
  __typename?: 'Modifications';
  category: Array<Category>;
  modificationType: Scalars['String']['output'];
  modificationTypeDisplayName: Scalars['String']['output'];
};

export type ModificationsAndSpecificationsResponse = {
  __typename?: 'ModificationsAndSpecificationsResponse';
  errorType?: Maybe<Scalars['String']['output']>;
  modifications: Array<Modifications>;
  specifications: Array<Specifications>;
};

export type MpayChargePaymentInput = {
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  encryptedCVV?: InputMaybe<Scalars['String']['input']>;
  merchantSiteUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type MpayInvoiceInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type MpayInvoicePaymentUpdateInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MpayInvoicePaymentUpdateResponse = {
  __typename?: 'MpayInvoicePaymentUpdateResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type MpayInvoiceResponse = {
  __typename?: 'MpayInvoiceResponse';
  invoiceLineItems?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  openInvoiceHeaderInfoModel?: Maybe<OpenInvoiceHeaderInfoModel>;
};

export type MpayPaymentHistoryResponse = {
  __typename?: 'MpayPaymentHistoryResponse';
  invoiceTransactionHistoryList: Array<PaymentHistoryLineItem>;
};

export type MpayPaymentUrlInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  submittedInvoiceList: Array<MpayPaymentUrlListItem>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type MpayPaymentUrlListItem = {
  comments?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dbCrIndicator?: InputMaybe<Scalars['String']['input']>;
  docType?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  openInvoiceAccountingDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<Scalars['String']['input']>;
  postingDate?: InputMaybe<Scalars['String']['input']>;
  residualAmount?: InputMaybe<Scalars['Float']['input']>;
  sapOrderNumber?: InputMaybe<Scalars['String']['input']>;
  withHoldingTax?: InputMaybe<Scalars['Float']['input']>;
};

export type MpayPaymentUrlResponse = {
  __typename?: 'MpayPaymentUrlResponse';
  transactionId: Scalars['String']['output'];
};

export type MpayProcessPaymentResponse = {
  __typename?: 'MpayProcessPaymentResponse';
  status: Scalars['String']['output'];
};

export type MultiCountryPartnersInfo = {
  __typename?: 'MultiCountryPartnersInfo';
  billTo: Scalars['String']['output'];
  country: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  payer: Scalars['String']['output'];
  pricingAvailabilitySetting: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salesOrg?: Maybe<Scalars['String']['output']>;
  shipTo: Scalars['String']['output'];
  soldTo: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
};

export type MultipleProductInput = {
  catalogType?: InputMaybe<CatalogType>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  productInputs: Array<ProductInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** dummy value required for schema merging */
  _?: Maybe<Scalars['String']['output']>;
  acceptInviteApprover: DealerApprover;
  acceptInviteRequester: Requester;
  acceptSpotOffer?: Maybe<OfferAcceptanceResponse>;
  addCoworkerToGroup?: Maybe<Scalars['Boolean']['output']>;
  addItemToSavedDocs: Scalars['Boolean']['output'];
  addItemsToCart: Cart;
  addItemsToSavedCart: Scalars['Boolean']['output'];
  addQuickOrderItems: Array<QuickOrderItemsResponse>;
  addSaveForLaterItem: Scalars['Boolean']['output'];
  addSoftwareItemsToSavedCart: NewSavedCart;
  addToProtocolsLibrary: Scalars['Boolean']['output'];
  addUserActivity?: Maybe<UserActivityEntry>;
  approveDealerOrder: CartSubmission;
  biTubePriceCall?: Maybe<Array<BitubeTotalValidationResponse>>;
  bitubeTotalValidation?: Maybe<Array<BitubeTotalValidationResponse>>;
  cancelCart: Scalars['Boolean']['output'];
  cancelMarketplaceOrder: Scalars['Boolean']['output'];
  cancelSapOrder: Scalars['Boolean']['output'];
  cancelSubscription?: Maybe<Scalars['Boolean']['output']>;
  changePassword?: Maybe<Scalars['Boolean']['output']>;
  chatWithAssistant: AssistantResponse;
  clearRedisCache?: Maybe<Scalars['String']['output']>;
  clearSession?: Maybe<Login>;
  clearSharedListItems: Scalars['Boolean']['output'];
  confAddToMiniCart?: Maybe<ConfiguratorMiniCartResponse>;
  confMilliplexAddToCart?: Maybe<ConfiguratorMilliplexAddToCartResponse>;
  confPlatesAddToCart?: Maybe<ConfiguratorMiniCartResponse>;
  confirmAffiliation?: Maybe<Scalars['Boolean']['output']>;
  confirmOrderQuote: Scalars['Boolean']['output'];
  consolidateOrdersIntoActiveCart: Scalars['Boolean']['output'];
  convertQuoteToOrder?: Maybe<Scalars['String']['output']>;
  copyPasteTube?: Maybe<UploadCopyPasteResponse>;
  createApproverCart: Scalars['Boolean']['output'];
  createContractCart: Scalars['Boolean']['output'];
  createCustomPromotionalBundle?: Maybe<Scalars['Boolean']['output']>;
  createDealerCart: Scalars['Boolean']['output'];
  createElavonSessionToken: Scalars['String']['output'];
  createGroup?: Maybe<CreateGroupResponse>;
  createMpayTransaction: MpayPaymentUrlResponse;
  createNewCart: NewCart;
  createOrderEvaluation: Scalars['Boolean']['output'];
  createParallelSavedCart: Scalars['Boolean']['output'];
  createSharedList: SharedListDetail;
  createSharedListItems: Scalars['Boolean']['output'];
  crisprgRnaPriceCall?: Maybe<CrisprgRnaPriceCall>;
  crisprgrnaAddToCart?: Maybe<CrisprgrnaAddToCartResponse>;
  customCrisprSaveToSession: SessionResponse;
  customCrisprTotalValidation?: Maybe<Array<CustomCrisprTotalValidationResponse>>;
  cybersourcePayerAuthEnroll: PayerAuthResponse;
  cybersourcePayerAuthResult: PayerAuthResponse;
  cybersourcePayerAuthSetup: PayerAuthResponse;
  deactivateCoworker?: Maybe<Scalars['Boolean']['output']>;
  delegateApprover?: Maybe<Scalars['Boolean']['output']>;
  deleteCartItem: Scalars['Boolean']['output'];
  deleteConsolidationOrders: Scalars['Boolean']['output'];
  deleteCoworkerGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteDropshipAddress?: Maybe<Scalars['Boolean']['output']>;
  deleteMyNetworkGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteNewCart: Scalars['Boolean']['output'];
  deleteNewCartItem: Scalars['Boolean']['output'];
  deleteParallelCart: Scalars['Boolean']['output'];
  deleteQuickOrderItem?: Maybe<Scalars['Boolean']['output']>;
  deleteQuickOrderItems?: Maybe<Scalars['Boolean']['output']>;
  deleteRequester: Scalars['Boolean']['output'];
  deleteSaveForLaterItem: Scalars['Boolean']['output'];
  deleteSavedCart: Scalars['Boolean']['output'];
  deleteSavedOrder: Scalars['Boolean']['output'];
  deleteSharedList: Scalars['Boolean']['output'];
  deleteSharedListInvitations: Scalars['Boolean']['output'];
  deleteSharedListMembers: Scalars['Boolean']['output'];
  deleteUserPushSubscription: Array<UserPushSubscription>;
  duplexSpecificationValidation?: Maybe<WellSpecificationResponse>;
  emailCart: Scalars['Boolean']['output'];
  emailVerification?: Maybe<Scalars['Boolean']['output']>;
  enrollPayuPayerAuth: PayuAuthResponse;
  fastduplexRuleValidation: FastDuplexValidateResponse;
  fedexNotificationSubscription: FedexNotificationSubscriptionResponse;
  fetchOauthSessionExchange?: Maybe<Oauth2SessionResponse>;
  fetchPayuPayerAuthResult: PayuAuthResponse;
  fetchPosPaymentData: PosPaymentDataResponse;
  fetchThirdPartyToken?: Maybe<ThirdPartyTokenResponse>;
  fetchWechatInfo?: Maybe<WechatInfo>;
  fileUploadDuplexPlate?: Maybe<UploadCopyPasteResponse>;
  fileUploadPlate?: Maybe<UploadCopyPasteResponse>;
  forgotPassword?: Maybe<ForgotPasswordResponseType>;
  fullRegistration?: Maybe<Scalars['Boolean']['output']>;
  generateQuote: QuoteGenerationResponse;
  genomicsFileUpload?: Maybe<UploadFileResponse>;
  getForgotPin: Scalars['Boolean']['output'];
  getMobileSecurityCode?: Maybe<Scalars['Boolean']['output']>;
  getNewCheckoutAddresses: NewCheckoutAddressesResponse;
  getNewCheckoutPaymentMethods: NewCheckoutPaymentMethodsResponse;
  getNewCheckoutPreview: NewCheckoutPreviewResponse;
  inviteRequester: Scalars['Boolean']['output'];
  kicqStartAddToCart?: Maybe<KicqStartAddToCartResponse>;
  kicqStartGeneArraySaveToSession?: Maybe<SaveToSessionResponse>;
  kicqStartPrimerSaveToSession?: Maybe<SaveToSessionResponse>;
  kicqStartPrimersAddToCart?: Maybe<KicqStartPrimersAddToCartResponse>;
  login?: Maybe<Login>;
  logout?: Maybe<Login>;
  mergeEmailCart: Scalars['Boolean']['output'];
  mergeSavedCart: Scalars['Boolean']['output'];
  milliplexPriceCall?: Maybe<MilliplexPriceResponse>;
  milliplexSaveToSession?: Maybe<SessionResponse>;
  milliplexTotalValidation?: Maybe<Array<Maybe<MilliplexTotalValidationResponse>>>;
  ngsoCopyPaste?: Maybe<UploadCopyPasteResponse>;
  ngsoFileUpload?: Maybe<UploadFileResponse>;
  openIncidentMessage?: Maybe<Array<Maybe<IncidentMessageResponse>>>;
  orfAddToCart?: Maybe<OrfAddToCartResponse>;
  orfPriceCall?: Maybe<OrfPriceCall>;
  patchCartItem: Cart;
  patchCcLegalTerms?: Maybe<Scalars['Boolean']['output']>;
  patchNewCart: NewCart;
  patchNewCartItem: NewCartItem;
  patchQuoteWithUpdateData: Scalars['Boolean']['output'];
  patchSitePreference?: Maybe<Scalars['Boolean']['output']>;
  plateSessionField: Scalars['Boolean']['output'];
  plateSpecificationValidation?: Maybe<WellSpecificationResponse>;
  plateTotalValidation?: Maybe<PlatesDataResponse>;
  postBigQueryData?: Maybe<Scalars['Boolean']['output']>;
  processMpayPayment: MpayProcessPaymentResponse;
  readyToShipNotification: ReadyToShipNotificationResponse;
  registerBlanketPo: RegisteredBlanketPoResponse;
  registerNewUser?: Maybe<RegisteredUserProfile>;
  rejectDealerRequests: Scalars['Boolean']['output'];
  removeCoworker?: Maybe<Scalars['Boolean']['output']>;
  removeFromProtocolsLibrary: Scalars['Boolean']['output'];
  removeItemFromSavedDocs: Scalars['Boolean']['output'];
  removeOmsAccess?: Maybe<Scalars['Boolean']['output']>;
  removeSharedListItem: Scalars['Boolean']['output'];
  reorderCart: Scalars['Boolean']['output'];
  requestApproval: Scalars['Boolean']['output'];
  requestQuoteForMilliplex?: Maybe<Scalars['Boolean']['output']>;
  resendEmail?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  resubmitOrderQuote: Scalars['Boolean']['output'];
  ruleValidateDuplex: RuleValidateResponsePlate;
  ruleValidateFields: RuleValidateResponse;
  ruleValidatePlate: RuleValidateResponsePlate;
  sangerAddToCart?: Maybe<SangerCrisprAddToCartResponse>;
  sangerPriceCall?: Maybe<SangerCrisprPriceCall>;
  saveCart: NewSavedCart;
  saveLabWaterSession?: Maybe<Scalars['Boolean']['output']>;
  saveMilliqSqSession?: Maybe<Scalars['Boolean']['output']>;
  saveOrder: SavedOrderResponse;
  saveUserPushSubscription: Array<UserPushSubscription>;
  selectDealer: Scalars['Boolean']['output'];
  semiConfAddToMiniCart?: Maybe<SemiConfiguratorMiniCartResponse>;
  semiConfSaveToSession?: Maybe<SaveToSessionResponse>;
  sendInvite?: Maybe<Scalars['Boolean']['output']>;
  sendLabWaterEmail?: Maybe<Scalars['Boolean']['output']>;
  sendMilliplexDealerConfirmationEmail?: Maybe<Scalars['Boolean']['output']>;
  sendMilliqSqEmail?: Maybe<Scalars['Boolean']['output']>;
  sendOrderShippedNotification: SendNotificationResult;
  sessionFields: SessionResponse;
  shareOrderDetails: Scalars['Boolean']['output'];
  shareProductDetails?: Maybe<Scalars['Boolean']['output']>;
  shareQuoteDetails: Scalars['Boolean']['output'];
  shrnaAddToCart?: Maybe<ShrnaAddToCartResponse>;
  shrnaPriceCall?: Maybe<ShrnaPriceCall>;
  sirnaAddToCart?: Maybe<SirnaAddToCartResponse>;
  skipSubscription: Scalars['Boolean']['output'];
  submitCart: CartSubmission;
  submitContactSeller?: Maybe<ContactSellerResponse>;
  submitFullRegistration?: Maybe<SubmitFullRegistrationResponse>;
  submitNewCheckout: NewCheckoutSubmitResponse;
  tubePriceCall?: Maybe<TubePriceCall>;
  tubeTotalValidation?: Maybe<Array<TubeTotalValidationResponse>>;
  updateCart: Cart;
  updateCartItems: Cart;
  updateCoworkerGroup?: Maybe<CreateGroupResponse>;
  updateCoworkerRoles?: Maybe<Scalars['Boolean']['output']>;
  updateCreditCardPaymentInfo: CreditCardPaymentUpdateResponse;
  updateDefaultAddress?: Maybe<Scalars['Boolean']['output']>;
  updateDeliveryDate: Scalars['Boolean']['output'];
  updateDirectShipment: Scalars['Boolean']['output'];
  updateEmproveUserTermsConditions?: Maybe<Scalars['Boolean']['output']>;
  updateMembersDoneAddingToSharedList: Scalars['Boolean']['output'];
  updateMobile?: Maybe<Scalars['Boolean']['output']>;
  updateMpayInvoicePaymentInfo: MpayInvoicePaymentUpdateResponse;
  updateNewCart: NewCart;
  updateNewCartItem: NewCartItem;
  updateOrdersPendingApproval: Scalars['Boolean']['output'];
  updatePinnedAddresses?: Maybe<Scalars['Boolean']['output']>;
  updateProfileNameContactInfo?: Maybe<Scalars['Boolean']['output']>;
  updateQuickOrderItem?: Maybe<Scalars['Boolean']['output']>;
  updateRequester: Scalars['Boolean']['output'];
  updateSavedCart: Scalars['Boolean']['output'];
  updateSavedCartItems: Scalars['Boolean']['output'];
  updateSharedList: Scalars['Boolean']['output'];
  updateSharedListItem: Scalars['Boolean']['output'];
  updateTermCondition?: Maybe<TermConditionResponse>;
  updateTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  updateUserProfile?: Maybe<Scalars['Boolean']['output']>;
  updateUserSitePreference?: Maybe<Scalars['Boolean']['output']>;
  updateWIMSAccessCode?: Maybe<UpdateWimsAccessCodeResponse>;
  uploadBusinessLicense: Scalars['Boolean']['output'];
  uploadCopyPasteText?: Maybe<UploadCopyPasteResponse>;
  uploadDuplexCopyPasteText?: Maybe<UploadCopyPasteResponse>;
  uploadTubesFromFile?: Maybe<UploadFileResponse>;
  upsertDropshipAddress?: Maybe<PartnerAccount>;
  validateMobileSecurityCode?: Maybe<ValidateMobileSecurityCodeResponse>;
  validatePlateShipping?: Maybe<PlateShippingResponse>;
  verifyEmail?: Maybe<VerificationResponse>;
  wechatBind?: Maybe<WechatLoginResponse>;
  wechatLogin?: Maybe<WechatLoginResponse>;
  wechatUnbind?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptInviteApproverArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptInviteRequesterArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptSpotOfferArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationAddCoworkerToGroupArgs = {
  input: AddCoworkerToGroupInput;
};


export type MutationAddItemToSavedDocsArgs = {
  input: SavedDocumentInput;
};


export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


export type MutationAddItemsToSavedCartArgs = {
  input: AddSavedCartItemsInput;
};


export type MutationAddQuickOrderItemsArgs = {
  input: AddQuickOrderItemsInput;
};


export type MutationAddSaveForLaterItemArgs = {
  input: SaveForLaterInput;
};


export type MutationAddSoftwareItemsToSavedCartArgs = {
  input: AddSoftwareSavedCartItemsInput;
};


export type MutationAddToProtocolsLibraryArgs = {
  input: AddToProtocolsLibraryInput;
};


export type MutationAddUserActivityArgs = {
  input?: InputMaybe<UserActivityInput>;
};


export type MutationApproveDealerOrderArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationBiTubePriceCallArgs = {
  product: ConfiguratorProductInput;
};


export type MutationBitubeTotalValidationArgs = {
  input: Array<InputMaybe<SessionInput>>;
  product: ConfiguratorProductInput;
};


export type MutationCancelCartArgs = {
  action: CartRequestAction;
};


export type MutationCancelMarketplaceOrderArgs = {
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelSapOrderArgs = {
  comment: Scalars['String']['input'];
  orderItemLineNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sapOrderNumber: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  cancelReason: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationChatWithAssistantArgs = {
  input: AssistantInput;
};


export type MutationClearRedisCacheArgs = {
  key: Scalars['String']['input'];
};


export type MutationClearSharedListItemsArgs = {
  listId: Scalars['ID']['input'];
};


export type MutationConfAddToMiniCartArgs = {
  input?: InputMaybe<ConfiguratorAddToMiniCartInput>;
};


export type MutationConfMilliplexAddToCartArgs = {
  input: Array<InputMaybe<ConfiguratorMilliplexAddToCartInput>>;
  productInput: MilliplexProductInput;
};


export type MutationConfPlatesAddToCartArgs = {
  input: Array<InputMaybe<PlatesTotalValidationInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationConfirmAffiliationArgs = {
  data: ConfirmAffiliationInput;
  isSwitchAccount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationConfirmOrderQuoteArgs = {
  input: ConfirmOrderQuoteInput;
};


export type MutationConsolidateOrdersIntoActiveCartArgs = {
  input: ConsolidateOrdersIntoActiveCartInput;
};


export type MutationConvertQuoteToOrderArgs = {
  input: QuoteConversionInput;
  isCsr?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCopyPasteTubeArgs = {
  input: Scalars['String']['input'];
  isDForm?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
};


export type MutationCreateApproverCartArgs = {
  input: CreateApproverCartInput;
};


export type MutationCreateContractCartArgs = {
  input: CreateContractCartInput;
};


export type MutationCreateCustomPromotionalBundleArgs = {
  input: CustomPromotionalBundleInput;
};


export type MutationCreateDealerCartArgs = {
  orderNumber: Scalars['ID']['input'];
};


export type MutationCreateGroupArgs = {
  input?: InputMaybe<CreateGroupInput>;
};


export type MutationCreateMpayTransactionArgs = {
  input: MpayPaymentUrlInput;
};


export type MutationCreateNewCartArgs = {
  input: NewCartInput;
};


export type MutationCreateOrderEvaluationArgs = {
  orderEvaluation: OrderEvaluationInput;
};


export type MutationCreateParallelSavedCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationCreateSharedListArgs = {
  input: CreateSharedListInput;
};


export type MutationCreateSharedListItemsArgs = {
  listIds: Array<Scalars['ID']['input']>;
  listItems: Array<SharedListItemInput>;
};


export type MutationCrisprgRnaPriceCallArgs = {
  input?: InputMaybe<CrisprgRnaPriceCallInput>;
};


export type MutationCrisprgrnaAddToCartArgs = {
  input?: InputMaybe<CrisprgrnaAddToCartInput>;
};


export type MutationCustomCrisprSaveToSessionArgs = {
  input?: InputMaybe<Array<InputMaybe<CustomCrisprSessionInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationCustomCrisprTotalValidationArgs = {
  input: Array<InputMaybe<CustomCrisprSessionInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationCybersourcePayerAuthEnrollArgs = {
  input: CybersourcePayerAuthEnrollInput;
};


export type MutationCybersourcePayerAuthResultArgs = {
  input: CybersourcePayerAuthResultInput;
};


export type MutationCybersourcePayerAuthSetupArgs = {
  input: CybersourcePayerAuthSetupInput;
};


export type MutationDeactivateCoworkerArgs = {
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDelegateApproverArgs = {
  input: DelegateApproverInput;
};


export type MutationDeleteCartItemArgs = {
  action: CartRequestAction;
  cartId: Scalars['ID']['input'];
  cartItemId: Scalars['ID']['input'];
};


export type MutationDeleteConsolidationOrdersArgs = {
  input: ConsolidateOrdersIntoActiveCartInput;
};


export type MutationDeleteCoworkerGroupArgs = {
  input: DeleteCoworkerGroupInput;
};


export type MutationDeleteDropshipAddressArgs = {
  addressId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteMyNetworkGroupArgs = {
  input: DeleteMyNetworkGroupInput;
};


export type MutationDeleteNewCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationDeleteNewCartItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['Int']['input'];
};


export type MutationDeleteParallelCartArgs = {
  action: CartRequestAction;
};


export type MutationDeleteQuickOrderItemArgs = {
  input: DeleteQuickOrderItemInput;
};


export type MutationDeleteRequesterArgs = {
  input: UpdateOrDeleteRequesterInput;
};


export type MutationDeleteSaveForLaterItemArgs = {
  input: DeleteSaveForLaterInput;
};


export type MutationDeleteSavedCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationDeleteSavedOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDeleteSharedListArgs = {
  listId: Scalars['ID']['input'];
};


export type MutationDeleteSharedListInvitationsArgs = {
  invitations: Array<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
};


export type MutationDeleteSharedListMembersArgs = {
  listId: Scalars['ID']['input'];
  members: Array<Scalars['ID']['input']>;
};


export type MutationDeleteUserPushSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationDuplexSpecificationValidationArgs = {
  input?: InputMaybe<Array<InputMaybe<BiTubeWellListInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationEmailCartArgs = {
  input: EmailCartInput;
};


export type MutationEnrollPayuPayerAuthArgs = {
  input: PayuPayerAuthEnrollInput;
};


export type MutationFastduplexRuleValidationArgs = {
  input: FastDuplexValidateInput;
  productInput: ConfiguratorProductInput;
};


export type MutationFedexNotificationSubscriptionArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};


export type MutationFetchOauthSessionExchangeArgs = {
  extAccessToken: Scalars['String']['input'];
};


export type MutationFetchPayuPayerAuthResultArgs = {
  input: PayuPayerAuthResultInput;
};


export type MutationFetchPosPaymentDataArgs = {
  input: PosPaymentDataInput;
};


export type MutationFetchThirdPartyTokenArgs = {
  data: ThirdPartyTokenInput;
};


export type MutationFetchWechatInfoArgs = {
  code: Scalars['String']['input'];
};


export type MutationFileUploadDuplexPlateArgs = {
  input?: InputMaybe<Array<InputMaybe<PlateListInput>>>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFileUploadPlateArgs = {
  autogenerateAntisense?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<Array<InputMaybe<PlateListInput>>>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFullRegistrationArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  data: FullRegistrationInput;
};


export type MutationGenerateQuoteArgs = {
  addressInfo?: InputMaybe<AddressInfoType>;
  applyQuoteDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ItemToQuote>;
};


export type MutationGenomicsFileUploadArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
  productInput: ConfiguratorProductInput;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGetForgotPinArgs = {
  input: ForgotPinInput;
};


export type MutationGetMobileSecurityCodeArgs = {
  mobile: Scalars['String']['input'];
  sceneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetNewCheckoutAddressesArgs = {
  input?: InputMaybe<NewCheckoutPartnerContextInput>;
};


export type MutationGetNewCheckoutPaymentMethodsArgs = {
  input?: InputMaybe<NewCheckoutPaymentMethodsRequestInput>;
};


export type MutationGetNewCheckoutPreviewArgs = {
  input: NewCheckoutPreviewRequest;
};


export type MutationInviteRequesterArgs = {
  input: InviteRequesterInput;
};


export type MutationKicqStartAddToCartArgs = {
  input?: InputMaybe<KicqStartAddToCartInput>;
};


export type MutationKicqStartGeneArraySaveToSessionArgs = {
  input?: InputMaybe<KicqStartGeneArraySessionInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationKicqStartPrimerSaveToSessionArgs = {
  input?: InputMaybe<KicqStartPrimerSessionInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationKicqStartPrimersAddToCartArgs = {
  input?: InputMaybe<KicqStartPrimersAddToCartInput>;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  userName: Scalars['String']['input'];
};


export type MutationMergeEmailCartArgs = {
  emailCartId: Scalars['ID']['input'];
};


export type MutationMergeSavedCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationMilliplexPriceCallArgs = {
  input?: InputMaybe<Array<InputMaybe<MilliplexDataInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationMilliplexSaveToSessionArgs = {
  input?: InputMaybe<Array<InputMaybe<MilliplexDataInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationMilliplexTotalValidationArgs = {
  input?: InputMaybe<Array<InputMaybe<MilliplexDataInput>>>;
  productInput?: InputMaybe<ConfiguratorProductInput>;
};


export type MutationNgsoCopyPasteArgs = {
  input: Scalars['String']['input'];
  isDForm?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
};


export type MutationNgsoFileUploadArgs = {
  input: Scalars['String']['input'];
  isDForm?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOpenIncidentMessageArgs = {
  input?: InputMaybe<IncidentMessageInput>;
};


export type MutationOrfAddToCartArgs = {
  input?: InputMaybe<OrfAddToCartInput>;
};


export type MutationOrfPriceCallArgs = {
  input?: InputMaybe<OrfPriceCallInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationPatchCartItemArgs = {
  action: CartRequestAction;
  input: PatchCartItemInput;
};


export type MutationPatchCcLegalTermsArgs = {
  data?: InputMaybe<Array<PatchCcLegalTermsInput>>;
};


export type MutationPatchNewCartArgs = {
  cartId: Scalars['ID']['input'];
  input: PatchNewCartInput;
};


export type MutationPatchNewCartItemArgs = {
  cartId: Scalars['ID']['input'];
  input: PatchNewCartItemInput;
  itemId: Scalars['Int']['input'];
};


export type MutationPatchQuoteWithUpdateDataArgs = {
  input: PatchQuoteInput;
};


export type MutationPatchSitePreferenceArgs = {
  data?: InputMaybe<Array<PatchSitePreferenceInput>>;
};


export type MutationPlateSessionFieldArgs = {
  input: Array<InputMaybe<PlatesInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationPlateSpecificationValidationArgs = {
  input?: InputMaybe<Array<InputMaybe<WelllistInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationPlateTotalValidationArgs = {
  input: Array<InputMaybe<PlatesInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationPostBigQueryDataArgs = {
  input: BigDataQueryInput;
};


export type MutationProcessMpayPaymentArgs = {
  input: MpayChargePaymentInput;
};


export type MutationReadyToShipNotificationArgs = {
  params: ReadyToShipNotificationInput;
};


export type MutationRegisterBlanketPoArgs = {
  input: RegisterBlanketPoInput;
};


export type MutationRegisterNewUserArgs = {
  newUser: NewUser;
};


export type MutationRejectDealerRequestsArgs = {
  input: RejectDealerRequestsInput;
};


export type MutationRemoveCoworkerArgs = {
  coworkerId: Scalars['String']['input'];
};


export type MutationRemoveFromProtocolsLibraryArgs = {
  input: AddToProtocolsLibraryInput;
};


export type MutationRemoveItemFromSavedDocsArgs = {
  input: SavedDocumentInput;
};


export type MutationRemoveOmsAccessArgs = {
  input?: InputMaybe<OmsGuestInput>;
};


export type MutationRemoveSharedListItemArgs = {
  itemId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};


export type MutationReorderCartArgs = {
  input: UpdateCartInput;
};


export type MutationRequestApprovalArgs = {
  input: RequestApprovalInput;
};


export type MutationRequestQuoteForMilliplexArgs = {
  input: RequestQuoteForMilliplexInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResubmitOrderQuoteArgs = {
  input: ConfirmOrderQuoteInput;
};


export type MutationRuleValidateDuplexArgs = {
  input: RuleValidateDuplexInput;
  productInput: ConfiguratorProductInput;
};


export type MutationRuleValidateFieldsArgs = {
  input: RuleValidateInput;
  productInput: ConfiguratorProductInput;
};


export type MutationRuleValidatePlateArgs = {
  input: RuleValidatePlateInput;
  productInput: ConfiguratorProductInput;
};


export type MutationSangerAddToCartArgs = {
  input?: InputMaybe<SangerCrisprAddToCartInput>;
};


export type MutationSangerPriceCallArgs = {
  input?: InputMaybe<SangerCrisprPriceCallInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationSaveCartArgs = {
  input: SaveCartInput;
};


export type MutationSaveLabWaterSessionArgs = {
  input?: InputMaybe<SaveLabWaterSessionInput>;
};


export type MutationSaveMilliqSqSessionArgs = {
  input?: InputMaybe<SaveMilliqSqSessionInput>;
};


export type MutationSaveOrderArgs = {
  input: SaveOrderInput;
};


export type MutationSaveUserPushSubscriptionArgs = {
  input: PushSubscriptionInput;
};


export type MutationSelectDealerArgs = {
  input: SelectedDealerInput;
};


export type MutationSemiConfAddToMiniCartArgs = {
  input?: InputMaybe<SemiConfiguratorAddToMiniCartInput>;
};


export type MutationSemiConfSaveToSessionArgs = {
  input?: InputMaybe<SemiConfSaveToSessionInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationSendInviteArgs = {
  input: InvitationRequestBody;
};


export type MutationSendLabWaterEmailArgs = {
  input?: InputMaybe<LabWaterSendEmailInput>;
};


export type MutationSendMilliplexDealerConfirmationEmailArgs = {
  input?: InputMaybe<MilliplexDealerConfirmationEmailInput>;
};


export type MutationSendMilliqSqEmailArgs = {
  input?: InputMaybe<MilliqSqSendEmailInput>;
};


export type MutationSendOrderShippedNotificationArgs = {
  notification: OrderShippedNotification;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationSessionFieldsArgs = {
  input?: InputMaybe<Array<InputMaybe<SessionInput>>>;
  productInput: ConfiguratorProductInput;
};


export type MutationShareOrderDetailsArgs = {
  orderNumber: Scalars['String']['input'];
  sharedLink: Scalars['String']['input'];
  toEmails: Array<Scalars['String']['input']>;
};


export type MutationShareProductDetailsArgs = {
  input: ShareProductDetailsInput;
};


export type MutationShareQuoteDetailsArgs = {
  quoteNumber: Scalars['String']['input'];
  sharedLink: Scalars['String']['input'];
  toEmails: Array<Scalars['String']['input']>;
};


export type MutationShrnaAddToCartArgs = {
  input?: InputMaybe<ShrnaAddToCartInput>;
};


export type MutationShrnaPriceCallArgs = {
  input?: InputMaybe<ShrnaPriceCallInput>;
  productInput?: InputMaybe<SemiConfiguratorProductInput>;
};


export type MutationSirnaAddToCartArgs = {
  input?: InputMaybe<SirnaAddToCartInput>;
};


export type MutationSkipSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationSubmitCartArgs = {
  action: CartRequestAction;
  applyQuoteDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  isDuplicateCheck?: InputMaybe<Scalars['Boolean']['input']>;
  isQuote: Scalars['Boolean']['input'];
  paymentTransactionId?: InputMaybe<Scalars['String']['input']>;
  totalProduct?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSubmitContactSellerArgs = {
  input?: InputMaybe<ContactSellerInput>;
};


export type MutationSubmitFullRegistrationArgs = {
  data: FullRegistrationInput;
  input?: InputMaybe<RegistrationInput>;
};


export type MutationSubmitNewCheckoutArgs = {
  idempotencyKey?: InputMaybe<Scalars['ID']['input']>;
  input: NewCheckoutSubmitRequest;
};


export type MutationTubePriceCallArgs = {
  input: Array<InputMaybe<SessionInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationTubeTotalValidationArgs = {
  input: Array<InputMaybe<SessionInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationUpdateCartArgs = {
  action: CartRequestAction;
  input: UpdateCartInput;
};


export type MutationUpdateCartItemsArgs = {
  action: CartRequestAction;
  input: Array<UpdateCartItemInput>;
};


export type MutationUpdateCoworkerGroupArgs = {
  input: UpdateCoworkerGroupInput;
};


export type MutationUpdateCoworkerRolesArgs = {
  input: UpdateCoworkerRolesInput;
};


export type MutationUpdateCreditCardPaymentInfoArgs = {
  input: CreditCardPaymentUpdateInput;
};


export type MutationUpdateDefaultAddressArgs = {
  input?: InputMaybe<AdminPartnersInfoInput>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDeliveryDateArgs = {
  cartId: Scalars['String']['input'];
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  fddLevelB2B?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};


export type MutationUpdateDirectShipmentArgs = {
  cartId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationUpdateMembersDoneAddingToSharedListArgs = {
  listId: Scalars['ID']['input'];
};


export type MutationUpdateMobileArgs = {
  input?: InputMaybe<OmsGuestInput>;
  lastBindMobile: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
};


export type MutationUpdateMpayInvoicePaymentInfoArgs = {
  input: MpayInvoicePaymentUpdateInput;
};


export type MutationUpdateNewCartArgs = {
  cartId: Scalars['ID']['input'];
  input: NewCartInput;
};


export type MutationUpdateNewCartItemArgs = {
  cartId: Scalars['ID']['input'];
  input: NewCartItemInput;
  itemId: Scalars['Int']['input'];
};


export type MutationUpdateOrdersPendingApprovalArgs = {
  input: UpdateOrdersPendingApprovalInput;
};


export type MutationUpdatePinnedAddressesArgs = {
  input: UpdatePinnedAddress;
  soldTo: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateProfileNameContactInfoArgs = {
  input: UpdateProfileNameContactInfoInput;
};


export type MutationUpdateQuickOrderItemArgs = {
  input: UpdateQuickOrderItemInput;
};


export type MutationUpdateRequesterArgs = {
  input: UpdateOrDeleteRequesterInput;
};


export type MutationUpdateSavedCartArgs = {
  cartId: Scalars['ID']['input'];
  input: UpdateSavedCartInput;
};


export type MutationUpdateSavedCartItemsArgs = {
  cartId: Scalars['ID']['input'];
  cartItemsUpdate: Array<CartItemUpdateInput>;
};


export type MutationUpdateSharedListArgs = {
  input: UpdateSharedListInput;
};


export type MutationUpdateSharedListItemArgs = {
  input: UpdateSharedListItemInput;
};


export type MutationUpdateTermConditionArgs = {
  terms: Array<Scalars['String']['input']>;
};


export type MutationUpdateTermsAndConditionsArgs = {
  data: UpdateTermsAndConditionsInput;
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateUserProfileInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserSitePreferenceArgs = {
  data: UpdateUserSitePreferenceInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateWimsAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
};


export type MutationUploadBusinessLicenseArgs = {
  file: Scalars['Upload']['input'];
  input?: InputMaybe<OmsGuestInput>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['String']['input'];
};


export type MutationUploadCopyPasteTextArgs = {
  autogenerateAntisense?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<Scalars['String']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
};


export type MutationUploadDuplexCopyPasteTextArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
};


export type MutationUploadTubesFromFileArgs = {
  input: Scalars['String']['input'];
  isDForm?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  productInput: ConfiguratorProductInput;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpsertDropshipAddressArgs = {
  data: UpsertDropshipAddressInput;
  userId: Scalars['String']['input'];
};


export type MutationValidateMobileSecurityCodeArgs = {
  input?: InputMaybe<OmsGuestInput>;
  mobile: Scalars['String']['input'];
  sceneId: Scalars['String']['input'];
  securityCode: Scalars['String']['input'];
};


export type MutationValidatePlateShippingArgs = {
  input: Array<InputMaybe<PlatesInput>>;
  productInput: ConfiguratorProductInput;
};


export type MutationVerifyEmailArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationWechatBindArgs = {
  password: Scalars['String']['input'];
  unionId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};


export type MutationWechatLoginArgs = {
  code: Scalars['String']['input'];
};

export type MynetworkResponse = {
  __typename?: 'MynetworkResponse';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  invitationId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<PartnersResponse>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NewAttribute = {
  __typename?: 'NewAttribute';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NewCart = {
  __typename?: 'NewCart';
  cartId: Scalars['ID']['output'];
  cartType?: Maybe<CartType>;
  count?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  items: Array<NewCartItem>;
  storeId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type NewCartInput = {
  cartType?: InputMaybe<CartType>;
  items?: InputMaybe<Array<NewCartItemInput>>;
};

export type NewCartItem = {
  __typename?: 'NewCartItem';
  itemId: Scalars['Int']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Material>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type NewCartItemInput = {
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type NewCategoryProductSearchInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facetSet?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<FacetInput>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};

export type NewCheckoutAddress = {
  __typename?: 'NewCheckoutAddress';
  addressType?: Maybe<NewCheckoutAddressType>;
  attentionTo?: Maybe<NewCheckoutAddressField>;
  buildingRoom?: Maybe<NewCheckoutAddressField>;
  city?: Maybe<NewCheckoutAddressField>;
  countryCode?: Maybe<NewCheckoutAddressField>;
  countryName?: Maybe<NewCheckoutAddressField>;
  department?: Maybe<NewCheckoutAddressField>;
  district?: Maybe<NewCheckoutAddressField>;
  email?: Maybe<NewCheckoutAddressField>;
  extension?: Maybe<NewCheckoutAddressField>;
  fax?: Maybe<NewCheckoutAddressField>;
  firstName?: Maybe<NewCheckoutAddressField>;
  lastName?: Maybe<NewCheckoutAddressField>;
  mobile?: Maybe<NewCheckoutAddressField>;
  organizationName?: Maybe<NewCheckoutAddressField>;
  postOfficeBox?: Maybe<NewCheckoutAddressField>;
  postalCode?: Maybe<NewCheckoutAddressField>;
  recipientName?: Maybe<NewCheckoutAddressField>;
  state?: Maybe<NewCheckoutAddressField>;
  streets?: Maybe<NewCheckoutStreets>;
  telephone?: Maybe<NewCheckoutAddressField>;
};

export type NewCheckoutAddressField = {
  __typename?: 'NewCheckoutAddressField';
  locked?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutAddressSubmissionInput = {
  addressType?: InputMaybe<NewCheckoutAddressTypeInput>;
  attentionTo?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  ccEmail?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  poBox?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streets?: InputMaybe<NewCheckoutStreetsSubmissionInput>;
  telNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum NewCheckoutAddressType {
  BillTo = 'BILL_TO',
  Contact = 'CONTACT',
  ShipTo = 'SHIP_TO'
}

export enum NewCheckoutAddressTypeInput {
  Billing = 'BILLING',
  Contact = 'CONTACT',
  Shipping = 'SHIPPING'
}

export type NewCheckoutAddressesResponse = {
  __typename?: 'NewCheckoutAddressesResponse';
  addresses?: Maybe<Array<NewCheckoutAddress>>;
  allowBlankStreet?: Maybe<Scalars['Boolean']['output']>;
  hideBillToAddress?: Maybe<Scalars['Boolean']['output']>;
};

export type NewCheckoutAlternateMaterials = {
  __typename?: 'NewCheckoutAlternateMaterials';
  altMaterials?: Maybe<Array<Scalars['String']['output']>>;
  brand?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutAvailabilityMessage = {
  __typename?: 'NewCheckoutAvailabilityMessage';
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  leadTime?: Maybe<Scalars['String']['output']>;
  plantLocation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type NewCheckoutCartItemPreviewInput = {
  configurationId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  quoteItemNumber?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  subscriptionDetails?: InputMaybe<NewCheckoutSubscriptionDetailsInput>;
};

export type NewCheckoutChargebackDetails = {
  __typename?: 'NewCheckoutChargebackDetails';
  item?: Maybe<Array<NewCheckoutChargebackItem>>;
  partnerFunction?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutChargebackDetailsInput = {
  item?: InputMaybe<Array<NewCheckoutChargebackItemInput>>;
  partnerFunction?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutChargebackItem = {
  __typename?: 'NewCheckoutChargebackItem';
  chargebackCode?: Maybe<Scalars['String']['output']>;
  chargebackLabel?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['Boolean']['output']>;
  docTypeFlag?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Boolean']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  maxRange?: Maybe<Scalars['String']['output']>;
  minRange?: Maybe<Scalars['String']['output']>;
  poFlag?: Maybe<Scalars['String']['output']>;
  printOnInvoice?: Maybe<Scalars['String']['output']>;
  printOnPackSlip?: Maybe<Scalars['String']['output']>;
  printOnSumInvoice?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortSequence?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutChargebackItemInput = {
  chargebackCode?: InputMaybe<Scalars['String']['input']>;
  chargebackLabel?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
  docTypeFlag?: InputMaybe<Scalars['String']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  mask?: InputMaybe<Scalars['String']['input']>;
  maxRange?: InputMaybe<Scalars['String']['input']>;
  minRange?: InputMaybe<Scalars['String']['input']>;
  poFlag?: InputMaybe<Scalars['String']['input']>;
  printOnInvoice?: InputMaybe<Scalars['String']['input']>;
  printOnPackSlip?: InputMaybe<Scalars['String']['input']>;
  printOnSumInvoice?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortSequence?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutContractInput = {
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  contractPin?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutCreditCardDetails = {
  __typename?: 'NewCheckoutCreditCardDetails';
  cardExpiry?: Maybe<Scalars['String']['output']>;
  cardName?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  ccLegalTermsAcceptance?: Maybe<Scalars['Boolean']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<NewCheckoutTokenType>;
};

export type NewCheckoutCreditCardInput = {
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardName?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<NewCheckoutTokenType>;
};

export type NewCheckoutCreditCardResponse = {
  __typename?: 'NewCheckoutCreditCardResponse';
  cards?: Maybe<Array<NewCheckoutCreditCardDetails>>;
  ghostCardId?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutError = {
  __typename?: 'NewCheckoutError';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorNumber?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutItem = {
  __typename?: 'NewCheckoutItem';
  alternateMaterials?: Maybe<Array<Maybe<NewCheckoutAlternateMaterials>>>;
  availability: NewCheckoutItemAvailability;
  compliance: NewCheckoutItemCompliance;
  flags: NewCheckoutItemFlags;
  itemErrors?: Maybe<Array<NewCheckoutError>>;
  itemId: Scalars['Int']['output'];
  itemMetadata?: Maybe<NewCheckoutItemMetadata>;
  kitItems?: Maybe<Array<Maybe<NewCheckoutKitItem>>>;
  materialInfo: NewCheckoutMaterialInfo;
  minimumOrderQuantity?: Maybe<Scalars['String']['output']>;
  pricing: NewCheckoutItemPricing;
  quoteDetails?: Maybe<NewCheckoutQuoteDetails>;
  shipping: NewCheckoutItemShipping;
};

export type NewCheckoutItemAvailability = {
  __typename?: 'NewCheckoutItemAvailability';
  availabilityMessages?: Maybe<Array<NewCheckoutAvailabilityMessage>>;
  plant?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutItemCompliance = {
  __typename?: 'NewCheckoutItemCompliance';
  importLicense?: Maybe<Scalars['String']['output']>;
  jfcCode?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  pdcCode?: Maybe<Scalars['String']['output']>;
  regulations?: Maybe<Array<NewCheckoutRegulation>>;
  species?: Maybe<Scalars['String']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutItemFlags = {
  __typename?: 'NewCheckoutItemFlags';
  deaItem?: Maybe<Scalars['Boolean']['output']>;
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  isSingleLotSelected?: Maybe<Scalars['Boolean']['output']>;
  isTechwareItem?: Maybe<Scalars['Boolean']['output']>;
};

export type NewCheckoutItemMetadata = {
  __typename?: 'NewCheckoutItemMetadata';
  carrierRestriction?: Maybe<Scalars['String']['output']>;
  customerMaterial?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  drugType?: Maybe<Scalars['String']['output']>;
  genCode?: Maybe<Scalars['String']['output']>;
  groupedWebPrice?: Maybe<Scalars['String']['output']>;
  mainGroupGph?: Maybe<Scalars['String']['output']>;
  materialOrigin?: Maybe<Scalars['String']['output']>;
  materialUsage?: Maybe<Scalars['String']['output']>;
  mdpCode?: Maybe<Scalars['String']['output']>;
  ndcNumber?: Maybe<Scalars['String']['output']>;
  oldProductHierarchy?: Maybe<Scalars['String']['output']>;
  physState?: Maybe<Scalars['String']['output']>;
  prodInit?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productHierarchy?: Maybe<Scalars['String']['output']>;
  prtrCode?: Maybe<Scalars['String']['output']>;
  roanDispCode?: Maybe<Scalars['String']['output']>;
  roanMsdsCode?: Maybe<Scalars['String']['output']>;
  storageTemp?: Maybe<Scalars['String']['output']>;
  toxinCode?: Maybe<Scalars['String']['output']>;
  transGroup?: Maybe<Scalars['String']['output']>;
  vocCurrency?: Maybe<Scalars['String']['output']>;
  vocFee?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutItemPrice = {
  __typename?: 'NewCheckoutItemPrice';
  listPrice?: Maybe<Scalars['Float']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type NewCheckoutItemPriceSubmissionInput = {
  listPrice: Scalars['Float']['input'];
  netPrice: Scalars['Float']['input'];
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  unitPrice: Scalars['Float']['input'];
};

export type NewCheckoutItemPricing = {
  __typename?: 'NewCheckoutItemPricing';
  currency?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type NewCheckoutItemShipping = {
  __typename?: 'NewCheckoutItemShipping';
  carrierName?: Maybe<Scalars['String']['output']>;
  carrierRestriction?: Maybe<Scalars['String']['output']>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  routeInfo?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutKitItem = {
  __typename?: 'NewCheckoutKitItem';
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<NewCheckoutItemPrice>;
};

export type NewCheckoutKitItemSubmissionInput = {
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<NewCheckoutItemPriceSubmissionInput>;
};

export type NewCheckoutLineItemSubmissionInput = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  isQuotePriceItem?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategory?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  itemNote?: InputMaybe<Scalars['String']['input']>;
  itemType: NewCheckoutLineItemType;
  kitItems?: InputMaybe<Array<NewCheckoutKitItemSubmissionInput>>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  price: NewCheckoutItemPriceSubmissionInput;
  pricingCondition?: InputMaybe<NewCheckoutPricingConditionInput>;
  productConfiguration?: InputMaybe<NewCheckoutMtoItemConfigurationInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  quoteItemNumber?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  subscriptionFrequency?: InputMaybe<Scalars['String']['input']>;
  techwareItem?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyProductConfig?: InputMaybe<NewCheckoutThirdPartyProductConfigInput>;
  yourReference?: InputMaybe<Scalars['String']['input']>;
};

export enum NewCheckoutLineItemType {
  Configurable = 'CONFIGURABLE',
  Prepack = 'PREPACK',
  ThirdParty = 'THIRD_PARTY'
}

export type NewCheckoutMtoItemConfigurationInput = {
  configurations?: InputMaybe<Array<NewCheckoutMtoItemConfigurationOptionInput>>;
  itemTexts?: InputMaybe<Array<NewCheckoutMtoItemTextInput>>;
  productType?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutMtoItemConfigurationOptionInput = {
  configName?: InputMaybe<Scalars['String']['input']>;
  configValue?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sapCharacteristic?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutMtoItemTextInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutMaterialInfo = {
  __typename?: 'NewCheckoutMaterialInfo';
  availabilityOverwriteMessage?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  casNumber?: Maybe<Scalars['String']['output']>;
  configurationId?: Maybe<Scalars['ID']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  itemCategory?: Maybe<Scalars['String']['output']>;
  itemNotes?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  packagingSize?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productConfiguration?: Maybe<Scalars['String']['output']>;
  promotionalMessage?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  subscriptionDetails?: Maybe<NewCheckoutSubscriptionDetails>;
  supplementaryMessage?: Maybe<Scalars['String']['output']>;
  tariffCode?: Maybe<Scalars['String']['output']>;
  vendorSku?: Maybe<Scalars['String']['output']>;
  yourReference?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutNotesInput = {
  csrInstructions?: InputMaybe<Scalars['String']['input']>;
  packingSlipNote?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutPartnerContextInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutPartnerInfo = {
  __typename?: 'NewCheckoutPartnerInfo';
  billTo?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  distrChannel?: Maybe<Scalars['String']['output']>;
  erpId?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutPartnerInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  distrChannel?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutPaymentInput = {
  chargeback?: InputMaybe<NewCheckoutChargebackDetailsInput>;
  contract?: InputMaybe<NewCheckoutContractInput>;
  creditCard?: InputMaybe<NewCheckoutCreditCardInput>;
  paymentMethod?: InputMaybe<NewCheckoutPaymentMethod>;
  standard?: InputMaybe<NewCheckoutStandardPaymentDetailsInput>;
};

export enum NewCheckoutPaymentMethod {
  BlanketPo = 'BLANKET_PO',
  CreditCard = 'CREDIT_CARD',
  Mpower = 'MPOWER',
  RapidRed = 'RAPID_RED',
  Standard = 'STANDARD'
}

export type NewCheckoutPaymentMethodItemInput = {
  itemType?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  quoteItemNumber?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutPaymentMethodsRequestInput = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<NewCheckoutPaymentMethodItemInput>>;
  partnerInfo?: InputMaybe<NewCheckoutPartnerContextInput>;
};

export type NewCheckoutPaymentMethodsResponse = {
  __typename?: 'NewCheckoutPaymentMethodsResponse';
  chargebacks?: Maybe<NewCheckoutChargebackDetails>;
  creditCard?: Maybe<NewCheckoutCreditCardResponse>;
  selectedPaymentMethod?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<NewCheckoutStandardPaymentDetails>;
  supportedMethods?: Maybe<Array<Scalars['String']['output']>>;
};

export type NewCheckoutPreviewFlags = {
  __typename?: 'NewCheckoutPreviewFlags';
  deaItemExists?: Maybe<Scalars['Boolean']['output']>;
  hasHazardousMaterial?: Maybe<Scalars['Boolean']['output']>;
  isQuotePriceItemExists?: Maybe<Scalars['Boolean']['output']>;
};

export type NewCheckoutPreviewRequest = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<NewCheckoutCartItemPreviewInput>>;
  partners?: InputMaybe<NewCheckoutPartnerInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutPreviewResponse = {
  __typename?: 'NewCheckoutPreviewResponse';
  cartId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<NewCheckoutError>>;
  flags?: Maybe<NewCheckoutPreviewFlags>;
  items?: Maybe<Array<NewCheckoutItem>>;
  partners?: Maybe<NewCheckoutPartnerInfo>;
  storeId?: Maybe<Scalars['Int']['output']>;
  totals?: Maybe<NewCheckoutTotals>;
};

export type NewCheckoutPricingConditionInput = {
  conditionType?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type NewCheckoutQuoteDetails = {
  __typename?: 'NewCheckoutQuoteDetails';
  quoteItemNumber?: Maybe<Scalars['String']['output']>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
  remainingReserveQuantity?: Maybe<Scalars['Int']['output']>;
  totalReserveQuantity?: Maybe<Scalars['Int']['output']>;
};

export type NewCheckoutRegulation = {
  __typename?: 'NewCheckoutRegulation';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export enum NewCheckoutRequestType {
  Order = 'ORDER',
  Quote = 'QUOTE'
}

export type NewCheckoutShippingInput = {
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  shippingMethod: Scalars['String']['input'];
};

export type NewCheckoutShippingMethod = {
  __typename?: 'NewCheckoutShippingMethod';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutShippingMethodsResponse = {
  __typename?: 'NewCheckoutShippingMethodsResponse';
  shippingMethods?: Maybe<Array<NewCheckoutShippingMethod>>;
};

export type NewCheckoutStandardPaymentDetails = {
  __typename?: 'NewCheckoutStandardPaymentDetails';
  purchaseOrderNumber?: Maybe<NewCheckoutStandardPaymentFields>;
  requisitionNumber?: Maybe<NewCheckoutStandardPaymentFields>;
};

export type NewCheckoutStandardPaymentDetailsInput = {
  purchaseOrderNumber?: InputMaybe<NewCheckoutStandardPaymentFieldsInput>;
  requisitionNumber?: InputMaybe<NewCheckoutStandardPaymentFieldsInput>;
};

export type NewCheckoutStandardPaymentFields = {
  __typename?: 'NewCheckoutStandardPaymentFields';
  displayableInCheckout?: Maybe<Scalars['Boolean']['output']>;
  displayableInEmail?: Maybe<Scalars['Boolean']['output']>;
  editableInCheckout?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutStandardPaymentFieldsInput = {
  displayableInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  displayableInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  editableInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mask?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutStreets = {
  __typename?: 'NewCheckoutStreets';
  street1?: Maybe<NewCheckoutAddressField>;
  street2?: Maybe<NewCheckoutAddressField>;
  street3?: Maybe<NewCheckoutAddressField>;
  street4?: Maybe<NewCheckoutAddressField>;
  street5?: Maybe<NewCheckoutAddressField>;
};

export type NewCheckoutStreetsSubmissionInput = {
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  street3?: InputMaybe<Scalars['String']['input']>;
  street4?: InputMaybe<Scalars['String']['input']>;
  street5?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutSubmitFlagsInput = {
  deaItemExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewCheckoutSubmitRequest = {
  addresses: Array<NewCheckoutAddressSubmissionInput>;
  cartId?: InputMaybe<Scalars['ID']['input']>;
  checkoutSubmitFlags?: InputMaybe<NewCheckoutSubmitFlagsInput>;
  items: Array<NewCheckoutLineItemSubmissionInput>;
  notes?: InputMaybe<NewCheckoutNotesInput>;
  partners: NewCheckoutPartnerInput;
  payment: NewCheckoutPaymentInput;
  requestType: NewCheckoutRequestType;
  shipping?: InputMaybe<NewCheckoutShippingInput>;
  totals: NewCheckoutSubmitTotalsInput;
};

export type NewCheckoutSubmitResponse = {
  __typename?: 'NewCheckoutSubmitResponse';
  error?: Maybe<Scalars['String']['output']>;
  externalOrderNumber?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderTimedOut?: Maybe<Scalars['Boolean']['output']>;
};

export type NewCheckoutSubmitTotalsInput = {
  alcTax?: InputMaybe<Scalars['Float']['input']>;
  complianceFee?: InputMaybe<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  dutyTotal?: InputMaybe<Scalars['Float']['input']>;
  electricalFee?: InputMaybe<Scalars['Float']['input']>;
  eurVolatileMassCharge?: InputMaybe<Scalars['Float']['input']>;
  iceCharge?: InputMaybe<Scalars['Float']['input']>;
  netTotal: Scalars['Float']['input'];
  orderTotal: Scalars['Float']['input'];
  packageCharge?: InputMaybe<Scalars['Float']['input']>;
  promoSavings?: InputMaybe<Scalars['Float']['input']>;
  tariffSurcharge?: InputMaybe<Scalars['Float']['input']>;
  taxTotal?: InputMaybe<Scalars['Float']['input']>;
  totalProductCount: Scalars['Int']['input'];
  transHandlingCharge?: InputMaybe<Scalars['Float']['input']>;
};

export type NewCheckoutSubscriptionDetails = {
  __typename?: 'NewCheckoutSubscriptionDetails';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  subscriptionFrequency?: Maybe<Scalars['String']['output']>;
};

export type NewCheckoutSubscriptionDetailsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  subscriptionFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type NewCheckoutThirdPartyProductConfigInput = {
  casNum?: InputMaybe<Scalars['String']['input']>;
  condUnit?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  customCharges?: InputMaybe<Scalars['String']['input']>;
  delvLeadTime?: InputMaybe<Scalars['String']['input']>;
  freightCharges?: InputMaybe<Scalars['Float']['input']>;
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  mainGroup?: InputMaybe<Scalars['String']['input']>;
  materialDesc?: InputMaybe<Scalars['String']['input']>;
  matlExist?: InputMaybe<Scalars['String']['input']>;
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  offerPrice?: InputMaybe<Scalars['String']['input']>;
  poCurrency?: InputMaybe<Scalars['String']['input']>;
  poPrice?: InputMaybe<Scalars['String']['input']>;
  priceUnit?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  templateMaterial?: InputMaybe<Scalars['String']['input']>;
  uom?: InputMaybe<Scalars['String']['input']>;
  vendorMaterial?: InputMaybe<Scalars['String']['input']>;
  vendorSku?: InputMaybe<Scalars['String']['input']>;
};

export enum NewCheckoutTokenType {
  Encrypted = 'ENCRYPTED',
  Tokenized = 'TOKENIZED',
  Transient = 'TRANSIENT'
}

export type NewCheckoutTotals = {
  __typename?: 'NewCheckoutTotals';
  alcTax?: Maybe<Scalars['Float']['output']>;
  complianceFee?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dutyTotal?: Maybe<Scalars['Float']['output']>;
  electricalFee?: Maybe<Scalars['Float']['output']>;
  eurVolatileMassCharge?: Maybe<Scalars['Float']['output']>;
  iceCharge?: Maybe<Scalars['Float']['output']>;
  netTotal?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  packageCharge?: Maybe<Scalars['Float']['output']>;
  promoSavings?: Maybe<Scalars['Float']['output']>;
  tariffSurcharge?: Maybe<Scalars['Float']['output']>;
  taxTotal?: Maybe<Scalars['Float']['output']>;
  transHandlingCharge?: Maybe<Scalars['Float']['output']>;
};

export type NewCreditCardInput = {
  cardExpiryDate?: InputMaybe<Scalars['String']['input']>;
  cardName?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardSecret?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
  expiryMonth?: InputMaybe<Scalars['String']['input']>;
  expiryYear?: InputMaybe<Scalars['String']['input']>;
  maskedCardNumber?: InputMaybe<Scalars['String']['input']>;
  saveAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  transientCCToken?: InputMaybe<Scalars['String']['input']>;
};

export type NewGeneralProductSearchResults = {
  __typename?: 'NewGeneralProductSearchResults';
  facets?: Maybe<Array<Maybe<Facet>>>;
  metadata: NewMetadata;
  products?: Maybe<Array<Maybe<NewSearchProduct>>>;
};

export type NewImage = {
  __typename?: 'NewImage';
  altText?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type NewMetadata = {
  __typename?: 'NewMetadata';
  count: Scalars['Int']['output'];
};

export type NewProductSearchInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facetSet?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<FacetInput>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  isBbeCatalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};

export type NewProductSearchResults = {
  __typename?: 'NewProductSearchResults';
  facets?: Maybe<Array<Maybe<Facet>>>;
  metadata: NewMetadata;
  products?: Maybe<Array<Maybe<NewSearchProduct>>>;
};

export type NewSavedCart = {
  __typename?: 'NewSavedCart';
  savedCart: SaveCartId;
};

export type NewSearchProduct = {
  __typename?: 'NewSearchProduct';
  application?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Array<Maybe<NewAttribute>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandKey?: Maybe<Scalars['String']['output']>;
  catalogId?: Maybe<Scalars['String']['output']>;
  citationCount?: Maybe<Scalars['Int']['output']>;
  dd_group_type?: Maybe<Scalars['String']['output']>;
  displayBrand?: Maybe<Scalars['String']['output']>;
  displaySellerName?: Maybe<Scalars['String']['output']>;
  erp_type?: Maybe<Array<Scalars['String']['output']>>;
  images?: Maybe<Array<Maybe<NewImage>>>;
  isBBE?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  keyAttributes?: Maybe<Array<Maybe<ProductAttribute>>>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNameSuffix?: Maybe<Scalars['String']['output']>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  marketplaceSellerId?: Maybe<Scalars['String']['output']>;
  materialIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  paMessage?: Maybe<Scalars['String']['output']>;
  productKey?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productNameSuffix?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  sds: Array<SdsResponseNew>;
  substance?: Maybe<NewSubstance>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NewSubstance = {
  __typename?: 'NewSubstance';
  casNumber?: Maybe<Scalars['String']['output']>;
  substanceCount?: Maybe<Scalars['Int']['output']>;
  substanceId?: Maybe<Scalars['String']['output']>;
  substanceName?: Maybe<Scalars['String']['output']>;
};

export type NewUser = {
  acceptOptionalPromos?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  acceptPromos: Scalars['Boolean']['input'];
  acceptTerms: Scalars['Boolean']['input'];
  confirmPassword: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  generalTermsCondition: Scalars['Boolean']['input'];
  inviteeId?: InputMaybe<Scalars['String']['input']>;
  isDirectCustomer?: InputMaybe<Scalars['String']['input']>;
  isExternalRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  piiDataConsentAcceptance: Scalars['Boolean']['input'];
  siteAgreement: Scalars['Boolean']['input'];
  telephone: Scalars['String']['input'];
};

export type NgsoPlatePrice = {
  __typename?: 'NgsoPlatePrice';
  countryCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  plateId?: Maybe<Scalars['Int']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  wellList?: Maybe<Array<Maybe<WellListPrice>>>;
};

export type NgsoPriceResponse = {
  __typename?: 'NgsoPriceResponse';
  response?: Maybe<Array<Maybe<NgsoPlatePrice>>>;
  serverError?: Maybe<ListError>;
};

export enum NotificationType {
  Delayed = 'DELAYED',
  Shipped = 'SHIPPED'
}

export type NotificationsResponse = {
  __typename?: 'NotificationsResponse';
  eventDate: Scalars['Date']['output'];
  notificationType: NotificationType;
  orderNumber: Scalars['String']['output'];
};

export type Oauth2SessionResponse = {
  __typename?: 'Oauth2SessionResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type Offer = {
  __typename?: 'Offer';
  currency: Scalars['String']['output'];
  expirationTimestamp: Scalars['String']['output'];
  listPrice: Scalars['Float']['output'];
  offerId: Scalars['String']['output'];
  offerPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type OfferAcceptanceResponse = {
  __typename?: 'OfferAcceptanceResponse';
  currency: Scalars['String']['output'];
  expirationTimestamp: Scalars['String']['output'];
  listPrice: Scalars['Float']['output'];
  offerId: Scalars['String']['output'];
  offerPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type OfferMessage = {
  body: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type OmsContactAddress = {
  __typename?: 'OmsContactAddress';
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
};

export type OmsCurrentUserResponse = {
  __typename?: 'OmsCurrentUserResponse';
  contactAddress: OmsContactAddress;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobilePhone: Scalars['String']['output'];
  mobileVerifiedFlag: Scalars['Boolean']['output'];
};

export type OmsGuestInput = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  omsGuestToken?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
};

export type OpenIncidentMessage = {
  body: Scalars['String']['input'];
  line: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  reasonCode: Scalars['String']['input'];
};

export type OpenInvoiceHeaderInfoModel = {
  __typename?: 'OpenInvoiceHeaderInfoModel';
  payer?: Maybe<Scalars['String']['output']>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  billingBlock?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  deliveryBlock?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['Date']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  orderedBy: Scalars['String']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  quotePriceItemExists?: Maybe<Scalars['Boolean']['output']>;
  readableOrderId?: Maybe<Scalars['String']['output']>;
  salesDocNumber?: Maybe<Scalars['ID']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusAlias: Scalars['String']['output'];
  statusCategory?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  sysId?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalCompletedItems?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  transSurchargeMessage?: Maybe<Scalars['String']['output']>;
};

export type OrderAdditionalInfo = {
  __typename?: 'OrderAdditionalInfo';
  carrierRestriction?: Maybe<Scalars['String']['output']>;
  casNumber?: Maybe<Scalars['String']['output']>;
  jfcCode?: Maybe<Scalars['String']['output']>;
  pdcCode?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  tariff?: Maybe<Scalars['String']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderAssessment = {
  __typename?: 'OrderAssessment';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OrderAssessmentsResponse = {
  __typename?: 'OrderAssessmentsResponse';
  orderAssessments?: Maybe<Array<Maybe<OrderAssessment>>>;
};

export enum OrderByType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderConfirmationPdfInput = {
  sapOrderId: Scalars['String']['input'];
  soldTo: Scalars['String']['input'];
};

export type OrderContactDetail = {
  __typename?: 'OrderContactDetail';
  ccEmail?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  orderedBy: Scalars['String']['output'];
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneNumber1?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
};

export type OrderContactInfo = {
  __typename?: 'OrderContactInfo';
  attentionTo?: Maybe<Scalars['String']['output']>;
  buildingRoom?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneNumber1?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
  street4?: Maybe<Scalars['String']['output']>;
};

export type OrderDealerOrganizationName = {
  __typename?: 'OrderDealerOrganizationName';
  email?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderDetails = {
  __typename?: 'OrderDetails';
  alcTax?: Maybe<Scalars['Float']['output']>;
  approvers: Array<Approver>;
  bankDetails?: Maybe<BankDetails>;
  billTo: OrderContactInfo;
  blanketPoNumber?: Maybe<Scalars['String']['output']>;
  canCancelOrder?: Maybe<Scalars['Boolean']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  /**
   * Indicate if the order is a FTB order. Value is null or FTB.
   * NOTE:This FTB value won't change after order becomes a normal order
   */
  category?: Maybe<Scalars['String']['output']>;
  chargebackCodes: Array<ChargebackCode>;
  complianceDocuments?: Maybe<Array<Maybe<ComplianceDocument>>>;
  complianceFee?: Maybe<Scalars['Float']['output']>;
  consolidatorName: Scalars['String']['output'];
  contactAddress: OrderContactInfo;
  contactDetail: OrderContactDetail;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  creditCardNumber?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerServiceContactInfo?: Maybe<CustomerServiceContactInfo>;
  customerServiceNote?: Maybe<Scalars['String']['output']>;
  dealers?: Maybe<Array<Dealer>>;
  domainStatus?: Maybe<OrderEmproveDomainStatus>;
  dutyTotal?: Maybe<Scalars['Float']['output']>;
  electricalFee?: Maybe<Scalars['Float']['output']>;
  eurVolatileMassCharge?: Maybe<Scalars['Float']['output']>;
  hasQuotePriceItem: Scalars['Boolean']['output'];
  ice?: Maybe<Scalars['Float']['output']>;
  invoices?: Maybe<Array<MarketplaceInvoice>>;
  isApprovedOrder: Scalars['Boolean']['output'];
  isBlueInvoiceLinkEnabled: Scalars['Boolean']['output'];
  isComplianceDocumentRequired?: Maybe<Scalars['Boolean']['output']>;
  isDealerOrder: Scalars['Boolean']['output'];
  isEmproveProductExists: Scalars['Boolean']['output'];
  isEndUserWithZuPartner: Scalars['Boolean']['output'];
  isReOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  items: Array<OrderItem>;
  mPortalLinks?: Maybe<MPortalLinks>;
  mpowerNumber?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['Date']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  orderInfo?: Maybe<OrderInfo>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  orderedBy: Scalars['String']['output'];
  overallDeliveryStatus?: Maybe<Scalars['String']['output']>;
  packingSlipNote?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<OrderContactInfo>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentTerms: Scalars['String']['output'];
  pkg?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poNumberLabel?: Maybe<Scalars['String']['output']>;
  rapidRedNumber?: Maybe<Scalars['String']['output']>;
  readableOrderId?: Maybe<Scalars['String']['output']>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  reqNumber?: Maybe<Scalars['String']['output']>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  requisitionNumber?: Maybe<Scalars['String']['output']>;
  requisitionNumberLabel?: Maybe<Scalars['String']['output']>;
  salesDocNumber?: Maybe<Scalars['ID']['output']>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  shipTo: OrderContactInfo;
  shippingTransportation?: Maybe<Scalars['Float']['output']>;
  soldTo: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusAlias: Scalars['String']['output'];
  subscriptionFrequency?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
  tariffSurcharge?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  transHandlingCharge?: Maybe<Scalars['Float']['output']>;
  transSurchargeMessage?: Maybe<Scalars['String']['output']>;
  znPartner?: Maybe<OrderContactInfo>;
  zzPartner?: Maybe<OrderContactInfo>;
};

export enum OrderEmproveDomainStatus {
  Approved = 'Approved',
  Blocked = 'Blocked',
  New = 'New',
  Pending = 'Pending'
}

export type OrderEvaluationInput = {
  evaluation: Assessments;
  orderId: Scalars['String']['input'];
};

export type OrderForApproval = {
  __typename?: 'OrderForApproval';
  approvalAmount?: Maybe<Scalars['Int']['output']>;
  approverTypeId: Scalars['String']['output'];
  createdDate: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  inReview?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate: Scalars['Date']['output'];
  numOfItems: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  orderedBy?: Maybe<Scalars['String']['output']>;
  originator: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  submittedBy: Scalars['String']['output'];
};

export type OrderInfo = {
  __typename?: 'OrderInfo';
  billingBlock?: Maybe<Scalars['String']['output']>;
  customerInfo?: Maybe<CustomerInfo>;
  dealerInformation?: Maybe<OrderDealerOrganizationName>;
  deliveryBlock?: Maybe<Scalars['String']['output']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  additionalInfo?: Maybe<OrderAdditionalInfo>;
  availabilityMessages: Array<Maybe<OrderItemAvailabilityMessages>>;
  availabilityOverwriteMessage?: Maybe<BbeMaterialAvailability>;
  availabilityTxt?: Maybe<Scalars['String']['output']>;
  availableDate?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  canCancelItem?: Maybe<Scalars['Boolean']['output']>;
  canReturnItem?: Maybe<Scalars['Boolean']['output']>;
  complianceMessages: Array<Scalars['String']['output']>;
  confidenceLevel?: Maybe<Scalars['String']['output']>;
  configuration: Array<ProductConfiguration>;
  configurationId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerOrderInfo?: Maybe<CustomerOrderInfo>;
  customerReference?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  distrChainStatus?: Maybe<Scalars['String']['output']>;
  emproveDossierInfo?: Maybe<EmproveDossierItem>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  isSingleLotSelected?: Maybe<Scalars['Boolean']['output']>;
  kitItems: Array<CartKitItem>;
  lineNumber: Scalars['String']['output'];
  listPrice?: Maybe<Scalars['Float']['output']>;
  listPriceCurrency?: Maybe<Scalars['String']['output']>;
  marketPlaceOfferId?: Maybe<Scalars['String']['output']>;
  marketPlaceOrderId?: Maybe<Scalars['String']['output']>;
  marketPlaceOrderLineId?: Maybe<Scalars['String']['output']>;
  marketplaceAvailableToReturnQty?: Maybe<Scalars['Int']['output']>;
  marketplaceCanEvaluate?: Maybe<Scalars['Boolean']['output']>;
  marketplaceCanOpenIncident?: Maybe<Scalars['Boolean']['output']>;
  marketplaceIncidentOpen?: Maybe<Scalars['Boolean']['output']>;
  marketplaceSellerId?: Maybe<Scalars['String']['output']>;
  material: Material;
  materialNumber: Scalars['String']['output'];
  pricePerUnit: Scalars['Float']['output'];
  product?: Maybe<Scalars['String']['output']>;
  productDetails?: Maybe<Product>;
  productNote?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  quoteNumber?: Maybe<Scalars['String']['output']>;
  remainingReservedQuantity?: Maybe<Scalars['Int']['output']>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  returnableQuantity?: Maybe<Scalars['Int']['output']>;
  routeInfo?: Maybe<Scalars['String']['output']>;
  scheduleLines: Array<OrderItemScheduleLine>;
  shippingFrom?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionFrequency?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
  totalReservedQuantity?: Maybe<Scalars['Int']['output']>;
  type: CartItemType;
  vendorNumber?: Maybe<Scalars['String']['output']>;
  yourRef?: Maybe<Scalars['String']['output']>;
};

export type OrderItemAvailabilityMessages = {
  __typename?: 'OrderItemAvailabilityMessages';
  date?: Maybe<Scalars['Date']['output']>;
  key: Scalars['String']['output'];
  plantLoc?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemLotNumber = {
  __typename?: 'OrderItemLotNumber';
  batch: Scalars['String']['output'];
  cOfALink?: Maybe<Scalars['String']['output']>;
  cOfOLink?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemScheduleLine = {
  __typename?: 'OrderItemScheduleLine';
  billingBlock?: Maybe<Scalars['String']['output']>;
  confirmedQuantity?: Maybe<Scalars['Int']['output']>;
  deliveryBlock?: Maybe<Scalars['String']['output']>;
  deliveryDate: Scalars['Date']['output'];
  deliveryId?: Maybe<Scalars['String']['output']>;
  displayableDate: Scalars['Date']['output'];
  hasFapiaoList: Scalars['Boolean']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lotNumber: Array<OrderItemLotNumber>;
  milestoneDate?: Maybe<Scalars['String']['output']>;
  refDocNumber?: Maybe<Scalars['String']['output']>;
  shipmentNumber?: Maybe<Scalars['String']['output']>;
  shippingPoint?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingInfo: Array<OrderItemTrackingInfo>;
};

export type OrderItemTrackingInfo = {
  __typename?: 'OrderItemTrackingInfo';
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  trackingNumber: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export type OrderMessage = {
  body: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
  topic?: InputMaybe<OrderMessageTopic>;
};

export type OrderMessageTopic = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderNotesInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderNotesResponse = {
  __typename?: 'OrderNotesResponse';
  language?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type OrderSearchInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<OrderByType>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatusType>;
  statusCategory?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type OrderSearchPayload = {
  __typename?: 'OrderSearchPayload';
  billingBlock?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  customerServicePhone?: Maybe<Scalars['String']['output']>;
  deliveryBlock?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  orderBy?: Maybe<OrderByType>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCategory?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type OrderShareableLinkInput = {
  orderNumber: Scalars['String']['input'];
};

/** TODO: Triggering notifications from a graphql mutation is only needed for PoC, not needed for production */
export type OrderShippedNotification = {
  orderId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum OrderStatusAlias {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  NotAvailable = 'NOT_AVAILABLE',
  OnHold = 'ON_HOLD',
  PartiallyCancelled = 'PARTIALLY_CANCELLED',
  PartiallyClosed = 'PARTIALLY_CLOSED',
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  PendingReview = 'PENDING_REVIEW',
  Processing = 'PROCESSING',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Shipped = 'SHIPPED',
  ShippingInProgress = 'SHIPPING_IN_PROGRESS'
}

/**
 * Order status/category/alias mappings can be found here:
 * https://wiki.merckgroup.com/confluence/display/EBPM/Order+Status+Mapping
 */
export enum OrderStatusCategoryType {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  SavedOrders = 'SAVED_ORDERS'
}

export enum OrderStatusType {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Open = 'OPEN',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  SearchComplete = 'SEARCH_COMPLETE',
  SearchInProgress = 'SEARCH_IN_PROGRESS',
  SearchOpen = 'SEARCH_OPEN',
  WimsOrderStatusComplete = 'WIMS_ORDER_STATUS_COMPLETE',
  WimsOrderStatusInProcess = 'WIMS_ORDER_STATUS_IN_PROCESS',
  WimsOrderStatusMap = 'WIMS_ORDER_STATUS_MAP',
  WimsOrderStatusMc = 'WIMS_ORDER_STATUS_MC',
  WimsOrderStatusMg = 'WIMS_ORDER_STATUS_MG',
  WimsOrderStatusMoc = 'WIMS_ORDER_STATUS_MOC',
  WimsOrderStatusMpc = 'WIMS_ORDER_STATUS_MPC',
  WimsOrderStatusMpoc = 'WIMS_ORDER_STATUS_MPOC',
  WimsOrderStatusMpre = 'WIMS_ORDER_STATUS_MPRE',
  WimsOrderStatusMps = 'WIMS_ORDER_STATUS_MPS',
  WimsOrderStatusMre = 'WIMS_ORDER_STATUS_MRE',
  WimsOrderStatusMs = 'WIMS_ORDER_STATUS_MS',
  WimsOrderStatusMsinp = 'WIMS_ORDER_STATUS_MSINP',
  WimsOrderStatusOh = 'WIMS_ORDER_STATUS_OH',
  WimsOrderStatusOpen = 'WIMS_ORDER_STATUS_OPEN'
}

export type OrdersForApproval = {
  __typename?: 'OrdersForApproval';
  count: Scalars['Int']['output'];
  ordersForApproval: Array<OrderForApproval>;
  perPage: Scalars['Int']['output'];
};

export type OrfAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  results?: InputMaybe<Array<InputMaybe<OrfPriceCallInputData>>>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type OrfAddToCartResponse = {
  __typename?: 'OrfAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type OrfDropDownListInput = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type OrfPhysicalMaterial = {
  __typename?: 'OrfPhysicalMaterial';
  DNA?: Maybe<Scalars['String']['output']>;
  GLYCEROL?: Maybe<Scalars['String']['output']>;
  VIRUS?: Maybe<Scalars['String']['output']>;
  noSelection?: Maybe<Scalars['String']['output']>;
};

export type OrfPriceCall = {
  __typename?: 'OrfPriceCall';
  result?: Maybe<Array<Maybe<OrfPriceCallResponse>>>;
  serverError?: Maybe<ServerError>;
};

export type OrfPriceCallInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  results?: InputMaybe<Array<InputMaybe<OrfPriceCallInputData>>>;
};

export type OrfPriceCallInputData = {
  brand?: InputMaybe<Scalars['String']['input']>;
  cloneId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  orfLength?: InputMaybe<Scalars['String']['input']>;
  orfSequence?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  subSetInfo?: InputMaybe<Array<InputMaybe<SubSetInfoInput>>>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type OrfPriceCallResponse = {
  __typename?: 'OrfPriceCallResponse';
  brand?: Maybe<Scalars['String']['output']>;
  cloneId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  orfLength?: Maybe<Scalars['String']['output']>;
  orfSequence?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  subSetInfo?: Maybe<Array<Maybe<SubSetInfo>>>;
  vector?: Maybe<Scalars['String']['output']>;
};

export type OrfProductSearchTermInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type OrfSearchResponse = {
  __typename?: 'OrfSearchResponse';
  count?: Maybe<Scalars['Int']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<OrfSearchResults>>>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OrfSearchResults = {
  __typename?: 'OrfSearchResults';
  cloneId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  orfLength?: Maybe<Scalars['String']['output']>;
  orfSequence?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  subSetInfo: Array<SubSetInfo>;
  vector?: Maybe<Scalars['String']['output']>;
};

export type OrfSpecifications = {
  __typename?: 'OrfSpecifications';
  aliquot?: Maybe<Array<Maybe<Aliquot>>>;
  amount?: Maybe<Array<Maybe<Amount>>>;
  physicalMaterial?: Maybe<Array<Maybe<OrfPhysicalMaterial>>>;
  serverError?: Maybe<ServerError>;
  titer?: Maybe<Array<Maybe<Titer>>>;
  volume?: Maybe<Array<Maybe<Volume>>>;
};

export type OrganizationApprover = {
  __typename?: 'OrganizationApprover';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
};

export type PspInformation = {
  __typename?: 'PSPInformation';
  captureContext?: Maybe<Scalars['String']['output']>;
  hostedCheckoutUrl?: Maybe<Scalars['String']['output']>;
  paymentEnvironment?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
};

export type Paper = {
  __typename?: 'Paper';
  abstract?: Maybe<Scalars['String']['output']>;
  authors: Array<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  endPage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue?: Maybe<Scalars['String']['output']>;
  journalName?: Maybe<Scalars['String']['output']>;
  pubMedId?: Maybe<Scalars['String']['output']>;
  relatedProducts: Array<Product>;
  startPage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
};

export type PaperInput = {
  paperIds: Array<Scalars['String']['input']>;
};

export type PaperSearchInput = {
  facets?: InputMaybe<Array<FacetInput>>;
  pagination?: Pagination;
  searchTerm: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaperSearchResponse = SearchResults & {
  __typename?: 'PaperSearchResponse';
  facets: Array<Facet>;
  items: Array<Paper>;
  metadata: SearchResultsMetadata;
};

export type Papers = {
  __typename?: 'Papers';
  count: Scalars['Int']['output'];
  papers: Array<Paper>;
};

export type ParticipantApprover = {
  __typename?: 'ParticipantApprover';
  approvalAmount?: Maybe<Scalars['Int']['output']>;
  approvalProductType?: Maybe<Scalars['String']['output']>;
  approvalTypeId?: Maybe<Scalars['String']['output']>;
  approverId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
};

export type ParticipantShippingMethods = {
  __typename?: 'ParticipantShippingMethods';
  description: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  shippingMethodCode?: Maybe<Scalars['String']['output']>;
};

export type ParticipantSitePreferenceInput = {
  preferredDealerId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  accountNumber: Scalars['String']['output'];
  attentionTo: Scalars['String']['output'];
  blueCustomerDetails?: Maybe<Array<Maybe<BlueCustomerDetails>>>;
  buildingRoom: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  customerServiceNotes?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  partnerNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  salesOrg: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddresses: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum PartnerAccountType {
  Ag = 'AG',
  Ap = 'AP',
  Ds = 'DS',
  Re = 'RE',
  Rg = 'RG',
  We = 'WE',
  Zn = 'ZN',
  Zz = 'ZZ'
}

export type PartnerAddresses = {
  __typename?: 'PartnerAddresses';
  billTos: Array<PartnerAccount>;
  dropshipTos: Array<PartnerAccount>;
  payers: Array<PartnerAccount>;
  shipTos: Array<PartnerAccount>;
  znPartners: Array<PartnerAccount>;
  zzPartners: Array<PartnerAccount>;
};

export type PartnerObject = {
  __typename?: 'PartnerObject';
  restrictedPartners?: Maybe<Array<Maybe<RestrictedPartnersObject>>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PartnerObjectInput = {
  restrictedPartners?: InputMaybe<Array<InputMaybe<RestrictedPartnersObjectInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerType = {
  id: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
};

export type PartnersResponse = {
  __typename?: 'PartnersResponse';
  billTo?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  payer?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
};

/** Used to patch an existing cart item (Fast) */
export type PatchCartItemInput = {
  cartItemId: Scalars['ID']['input'];
  isSingleLotSelected?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShippingMethod?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  productNote?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  subscriptionFrequency?: InputMaybe<Scalars['String']['input']>;
  yourReference?: InputMaybe<Scalars['String']['input']>;
};

export type PatchCcLegalTermsInput = {
  op: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type PatchNewCartInput = {
  items?: InputMaybe<Array<NewCartItemInput>>;
};

export type PatchNewCartItemInput = {
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PatchQuoteInput = {
  itemsToUpdate: Array<InputMaybe<QuoteItemToUpdate>>;
  quoteId: Scalars['String']['input'];
};

export type PatchSitePreferenceInput = {
  op: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type PayerAuthResponse = {
  __typename?: 'PayerAuthResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  authenticationTransactionId?: Maybe<Scalars['String']['output']>;
  cybersourceErrorMessage?: Maybe<Scalars['String']['output']>;
  cybersourceStatus?: Maybe<Scalars['String']['output']>;
  deviceDataCollectionUrl?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stepUpUrl?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  approvalNumber: Scalars['String']['output'];
  approvalTime: Scalars['Date']['output'];
  cancel?: Maybe<Scalars['String']['output']>;
  cardType: Scalars['String']['output'];
  cardTypeDescription: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  invoices: Array<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  payer: Scalars['String']['output'];
  receiptUrl: Scalars['String']['output'];
  result: Scalars['Int']['output'];
  resultDate: Scalars['Date']['output'];
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sigmaBusinessId?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Int']['output'];
  transactionNumber: Scalars['String']['output'];
  vanIdTitle?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistoryLineItem = {
  __typename?: 'PaymentHistoryLineItem';
  comptopTransId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  docType?: Maybe<Scalars['String']['output']>;
  invoiceAccDocNumber?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  sapOrderNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transId?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
};

export type PaymentHistoryResponse = {
  __typename?: 'PaymentHistoryResponse';
  lineItemList: Array<PaymentHistory>;
};

export type PaymentHistorySearchInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  salesOrg?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

export type PaymentLabelValue = {
  __typename?: 'PaymentLabelValue';
  label: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type PaymentListItemInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  dbCrIND?: InputMaybe<Scalars['String']['input']>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  invoiceDate: Scalars['Date']['input'];
  invoiceNo: Scalars['String']['input'];
  migratedInvoiceNo?: InputMaybe<Scalars['String']['input']>;
  migratedTaxInvoiceNo?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  taxInvoiceNo?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMetadataInput = {
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMetadataResponse = {
  __typename?: 'PaymentMetadataResponse';
  creditCardTypes?: Maybe<Array<Scalars['String']['output']>>;
  isMpayEnabled: Scalars['Boolean']['output'];
  pspIntegrationInfo?: Maybe<PspInformation>;
  pspIntegrationType?: Maybe<Scalars['String']['output']>;
  pspName?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  displayable: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodsInput = {
  chargebacks?: InputMaybe<UserChargebackInput>;
  creditCard?: InputMaybe<Array<CreditCardInput>>;
  defaultPaymentMethod: Scalars['String']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  purchaseOrderNumberMask?: InputMaybe<Scalars['String']['input']>;
  requisitionNumber: Scalars['String']['input'];
  requisitionNumberMask?: InputMaybe<Scalars['String']['input']>;
};

export type PayuAuthResponse = {
  __typename?: 'PayuAuthResponse';
  authorizationId?: Maybe<Scalars['String']['output']>;
  bankRedirectUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PayuPayerAuthEnrollInput = {
  cardExpiryDate: Scalars['String']['input'];
  cardType: Scalars['String']['input'];
  encryptedCvv: Scalars['String']['input'];
  merchantSiteUrl: Scalars['String']['input'];
  tokenizedCCNumber: Scalars['String']['input'];
  transientCCToken: Scalars['String']['input'];
};

export type PayuPayerAuthResultInput = {
  authorizationId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type PdfDownloadInput = {
  docid?: InputMaybe<Scalars['String']['input']>;
  lotnumber?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type PeptideErrors = {
  __typename?: 'PeptideErrors';
  listError?: Maybe<Array<Maybe<ListError>>>;
};

export type PhysicalFormatInput = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  lentivirusBackbone?: InputMaybe<Scalars['String']['input']>;
  modification?: InputMaybe<Scalars['String']['input']>;
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type PhysicalFormatItem = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type PhysicalMaterial = {
  __typename?: 'PhysicalMaterial';
  DNA?: Maybe<Scalars['String']['output']>;
  RNA?: Maybe<Scalars['String']['output']>;
  VIRUS?: Maybe<Scalars['String']['output']>;
  noSelection?: Maybe<Scalars['String']['output']>;
};

export type PinnedAddress = {
  __typename?: 'PinnedAddress';
  pinnedAddress?: Maybe<Array<Maybe<PinnedPartnerAccount>>>;
  unPinnedAddresses?: Maybe<Array<Maybe<PartnerAccount>>>;
};

export type PinnedAddressInputItem = {
  index: Scalars['Int']['input'];
  partnerNumber: Scalars['String']['input'];
  partnerType: Scalars['String']['input'];
};

export type PinnedAddressItem = {
  __typename?: 'PinnedAddressItem';
  index: Scalars['Int']['output'];
  partnerNumber: Scalars['String']['output'];
  partnerType: Scalars['String']['output'];
};

export type PinnedAddressSearchInput = {
  attentionTo?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  customerNumber: Scalars['String']['input'];
  department?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  requestType: RequestType;
  salesOrderSource?: InputMaybe<SalesOrderSource>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  soldToCountry?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type PinnedAddresses = {
  __typename?: 'PinnedAddresses';
  addresses?: Maybe<Array<Maybe<PinnedAddressItem>>>;
};

export type PinnedPartnerAccount = {
  __typename?: 'PinnedPartnerAccount';
  accountNumber: Scalars['String']['output'];
  attentionTo: Scalars['String']['output'];
  buildingRoom: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  customerServiceNotes?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  partnerNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  salesOrg: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddresses: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PinnedPartnerAddresses = {
  __typename?: 'PinnedPartnerAddresses';
  billTos?: Maybe<PinnedAddress>;
  contact?: Maybe<PinnedAddress>;
  payers?: Maybe<PinnedAddress>;
  shipTos?: Maybe<PinnedAddress>;
  soldTos?: Maybe<PinnedAddress>;
};

export type PipelineOrganizationDepartments = {
  __typename?: 'PipelineOrganizationDepartments';
  pipelineOrganizationDepartments: Array<PipelineOrganizationDepartmentsFields>;
};

export type PipelineOrganizationDepartmentsFields = {
  __typename?: 'PipelineOrganizationDepartmentsFields';
  languages: Scalars['String']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  parentOrg?: Maybe<Scalars['Boolean']['output']>;
};

export type PlateListInput = {
  biTubeWellList?: InputMaybe<Array<InputMaybe<BiTubeWellListUploadInput>>>;
  plateName?: InputMaybe<Scalars['String']['input']>;
  wellList?: InputMaybe<Array<InputMaybe<WellListUploadInput>>>;
};

export type PlatePrice = {
  __typename?: 'PlatePrice';
  baseFee?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  modificationFee?: Maybe<Scalars['String']['output']>;
  plateCopyFee?: Maybe<Scalars['String']['output']>;
  plateFee?: Maybe<Scalars['String']['output']>;
  plateId?: Maybe<Scalars['Int']['output']>;
  plateName?: Maybe<Scalars['String']['output']>;
  priceErrorHeader?: Maybe<Scalars['String']['output']>;
  processFee?: Maybe<Scalars['String']['output']>;
  purificationFee?: Maybe<Scalars['String']['output']>;
  remainingMaterials?: Maybe<Scalars['String']['output']>;
  shippingOptionFee?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['String']['output']>;
  wells?: Maybe<Scalars['String']['output']>;
};

export type PlateShippingResponse = {
  __typename?: 'PlateShippingResponse';
  listExcessMaterial?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listProductPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listShipment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serverError?: Maybe<ListError>;
};

export type Plates = {
  __typename?: 'Plates';
  amount?: Maybe<Scalars['String']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  biTubeWellList?: Maybe<Array<Maybe<BiTubeWellList>>>;
  category?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['Int']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countOfWells?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  daughterPlateCount?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  isAmountSelected?: Maybe<Scalars['Boolean']['output']>;
  isCSR?: Maybe<Scalars['Boolean']['output']>;
  isCSRSupervisor?: Maybe<Scalars['Boolean']['output']>;
  isConcentrationOther?: Maybe<Scalars['Boolean']['output']>;
  isConcentrationSelected?: Maybe<Scalars['Boolean']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  isPackageTypeOther?: Maybe<Scalars['Boolean']['output']>;
  isShippingOverridden?: Maybe<Scalars['Boolean']['output']>;
  isSpecificationsOverridden?: Maybe<Scalars['Boolean']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  maxAmount?: Maybe<Scalars['String']['output']>;
  minAmount?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  plateCopiesRange?: Maybe<Scalars['String']['output']>;
  plateId?: Maybe<Scalars['Int']['output']>;
  plateName?: Maybe<Scalars['String']['output']>;
  plateNameError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  plateType?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  researcher?: Maybe<Scalars['String']['output']>;
  researcherNameError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scale?: Maybe<Scalars['String']['output']>;
  selectedPackageType?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Scalars['String']['output']>;
  stockPlate?: Maybe<Scalars['String']['output']>;
  totalBaseCount?: Maybe<Scalars['Int']['output']>;
  wellList: Array<Welllist>;
  wellType?: Maybe<Scalars['Int']['output']>;
};

export type PlatesData = {
  __typename?: 'PlatesData';
  data: Array<Plates>;
};

export type PlatesDataResponse = {
  __typename?: 'PlatesDataResponse';
  response?: Maybe<Array<Maybe<PlatesResponse>>>;
  serverError?: Maybe<ListError>;
};

export type PlatesInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  biTubeWellList?: InputMaybe<Array<InputMaybe<BiTubeWellListInput>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<Scalars['Int']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countOfWells?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  daughterPlateCount?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isAmountSelected?: InputMaybe<Scalars['Boolean']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isConcentrationOther?: InputMaybe<Scalars['Boolean']['input']>;
  isConcentrationSelected?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isPackageTypeOther?: InputMaybe<Scalars['Boolean']['input']>;
  isShippingOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificationsOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['String']['input']>;
  minAmount?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  plateCopiesRange?: InputMaybe<Scalars['String']['input']>;
  plateId?: InputMaybe<Scalars['Int']['input']>;
  plateName?: InputMaybe<Scalars['String']['input']>;
  plateNameError?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  researcher?: InputMaybe<Scalars['String']['input']>;
  researcherNameError?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scale?: InputMaybe<Scalars['String']['input']>;
  selectedPackageType?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['String']['input']>;
  stockPlate?: InputMaybe<Scalars['String']['input']>;
  totalBaseCount?: InputMaybe<Scalars['Int']['input']>;
  wellList: Array<WelllistInput>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type PlatesPriceResponse = {
  __typename?: 'PlatesPriceResponse';
  response?: Maybe<Array<Maybe<PlatePrice>>>;
  serverError?: Maybe<ListError>;
};

export type PlatesResponse = {
  __typename?: 'PlatesResponse';
  biTubeWellList?: Maybe<Array<Maybe<BiTubeWelllistResponse>>>;
  error?: Maybe<Scalars['String']['output']>;
  wellList?: Maybe<Array<Maybe<WelllistResponse>>>;
};

export type PlatesTotalValidationInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countOfWells?: InputMaybe<Scalars['Int']['input']>;
  daughterPlateCount?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isConcentrationOther?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isPackageTypeOther?: InputMaybe<Scalars['Boolean']['input']>;
  isShippingOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificationsOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  plateId?: InputMaybe<Scalars['Int']['input']>;
  plateName?: InputMaybe<Scalars['String']['input']>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  selectedPackageType?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['String']['input']>;
  stockPlate?: InputMaybe<Scalars['String']['input']>;
  wellList: Array<WelllItemInput>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type PosPaymentDataInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  lineItemList: Array<PaymentListItemInput>;
  payerNo?: InputMaybe<Scalars['String']['input']>;
  paymentCard: Scalars['String']['input'];
  soldTo?: InputMaybe<Scalars['String']['input']>;
  totalFormattedAmount?: InputMaybe<Scalars['String']['input']>;
};

export type PosPaymentDataResponse = {
  __typename?: 'PosPaymentDataResponse';
  lineItemList: Array<Invoice>;
  paymentCardURL: Scalars['String']['output'];
  transactionNo: Scalars['String']['output'];
};

export type PriceInputKicqstart = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type PriceInputSiRna = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PriceResponseKicqStart = {
  __typename?: 'PriceResponseKicqStart';
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  serverError?: Maybe<ServerError>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type PriceResponseSiRna = {
  __typename?: 'PriceResponseSiRNA';
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ServerError>;
};

export type Pricing = {
  __typename?: 'Pricing';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type PricingAndAvailabilityModel = {
  __typename?: 'PricingAndAvailabilityModel';
  alternateMaterials?: Maybe<Array<Maybe<AlternateMaterials>>>;
  dchainMessage?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<ErrorMsg>;
  hideAddToCart?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PricingAvailabilityItem>>>;
  product?: Maybe<Scalars['String']['output']>;
  productInfo?: Maybe<Array<Maybe<ProductInfo>>>;
};

export type PricingAvailabilityItem = {
  __typename?: 'PricingAvailabilityItem';
  additionalInfo?: Maybe<CartAdditionalInfo>;
  availabilityMsg?: Maybe<AvailabilityMsg>;
  availableQtyInStock?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  commodityCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dchainCode?: Maybe<Scalars['String']['output']>;
  eligibleForBuyItNow?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  extItemNum?: Maybe<Scalars['String']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  isBlockedProduct?: Maybe<Scalars['Boolean']['output']>;
  isFreeFreight?: Maybe<Scalars['Boolean']['output']>;
  isPBAvailable?: Maybe<Scalars['Boolean']['output']>;
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  isSameDayShippingAvailable?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  leadTime?: Maybe<Scalars['Int']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  listPriceCurrency?: Maybe<Scalars['String']['output']>;
  marketplace_offer_id?: Maybe<Scalars['String']['output']>;
  marketplace_seller_id?: Maybe<Scalars['String']['output']>;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  minOrderQuantity?: Maybe<Scalars['Int']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  packageSize?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  packaging?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricePerUom?: Maybe<Scalars['Float']['output']>;
  pricingDisplay?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productGroupSBU?: Maybe<Scalars['String']['output']>;
  productHierarchy?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vendorSKU?: Maybe<Scalars['String']['output']>;
};

export type Primer = {
  __typename?: 'Primer';
  ampliconSize?: Maybe<Scalars['String']['output']>;
  exons?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  primerPairId?: Maybe<Scalars['String']['output']>;
  primerSeqFwd?: Maybe<Scalars['String']['output']>;
  primerSeqRev?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  refSeq?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type PrintInvoiceInput = {
  payer: Scalars['String']['input'];
  resultDate: Scalars['String']['input'];
  transactionNumber: Scalars['String']['input'];
};

export type PrintInvoiceItem = {
  __typename?: 'PrintInvoiceItem';
  billingDoc: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  invoiceQty: Scalars['String']['output'];
  itemNo?: Maybe<Scalars['String']['output']>;
  materialDesc?: Maybe<Scalars['String']['output']>;
  materialNo?: Maybe<Scalars['String']['output']>;
  netValue: Scalars['Float']['output'];
  salesUnit?: Maybe<Scalars['String']['output']>;
  shipHandCrg: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type PrintInvoiceResponse = {
  __typename?: 'PrintInvoiceResponse';
  currency: Scalars['String']['output'];
  invoiceItems: Array<PrintInvoiceItem>;
  netTotal?: Maybe<Scalars['Float']['output']>;
  otherCost?: Maybe<Scalars['Float']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['Date']['output'];
  subTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export enum Priority {
  Critical = 'Critical',
  Informational = 'Informational',
  Promotional = 'Promotional'
}

export type Product = {
  __typename?: 'Product';
  aliases: Array<Alias>;
  applications: Array<Scalars['String']['output']>;
  attributeDifferences?: Maybe<Array<Scalars['String']['output']>>;
  attributes: Array<ProductAttribute>;
  badge?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  browserMetadata?: Maybe<BrowserMetadata>;
  cardAttribute?: Maybe<CardAttribute>;
  cardCategory?: Maybe<Scalars['String']['output']>;
  casNumber?: Maybe<Scalars['String']['output']>;
  catalogId?: Maybe<CatalogType>;
  compliance: Array<Compliance>;
  complianceJp: Array<ComplianceJp>;
  complianceReach: Array<ComplianceReach>;
  components: MappedProductComponent;
  customPdpId: Scalars['String']['output'];
  customersAlsoViewedProducts: Array<Product>;
  description?: Maybe<Scalars['String']['output']>;
  descriptions: Array<ProductDescription>;
  discount?: Maybe<Scalars['String']['output']>;
  displaySellerName?: Maybe<Scalars['String']['output']>;
  empiricalFormula?: Maybe<Scalars['String']['output']>;
  erpProductKey: Scalars['String']['output'];
  erp_type?: Maybe<Array<Scalars['String']['output']>>;
  faqs: Array<Faq>;
  features: Array<Scalars['String']['output']>;
  forms?: Maybe<Array<Form>>;
  fullName: Scalars['String']['output'];
  gaProductCode?: Maybe<Scalars['String']['output']>;
  geneVariants: Array<GeneVariant>;
  hasEmproveDoc?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<CatalogImage>;
  isBBE?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace: Scalars['Boolean']['output'];
  isSial: Scalars['Boolean']['output'];
  keyAttributes?: Maybe<Array<ProductAttribute>>;
  lastBoughtUnix?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNameSuffix?: Maybe<Scalars['String']['output']>;
  linearFormula?: Maybe<Scalars['String']['output']>;
  links: Array<DocumentLink>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  marketplaceSellerId?: Maybe<Scalars['String']['output']>;
  materialIds: Array<Scalars['String']['output']>;
  mdlNumber?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paMessage?: Maybe<Scalars['String']['output']>;
  peerPapers: Papers;
  productCategories: Array<Maybe<ProductCategory>>;
  productKey: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
  productRating?: Maybe<ProductRating>;
  productSku?: Maybe<Scalars['String']['output']>;
  productSpecifications?: Maybe<Array<ProductSpecifications>>;
  protocolsAndArticles: ProtocolsArticles;
  recentlyViewedProducts: Array<Product>;
  recommendedProducts: Array<Product>;
  relatedProducts: Array<RelatedProduct>;
  sampleCertificate?: Maybe<Certificate>;
  sdsLanguages: Array<Maybe<Scalars['String']['output']>>;
  sdsPnoKey: Scalars['String']['output'];
  similarity?: Maybe<Scalars['String']['output']>;
  speciesReactivity: Array<Scalars['String']['output']>;
  specificationSheet: SpecificationSheet;
  status?: Maybe<Scalars['String']['output']>;
  substance: Substance;
  substanceCount: Scalars['Int']['output'];
  synonyms: Array<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  txnBadge?: Maybe<TxnBadge>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  seq?: Maybe<Scalars['Int']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  category: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * comparisonAttributes is added to a new type that's composed of a Product
 * rather than to the Product type itself in order to avoid cache collisions in
 * clients (e.g. with dataIdFromObject)
 */
export type ProductComparate = {
  __typename?: 'ProductComparate';
  attributeDifferences?: Maybe<Array<Scalars['String']['output']>>;
  comparisonAttributes: Array<AnalyticsProductAttribute>;
  product: Product;
};

export type ProductComparisonResult = {
  __typename?: 'ProductComparisonResult';
  comparates: Array<ProductComparate>;
};

export type ProductComponent = {
  __typename?: 'ProductComponent';
  brand?: Maybe<Scalars['String']['output']>;
  erpBrandKey?: Maybe<Scalars['String']['output']>;
  erpPnoKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pId?: Maybe<Scalars['String']['output']>;
  pno?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  name?: Maybe<Scalars['String']['output']>;
  sapCharc?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductConfigurationDetail = {
  __typename?: 'ProductConfigurationDetail';
  confType?: Maybe<Scalars['String']['output']>;
  configuration: Array<ProductConfiguration>;
  productType?: Maybe<Scalars['String']['output']>;
};

export type ProductConfigurationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sapCharc?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDescription = {
  __typename?: 'ProductDescription';
  label?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type ProductDocumentsResponse = {
  __typename?: 'ProductDocumentsResponse';
  certificateOfAnalysis?: Maybe<Certificate>;
  certificateOfOrigin?: Maybe<Certificate>;
  product: Product;
  sdsLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  specificationSheet?: Maybe<SpecificationSheet>;
};

export type ProductInfo = {
  __typename?: 'ProductInfo';
  message?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
};

export type ProductInfoMessage = {
  __typename?: 'ProductInfoMessage';
  message?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
};

export type ProductInformationResponse = {
  __typename?: 'ProductInformationResponse';
  brand?: Maybe<Scalars['String']['output']>;
  companionProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currencyFormat?: Maybe<Scalars['String']['output']>;
  decimalSeparator?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  prefixCurrecny?: Maybe<Scalars['Boolean']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  shippingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thousandSeparator?: Maybe<Scalars['String']['output']>;
  thousandSpacing?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type ProductInput = {
  brandKey: Scalars['String']['input'];
  catalogType?: InputMaybe<CatalogType>;
  productKey: Scalars['String']['input'];
};

export type ProductNumberSuggestions = {
  __typename?: 'ProductNumberSuggestions';
  brand: Brand;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<CatalogImage>;
  name: Scalars['String']['output'];
  productKey: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
};

/**
 * Pricing for a single product, which will return pricing for multiple materials
 * and optionally a single object describing the product's replacement materials,
 * if it is discontinued.
 *
 * Will also return the product number and country the pricing is valid for.
 */
export type ProductPricing = {
  __typename?: 'ProductPricing';
  country: Scalars['String']['output'];
  dchainMessage?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  discontinuedPricingInfo?: Maybe<DiscontinuedMaterialPricing>;
  materialPricing: Array<ValidMaterialPricing>;
  productGroupSBU?: Maybe<Scalars['String']['output']>;
  productInfo?: Maybe<Array<Maybe<ProductInfoMessage>>>;
  productNumber: Scalars['String']['output'];
};

export type ProductPricingCustomerSpecific = {
  __typename?: 'ProductPricingCustomerSpecific';
  products?: Maybe<Array<Maybe<ProductPricingCustomerSpecificProduct>>>;
};

export type ProductPricingCustomerSpecificItem = {
  __typename?: 'ProductPricingCustomerSpecificItem';
  brand?: Maybe<Scalars['String']['output']>;
  cartItemId?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
};

export type ProductPricingCustomerSpecificProduct = {
  __typename?: 'ProductPricingCustomerSpecificProduct';
  dealerId: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<ProductPricingCustomerSpecificItem>>>;
};

export type ProductRating = {
  __typename?: 'ProductRating';
  ratingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductSearchGroup {
  Product = 'product',
  Substance = 'substance'
}

export type ProductSearchInput = {
  catalogType?: InputMaybe<CatalogType>;
  displayLanguage?: InputMaybe<Scalars['String']['input']>;
  facetSet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facets?: InputMaybe<Array<FacetInput>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<ProductSearchGroup>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  pagination?: Pagination;
  region?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<ProductSearchType>;
  variation?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSearchKicqStart = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ProductSearchKicqStartPrimers = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type ProductSearchResults = SearchResults & {
  __typename?: 'ProductSearchResults';
  didYouMeanTerms: Array<Maybe<DidYouMeanTerm>>;
  facets: Array<Facet>;
  items: Array<SearchResultsItems>;
  metadata: SearchResultsMetadata;
};

export type ProductSearchSiRna = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  defaultPurification?: InputMaybe<Scalars['Int']['input']>;
  defaultSize?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ProductSearchTermInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export enum ProductSearchType {
  CasNumber = 'CAS_NUMBER',
  ColorIndex = 'COLOR_INDEX',
  EcNumber = 'EC_NUMBER',
  EgecNumber = 'EGEC_NUMBER',
  FemaNumber = 'FEMA_NUMBER',
  MdlNumber = 'MDL_NUMBER',
  MolForm = 'MOL_FORM',
  Product = 'PRODUCT',
  ProductName = 'PRODUCT_NAME',
  ProductNumber = 'PRODUCT_NUMBER',
  Protocol = 'PROTOCOL',
  SubstanceId = 'SUBSTANCE_ID'
}

export type ProductSpecifications = {
  __typename?: 'ProductSpecifications';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ProfileType {
  B2B = 'B2B',
  Business = 'Business'
}

export type PromoCodeEligibilityAudienceInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  shipTo?: InputMaybe<Scalars['String']['input']>;
  shippingEmail?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
};

export type PromoCodeEligibilityRequestInput = {
  audience?: InputMaybe<PromoCodeEligibilityAudienceInput>;
  materials: Array<Scalars['String']['input']>;
};

export type PromoEligibility = {
  __typename?: 'PromoEligibility';
  hidePromoDetailsForAnonUser?: Maybe<Scalars['Boolean']['output']>;
  terms: PromoEligibilityTerms;
  uuid: Scalars['String']['output'];
};

export type PromoEligibilityEntry = {
  __typename?: 'PromoEligibilityEntry';
  data?: Maybe<PromoEligibility>;
  sku: Scalars['String']['output'];
};

export type PromoEligibilityResponse = {
  __typename?: 'PromoEligibilityResponse';
  skus: Array<PromoEligibilityEntry>;
};

export type PromoEligibilityTerms = {
  __typename?: 'PromoEligibilityTerms';
  currency?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  promoCode: Scalars['String']['output'];
  promoType: Scalars['String']['output'];
  qualifierType?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<PromoTier>>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type PromoItem = {
  __typename?: 'PromoItem';
  itemIdentifier?: Maybe<Scalars['String']['output']>;
};

export type PromoItemPricingAvailabilityInput = {
  product: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type PromoItemsPricingAvailabilityRequestInput = {
  productDetails: Array<PromoItemPricingAvailabilityInput>;
};

export type PromoItemsPricingAvailabilityResponse = {
  __typename?: 'PromoItemsPricingAvailabilityResponse';
  country?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  pricingAndAvailabilityModels?: Maybe<Array<Maybe<PricingAndAvailabilityModel>>>;
};

export type PromoItemsRequestInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};

export type PromoItemsResponse = {
  __typename?: 'PromoItemsResponse';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<PromoItem>>>;
  message?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PromoTermsRequestInput = {
  uuid: Scalars['String']['input'];
};

export type PromoTermsResponse = {
  __typename?: 'PromoTermsResponse';
  currency?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promoType?: Maybe<Scalars['String']['output']>;
  qualifierType?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<PromoTier>>>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type PromoTier = {
  __typename?: 'PromoTier';
  discount: Scalars['Int']['output'];
  qualifyingAmount: Scalars['Int']['output'];
  tier: Scalars['Int']['output'];
};

export type PromotionalBundle = {
  __typename?: 'PromotionalBundle';
  bundleDescription?: Maybe<Scalars['String']['output']>;
  bundleEndDate: Scalars['String']['output'];
  bundleId: Scalars['String']['output'];
  bundleItems: Array<PromotionalBundleItem>;
  bundleName?: Maybe<Scalars['String']['output']>;
  bundleStartDate: Scalars['String']['output'];
  countries: Array<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  noOfItems: Scalars['Int']['output'];
  promotionalBundleId: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type PromotionalBundleItem = {
  __typename?: 'PromotionalBundleItem';
  discount?: Maybe<Scalars['Float']['output']>;
  materialIds?: Maybe<Array<Scalars['String']['output']>>;
  materialNumber: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  showOnPdp: Scalars['Boolean']['output'];
};

export type PromotionalBundleItemPricing = {
  __typename?: 'PromotionalBundleItemPricing';
  availabilityMessages?: Maybe<Array<Maybe<MaterialAvailability>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandKey?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Material>;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  product?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  yourPrice?: Maybe<Scalars['Float']['output']>;
};

export type PromotionalBundlePricing = {
  __typename?: 'PromotionalBundlePricing';
  bundleItems: Array<PromotionalBundleItemPricing>;
  currency: Scalars['String']['output'];
  listPrice?: Maybe<Scalars['Float']['output']>;
  promotionalBundleId?: Maybe<Scalars['String']['output']>;
  yourPrice?: Maybe<Scalars['Float']['output']>;
};

export type PromotionalMessage = {
  __typename?: 'PromotionalMessage';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
};

export type ProtocolArticleDocument = {
  __typename?: 'ProtocolArticleDocument';
  contentType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProtocolsAndArticlesInput = {
  term: Scalars['String']['input'];
};

export type ProtocolsArticles = {
  __typename?: 'ProtocolsArticles';
  articles: Array<Maybe<ProtocolArticleDocument>>;
  protocols: Array<Maybe<ProtocolArticleDocument>>;
  relatedContent: Array<Maybe<ProtocolArticleDocument>>;
};

export enum ProtocolsArticlesContentType {
  Article = 'article',
  Protocol = 'protocol',
  RelatedContent = 'relatedContent'
}

export type PurchasingPartnerAccount = {
  __typename?: 'PurchasingPartnerAccount';
  accountNumber: Scalars['String']['output'];
  attentionTo: Scalars['String']['output'];
  buildingRoom: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  customerServiceNotes?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  partnerNumber: Scalars['String']['output'];
  pinnedIndex?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  salesOrg: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddresses: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Purification = {
  __typename?: 'Purification';
  Desalt?: Maybe<Scalars['String']['output']>;
  HPLC?: Maybe<Scalars['String']['output']>;
  Puredit?: Maybe<Scalars['String']['output']>;
  Standard?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type PushSubscription = {
  __typename?: 'PushSubscription';
  endpoint: Scalars['String']['output'];
  keys: PushSubscriptionKeys;
};

export type PushSubscriptionInput = {
  endpoint: Scalars['String']['input'];
  expirationTime?: InputMaybe<Scalars['Float']['input']>;
  keys: PushSubscriptionKeysInput;
};

export type PushSubscriptionKeys = {
  __typename?: 'PushSubscriptionKeys';
  auth: Scalars['String']['output'];
  p256dh: Scalars['String']['output'];
};

export type PushSubscriptionKeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type QualityDocument = {
  __typename?: 'QualityDocument';
  brand: Scalars['String']['output'];
  contentJSON?: Maybe<Scalars['String']['output']>;
  contentType: QualityDocumentContentType;
  contentURI?: Maybe<Scalars['String']['output']>;
  documentType: QualityDocumentType;
  lotNumber: Scalars['String']['output'];
  product?: Maybe<Product>;
  productNumber: Scalars['String']['output'];
};

export enum QualityDocumentContentType {
  Content = 'content',
  Html = 'html',
  SignedUrl = 'signed_url'
}

export type QualityDocumentPageInfo = {
  __typename?: 'QualityDocumentPageInfo';
  isLast: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QualityDocumentSearch = {
  __typename?: 'QualityDocumentSearch';
  documents: Array<QualityDocument>;
  metadata: QualityDocumentSearchMetadata;
  pageInfo: QualityDocumentPageInfo;
};

export type QualityDocumentSearchMetadata = {
  __typename?: 'QualityDocumentSearchMetadata';
  documentType: QualityDocumentType;
  lotNumber: Scalars['String']['output'];
  productNumber?: Maybe<Scalars['String']['output']>;
};

export enum QualityDocumentType {
  Coa = 'COA',
  Coo = 'COO',
  Coq = 'COQ',
  Spec = 'SPEC'
}

export type Query = {
  __typename?: 'Query';
  /** dummy value required for schema merging */
  _?: Maybe<Scalars['String']['output']>;
  aemHeaderFooter?: Maybe<AemHeaderFooter>;
  aemHomepage?: Maybe<Scalars['String']['output']>;
  aemSiteWideMessages: Array<AemSitewideMessage>;
  aemStaticContent?: Maybe<Scalars['String']['output']>;
  affiliateAccount?: Maybe<AffiliateAccountResponse>;
  amsQuotes: AmsQuotesPayload;
  bitubeEditLink?: Maybe<BiTubeData>;
  checkPromoEligibility?: Maybe<PromoEligibilityResponse>;
  checkTermCondition?: Maybe<TermConditionResponse>;
  contractCardTransactions?: Maybe<ContractCardTransactionsPayload>;
  contractPaymentMethod: ContractPaymentMethod;
  customCrisprEditLink?: Maybe<CrisprSessionResponse>;
  customerSearch: Array<PartnerAccount>;
  fapiaoSearch: FapiaoSearchPayload;
  fetchMaterialsDirectOrderComments?: Maybe<MaterialsDirectComments>;
  fetchMaterialsDirectOrderDelivery?: Maybe<MaterialsDirectOrderDeliveryResponse>;
  fetchMaterialsDirectOrders: MaterialsDirectResponse;
  fetchMaterialsDirectOrdersCSV: MaterialsDirectCsvResponse;
  fetchMaterialsDirectPackingSlip?: Maybe<MaterialsDirectPackingSlipResponse>;
  fetchSavedOrder: SavedOrderResponse;
  fetchSavedOrders: Array<SavedOrderResponse>;
  filters?: Maybe<FiltersResponse>;
  geneArrayPrimerSearch?: Maybe<GeneArrayWellSearchData>;
  get2c2pInquirePayment: Get2c2pPaymentResponse;
  get2c2pPaymentResponse: Get2c2pPaymentResponse;
  getAEMDiscountedProducts?: Maybe<AssociatedProducts>;
  getAllCarts: Array<Cart>;
  getAntisenceSeq?: Maybe<AntisenceSeq>;
  getAuthIdToken?: Maybe<Scalars['String']['output']>;
  getAutoCompleteCertificate?: Maybe<AutoCompleteCertificateResponse>;
  getAvailabilityForMaterial: MaterialAvailabilities;
  getAzureJWTToken?: Maybe<AzureTokenResponse>;
  getB2BPunchOutLogoffData: B2bShoppingCartDataResponse;
  getB2bShoppingCart: B2bShoppingCartDataResponse;
  getB2bUserDetails?: Maybe<B2bUserResponse>;
  getBestSellerProducts?: Maybe<AssociatedProducts>;
  getBestSellerProductsByRegion?: Maybe<AssociatedProducts>;
  getBitubeData?: Maybe<BiTubeData>;
  getBuyItAgainProducts?: Maybe<AssociatedProducts>;
  getCart: Cart;
  getCartRecommendedProducts?: Maybe<AssociatedProducts>;
  getCertificateContent?: Maybe<CertificateContent>;
  getCertificateOfAnalysis: Certificate;
  getCertificateOfOrigin: Certificate;
  getChatConfig?: Maybe<Array<Maybe<ChatConfigResponse>>>;
  getCompareSimilarItems: Array<Maybe<Product>>;
  getComplianceRegulationMappingList: Array<ComplianceObj>;
  getConfContactDetails?: Maybe<ConfContactDetailsResponse>;
  getConsolidationOrders: Array<ConsolidationOrder>;
  getContactAccounts: Array<PartnerAccount>;
  getContentDocuments: ContentDocumentSearchResponse;
  getContentProductDocuments: ContentProductDocumentsResponse;
  getCountryDetails?: Maybe<CountryAccountSetup>;
  getCountryGuestShoppingType?: Maybe<Scalars['String']['output']>;
  getCountryStates: Array<Maybe<CountryStates>>;
  getCoworkerDetails?: Maybe<MynetworkResponse>;
  getCoworkersGroup?: Maybe<Array<Maybe<CoworkerGroupResponse>>>;
  getCoworkersGroupDetails?: Maybe<CoworkerGroupDetailResponse>;
  getCoworkersList?: Maybe<Array<Maybe<MynetworkResponse>>>;
  getCreditCardPaymentInvoices: CreditCardPaymentInvoiceResponse;
  getCreditCards: CreditCardResponse;
  getCrisprPriceCall?: Maybe<CrisprPriceResponse>;
  getCrisprSessionData?: Maybe<CrisprSessionResponse>;
  getCustomOligoProducts?: Maybe<CustomOligoProductResponse>;
  getCustomerPricingForProduct: ProductPricingCustomerSpecific;
  getCustomerSupportInfo: CustomerServiceContactInfo;
  getCustomersAlsoViewedProducts?: Maybe<AssociatedProducts>;
  getDealerApprovers: Array<Maybe<DealerApprover>>;
  getDealerById: Dealer;
  getDealerRequests: GetDealerRequestsPayload;
  getDealerTerms: Array<DealerTermsResponse>;
  getDealers: Array<Dealer>;
  getDocLib: DocLibPayload;
  getDocLibSavedDocs: DocLibSavedDocsResponse;
  getDropDownList: CrisprSpecificatios;
  getEmproveSuiteDocs: EmproveSuiteDocsResponse;
  getEmproveUserData?: Maybe<EmproveUserData>;
  getEmproveUserDataV2?: Maybe<EmproveUserData>;
  getFacets?: Maybe<FacetSearchResponse>;
  getFapiaoList: GetFapiaoListPayload;
  getFedexTrackingInfo: ShipmentTrackingResponse;
  getGTINMaterials?: Maybe<Material>;
  getGTINMaterialsPDP?: Maybe<Array<GtinMaterialPdp>>;
  getGeneArraySessionData?: Maybe<GeneArraySearchData>;
  getGeneBySymbol?: Maybe<Gene>;
  getGeneSearchResults: GeneSearchResults;
  getGuestToken: Scalars['String']['output'];
  getHolidayCalendar: Array<HolidayCalendar>;
  getInvitationDetails?: Maybe<InviteCoworkerResponse>;
  getInviteEligibility?: Maybe<Scalars['Boolean']['output']>;
  getInvoiceAutoSuggest?: Maybe<InvoiceAutoSuggestResponse>;
  getInvoiceList: InvoiceListResponse;
  getInvoices: InvoiceResponse;
  getLabWaterAccessoriesConsumablesServices?: Maybe<LabWaterAccessoriesConsumablesServices>;
  getLabWaterSelection: LabWaterSelection;
  getLabWaterSession?: Maybe<LabWaterSession>;
  getLabWaterSubApplications: Array<LabWaterSubApplications>;
  getLabWaterSystemFeatures: Array<LabWaterSystemFeatures>;
  getLabWaterValidation?: Maybe<LabWaterValidation>;
  getMaterialDetail?: Maybe<Material>;
  getMaterialsDetail: Array<Maybe<Material>>;
  getMergeAnonymousCart: Scalars['Boolean']['output'];
  getMetadataForFFCertificates?: Maybe<FfCertificateProduct>;
  getMilliQSqBasePrice?: Maybe<MilliQSqBasePriceData>;
  getMilliQSqData?: Maybe<MilliQSqData>;
  getMilliplex?: Maybe<MilliplexResponse>;
  getMilliplexKitAnalytesAndSampleType?: Maybe<MilliplexKitAndSampleTypeResponse>;
  getMilliplexKits?: Maybe<MilliplexKitsResponse>;
  getMilliplexSearchCriteriaList?: Maybe<MilliplexSearchCriteriaResponse>;
  getMilliplexSessionData?: Maybe<MilliplexSessionDataResponse>;
  getMilliqSqSession?: Maybe<MilliqSqSessionResponse>;
  getModificationAndSpecifications?: Maybe<ModificationsAndSpecificationsResponse>;
  getModifications?: Maybe<ConfiguratorPlates>;
  getMpayInvoices: MpayInvoiceResponse;
  getMpayPaymentHistory: MpayPaymentHistoryResponse;
  getMultiSharedList: Array<Maybe<SharedListDetail>>;
  getMultipleProductDetails: Array<Maybe<Product>>;
  getNewCart?: Maybe<NewCart>;
  getNewCarts: Array<NewCart>;
  getNewCategoryProductSearchResults?: Maybe<ProductSearchResults>;
  getNewCheckoutShippingMethods: NewCheckoutShippingMethodsResponse;
  getNewProductSearchResults?: Maybe<NewProductSearchResults>;
  getNgsoPriceCall?: Maybe<NgsoPriceResponse>;
  getNotifications: Array<NotificationsResponse>;
  getOrderAssessments: OrderAssessmentsResponse;
  getOrderNotes?: Maybe<OrderNotesResponse>;
  getOrfDropDownList: OrfSpecifications;
  getOrfSearchTerm: OrfSearchResponse;
  getOrganizationApprovers: FetchOrganizationResponse;
  getOrganizationNameByEmailDomain?: Maybe<Scalars['String']['output']>;
  getOrganizationValidity?: Maybe<Scalars['Boolean']['output']>;
  getPapers: Array<Paper>;
  getPartnerAddressOnPinnedOrder: PinnedPartnerAddresses;
  getPartnerAddresses: PartnerAddresses;
  getPaymentHistory: PaymentHistoryResponse;
  getPaymentMetadata: PaymentMetadataResponse;
  getPinnedAddresses: PinnedAddresses;
  getPipelineDepartments: PipelineOrganizationDepartments;
  getPlatePriceCall?: Maybe<PlatesPriceResponse>;
  getPlateTotalValidation?: Maybe<PlatesDataResponse>;
  getPriceKicqStart?: Maybe<PriceResponseKicqStart>;
  getPriceSiRNA?: Maybe<PriceResponseSiRna>;
  getPricingForMaterial: MaterialPricing;
  getPricingForMultiCountryProducts: Array<Maybe<ProductPricing>>;
  getPricingForMultipleProducts: Array<ProductPricing>;
  getPricingForProduct: ProductPricing;
  getPricingForPromotionalBundle: PromotionalBundlePricing;
  getPrimerSessionData?: Maybe<KicqStartPrimerSessionData>;
  getPrintInvoice: PrintInvoiceResponse;
  getProductComparison?: Maybe<ProductComparisonResult>;
  getProductDetail?: Maybe<Product>;
  getProductDocuments?: Maybe<ProductDocumentsResponse>;
  getProductInformation?: Maybe<ProductInformationResponse>;
  getProductNumberSearchSuggestions?: Maybe<GetProductNumberSearchSuggestions>;
  getProductPapers: Papers;
  getProductProtocolsAndArticles: ProtocolsArticles;
  getProductSearchResults: ProductSearchResults;
  getProfileToken: Scalars['String']['output'];
  getPromoItems?: Maybe<PromoItemsResponse>;
  getPromoItemsPricingAvailability?: Maybe<PromoItemsPricingAvailabilityResponse>;
  getPromoTerms?: Maybe<PromoTermsResponse>;
  getPromotionalBundlesForProduct?: Maybe<Array<PromotionalBundle>>;
  getQualityDocument: QualityDocument;
  getQualityDocumentSearch: QualityDocumentSearch;
  getQualityDocuments: Array<QualityDocument>;
  getQuickOrderItems: Array<QuickOrderItemsResponse>;
  getQuickOrderRecommendedProducts?: Maybe<AssociatedProducts>;
  getQuotesCount: GetQuotesCountPayload;
  getRecentOrdersCount: GetRecentOrdersCountPayload;
  getRecentlyViewedDocs: Array<Maybe<Product>>;
  getRecentlyViewedProducts?: Maybe<AssociatedProducts>;
  getRecommendedProducts?: Maybe<AssociatedProducts>;
  getRecommendedProductsAlt?: Maybe<AssociatedProducts>;
  getRegions: Array<RegionResponse>;
  getRelatedProducts?: Maybe<AssociatedProducts>;
  getRequesters: GetRequestersPayload;
  getSampleCertificate: Certificate;
  getSangerDropDownList: SangerCrisprSpecificatios;
  getSangerSearchTerm: SangerConfigurations;
  getSavedCart: SavedCartData;
  getSavedCarts: SavedCartsDataResponse;
  getSavedForLater: Array<SaveForLaterResponse>;
  getSavedProtocols: Array<Maybe<SavedProtocolsResponse>>;
  getSavedRegistrationInfo?: Maybe<UserSavedRegistration>;
  getSdsBulkCertificateSearch?: Maybe<SdsBulkSearchResponse>;
  getSdsCertificateRetrieve?: Maybe<SdsRetrieveResponse>;
  getSdsCertificateSearch?: Maybe<SdsSearchResponse>;
  getSearchKicqStart?: Maybe<SearchResponseKicqStart>;
  getSearchKicqStartPrimersData?: Maybe<SearchResponseKicqStartPrimers>;
  getSearchSiRNA?: Maybe<SearchResponseSiRna>;
  getSearchSuggestions?: Maybe<GetSearchSuggestionResponse>;
  getSearchTerm: SemiConfigurations;
  getSemiConfSessionData?: Maybe<SemiConfSessionData>;
  getSemiConfigDropDownList: SemiConfigSpecifications;
  getSemiConfigPrice?: Maybe<SemiConfigPriceCall>;
  getSemiConfigSearch: SemiConfigSearchResult;
  getSessionData?: Maybe<TubeDataFromSession>;
  getSessionDataForPlates?: Maybe<PlatesData>;
  getSharedList?: Maybe<SharedListDetail>;
  getSharedListInvitations: SharedListsPayload;
  getSharedLists: SharedListsPayload;
  getShipmentTrackingInfo: ShipmentTrackingResponse;
  getShipmentTrackingRecommendedProducts?: Maybe<AssociatedProducts>;
  getShrnaDropDownList: ShrnaSpecifications;
  getShrnaSearchTerm: ShrnaSemiConfigurations;
  getSoftwareLicenses?: Maybe<SoftwareLicensesResponse>;
  getSoldToAccounts: Array<PartnerAccount>;
  getSpecificationCalculation?: Maybe<SpecificationsResponse>;
  getSpecificationSheet?: Maybe<SpecificationSheet>;
  getSpecifications?: Maybe<Configurations>;
  getSpecificationsForCustomCrispr?: Maybe<Configurations>;
  getSpotData?: Maybe<Array<Maybe<SpotOffer>>>;
  getSrpRecommendedProducts?: Maybe<AssociatedProducts>;
  getStockAvailability: StockAvailabilityResults;
  getStructureSearchResults: StructureSearchResults;
  getSubItemPriceSiRNA?: Maybe<SubsetItemPrice>;
  getSubscriptionById: SubscriptionIdData;
  getSubscriptions: Array<SubscriptionItem>;
  getSubstanceById?: Maybe<Substance>;
  getTrackingInfo: GetTrackingInfoPayload;
  getTubeRuleValidateFields: TubeRuleValidateResponse;
  getTubeTotalValidation?: Maybe<Array<TubeTotalValidationResponse>>;
  getUserActivity?: Maybe<Array<UserActivityEntry>>;
  getUserDetailByToken?: Maybe<UserByToken>;
  getUserPushSubscriptions: Array<UserPushSubscription>;
  getVectorDocument?: Maybe<VectorDocument>;
  getWIMSTokenInfo?: Maybe<WimsTokenInfoResponse>;
  getWebinarsLearningCenter?: Maybe<Array<Maybe<Webinars>>>;
  getplatePriceCalculation?: Maybe<PlatesPriceResponse>;
  invoicePDF: Scalars['String']['output'];
  me: User;
  milliplexSearchAnalytes?: Maybe<MilliplexSearchResponse>;
  multipleQuoteDetails: Array<Maybe<QuoteDetails>>;
  omsAccessToken?: Maybe<Login>;
  omsCurrentUser?: Maybe<OmsCurrentUserResponse>;
  orderConfirmationPDF: Scalars['String']['output'];
  orderDetail: GetOrderDetailPayload;
  orderSearch: OrderSearchPayload;
  orderShareableLink: Scalars['String']['output'];
  ordersPendingApproval: OrdersForApproval;
  pdfDownload?: Maybe<Scalars['String']['output']>;
  quoteDetail: QuoteDetailPayload;
  quotePDF: Scalars['String']['output'];
  quoteSearch: QuoteSearchPayload;
  quoteShareableLink: Scalars['String']['output'];
  recentOrderItems: RecentOrderItemsPayload;
  registeredUser?: Maybe<RegisteredUser>;
  searchGeneArrayData?: Maybe<GeneArraySearchData>;
  searchPapers: PaperSearchResponse;
  sellerContactContent?: Maybe<SellerContactContent>;
  sellerStaticContent: SellerResponse;
  siteWideMessages: Array<SitewideMessage>;
  submitTrialLicense?: Maybe<Scalars['Boolean']['output']>;
  subscriptionFrequencies: Array<Scalars['String']['output']>;
  tubeEditLink?: Maybe<TubeDataFromSession>;
  verifySoftwareLicense?: Maybe<Scalars['Boolean']['output']>;
  webOrders: WebOrdersPayload;
  webQuotes: WebQuotesPayload;
};


export type QueryAemHomepageArgs = {
  path: Scalars['String']['input'];
};


export type QueryAemSiteWideMessagesArgs = {
  input: AemSitewideMessageInput;
};


export type QueryAemStaticContentArgs = {
  path: Scalars['String']['input'];
};


export type QueryAffiliateAccountArgs = {
  customernumber?: InputMaybe<Scalars['String']['input']>;
  customerpin?: InputMaybe<Scalars['String']['input']>;
  invoicenumber?: InputMaybe<Scalars['String']['input']>;
  ordernumber?: InputMaybe<Scalars['String']['input']>;
  packingslipnumber?: InputMaybe<Scalars['String']['input']>;
  quotereferencenumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAmsQuotesArgs = {
  input: AmsQuotesInput;
};


export type QueryBitubeEditLinkArgs = {
  product?: InputMaybe<TubeEditInput>;
};


export type QueryCheckPromoEligibilityArgs = {
  input: PromoCodeEligibilityRequestInput;
};


export type QueryCheckTermConditionArgs = {
  input?: InputMaybe<OmsGuestInput>;
};


export type QueryContractCardTransactionsArgs = {
  input: ContractCardTransactionsInput;
};


export type QueryCustomCrisprEditLinkArgs = {
  product: ConfiguratorProductInput;
};


export type QueryCustomerSearchArgs = {
  input: CustomerSearchInput;
};


export type QueryFapiaoSearchArgs = {
  input: FapiaoSearchInput;
};


export type QueryFetchMaterialsDirectOrderCommentsArgs = {
  input: MaterialsDirectOrderCommentsInput;
};


export type QueryFetchMaterialsDirectOrderDeliveryArgs = {
  input: MaterialsDirectOrderDeliveryInput;
};


export type QueryFetchMaterialsDirectOrdersArgs = {
  input: MaterialsDirectInput;
};


export type QueryFetchMaterialsDirectOrdersCsvArgs = {
  input: MaterialsDirectCsvInput;
};


export type QueryFetchMaterialsDirectPackingSlipArgs = {
  input: MaterialsDirectPackingSlipInput;
};


export type QueryFetchSavedOrderArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryFiltersArgs = {
  input?: InputMaybe<OmsGuestInput>;
};


export type QueryGeneArrayPrimerSearchArgs = {
  input?: InputMaybe<GeneArrayWellSearchInput>;
  product?: InputMaybe<SemiConfiguratorProductInput>;
};


export type QueryGet2c2pInquirePaymentArgs = {
  tempOrderId: Scalars['String']['input'];
};


export type QueryGet2c2pPaymentResponseArgs = {
  tempOrderId: Scalars['String']['input'];
};


export type QueryGetAemDiscountedProductsArgs = {
  input: GetAemDiscountedProductsInput;
};


export type QueryGetAntisenceSeqArgs = {
  product: ConfiguratorProductInput;
  seq: Scalars['String']['input'];
};


export type QueryGetAuthIdTokenArgs = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  p?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAutoCompleteCertificateArgs = {
  input: AutoCompleteCertificateInput;
};


export type QueryGetAvailabilityForMaterialArgs = {
  input: GetPricingForMaterialInput;
};


export type QueryGetAzureJwtTokenArgs = {
  input: AzureTokenInput;
};


export type QueryGetB2bShoppingCartArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetB2bUserDetailsArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetBestSellerProductsArgs = {
  input: GetBestSellerProductsInput;
};


export type QueryGetBestSellerProductsByRegionArgs = {
  input: GetBestSellerProductsByRegionInput;
};


export type QueryGetBitubeDataArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetBuyItAgainProductsArgs = {
  input: GetBuyItAgainProductsInput;
};


export type QueryGetCartArgs = {
  id: CartRequestAction;
};


export type QueryGetCartRecommendedProductsArgs = {
  input: GetCartRecommendedProductsInput;
};


export type QueryGetCertificateContentArgs = {
  input?: InputMaybe<CertificateContentInput>;
};


export type QueryGetCertificateOfAnalysisArgs = {
  input: CertificateInput;
};


export type QueryGetCertificateOfOriginArgs = {
  input: CertificateInput;
};


export type QueryGetCompareSimilarItemsArgs = {
  input: GetCompareSimilarItemsInput;
};


export type QueryGetComplianceRegulationMappingListArgs = {
  input: GetComplianceRegMappingListInput;
};


export type QueryGetConfContactDetailsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetContactAccountsArgs = {
  cartType?: InputMaybe<CartRequestAction>;
  input: GetPartnersInput;
};


export type QueryGetContentDocumentsArgs = {
  input: ContentSearchInput;
};


export type QueryGetContentProductDocumentsArgs = {
  input: ContentProductDocumentsInput;
};


export type QueryGetCountryDetailsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCountryGuestShoppingTypeArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCountryStatesArgs = {
  country: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type QueryGetCoworkerDetailsArgs = {
  input?: InputMaybe<GetCoworkerDetailsInput>;
};


export type QueryGetCoworkersGroupDetailsArgs = {
  input?: InputMaybe<GetGroupInput>;
};


export type QueryGetCoworkersListArgs = {
  input?: InputMaybe<GetMynetworkInput>;
};


export type QueryGetCreditCardPaymentInvoicesArgs = {
  input?: InputMaybe<CreditCardPaymentSearchInput>;
};


export type QueryGetCrisprPriceCallArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetCrisprSessionDataArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetCustomOligoProductsArgs = {
  input: ConfiguratorProductInput;
};


export type QueryGetCustomerPricingForProductArgs = {
  input: GetCustomerPricingForProductInput;
};


export type QueryGetCustomersAlsoViewedProductsArgs = {
  input: GetCustomersAlsoViewedProductsInput;
};


export type QueryGetDealerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDealerRequestsArgs = {
  input?: InputMaybe<DealerRequestsSearchInput>;
};


export type QueryGetDealerTermsArgs = {
  dealerIds: Array<Scalars['String']['input']>;
};


export type QueryGetDealersArgs = {
  countryCode: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDocLibArgs = {
  input: DocLibInput;
};


export type QueryGetDropDownListArgs = {
  input?: InputMaybe<DropDownListInput>;
};


export type QueryGetEmproveSuiteDocsArgs = {
  options?: InputMaybe<EmproveSuiteDocsInput>;
};


export type QueryGetEmproveUserDataArgs = {
  input: EmproveUserDataInput;
};


export type QueryGetFacetsArgs = {
  input: FacetSearchInput;
};


export type QueryGetFapiaoListArgs = {
  input: GetFapiaoListInput;
};


export type QueryGetFedexTrackingInfoArgs = {
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGtinMaterialsArgs = {
  input: GetGtinMaterialsInput;
};


export type QueryGetGtinMaterialsPdpArgs = {
  input: GetGtinMaterialsInput;
};


export type QueryGetGeneArraySessionDataArgs = {
  product?: InputMaybe<SemiConfiguratorProductInput>;
};


export type QueryGetGeneBySymbolArgs = {
  input: SymbolInput;
};


export type QueryGetGeneSearchResultsArgs = {
  input: GeneSearchInput;
};


export type QueryGetGuestTokenArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetHolidayCalendarArgs = {
  plant: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetInvitationDetailsArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryGetInviteEligibilityArgs = {
  input?: InputMaybe<InviteEligibilityInput>;
};


export type QueryGetInvoiceAutoSuggestArgs = {
  input?: InputMaybe<OmsGuestInput>;
  keyword: Scalars['String']['input'];
};


export type QueryGetInvoiceListArgs = {
  input?: InputMaybe<InvoiceListInput>;
};


export type QueryGetInvoicesArgs = {
  input: InvoiceInput;
};


export type QueryGetLabWaterAccessoriesConsumablesServicesArgs = {
  input?: InputMaybe<LabWaterAccessoriesConsumablesServicesInput>;
};


export type QueryGetLabWaterSessionArgs = {
  input?: InputMaybe<LabWaterSessionInput>;
};


export type QueryGetLabWaterSystemFeaturesArgs = {
  input?: InputMaybe<LabWaterSystemFeaturesInput>;
};


export type QueryGetLabWaterValidationArgs = {
  input?: InputMaybe<LabWaterValidationInput>;
};


export type QueryGetMaterialDetailArgs = {
  input: GetMaterialDetailInput;
};


export type QueryGetMaterialsDetailArgs = {
  input: GetMaterialsDetailInput;
};


export type QueryGetMergeAnonymousCartArgs = {
  accessToken: Scalars['String']['input'];
  guestToken: Scalars['String']['input'];
};


export type QueryGetMetadataForFfCertificatesArgs = {
  input: GetProductInput;
};


export type QueryGetMilliQSqBasePriceArgs = {
  input?: InputMaybe<MilliQSqBasePriceInput>;
};


export type QueryGetMilliQSqDataArgs = {
  input?: InputMaybe<MilliQSqInput>;
};


export type QueryGetMilliplexArgs = {
  input?: InputMaybe<MilliplexInput>;
};


export type QueryGetMilliplexKitAnalytesAndSampleTypeArgs = {
  input?: InputMaybe<MilliplexKitAndSampleTypeInput>;
};


export type QueryGetMilliplexKitsArgs = {
  input?: InputMaybe<MilliplexInput>;
};


export type QueryGetMilliplexSessionDataArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetMilliqSqSessionArgs = {
  input?: InputMaybe<GetMilliqSqSessionInput>;
};


export type QueryGetModificationAndSpecificationsArgs = {
  product: ConfiguratorProductUserInput;
};


export type QueryGetModificationsArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetMpayInvoicesArgs = {
  input?: InputMaybe<MpayInvoiceInput>;
};


export type QueryGetMultiSharedListArgs = {
  input?: InputMaybe<GetSharedListsInput>;
};


export type QueryGetMultipleProductDetailsArgs = {
  input: MultipleProductInput;
};


export type QueryGetNewCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type QueryGetNewCategoryProductSearchResultsArgs = {
  input?: InputMaybe<NewCategoryProductSearchInput>;
};


export type QueryGetNewCheckoutShippingMethodsArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryGetNewProductSearchResultsArgs = {
  input?: InputMaybe<NewProductSearchInput>;
};


export type QueryGetNgsoPriceCallArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetOrderNotesArgs = {
  input?: InputMaybe<OrderNotesInput>;
};


export type QueryGetOrfDropDownListArgs = {
  input?: InputMaybe<OrfDropDownListInput>;
};


export type QueryGetOrfSearchTermArgs = {
  input?: InputMaybe<OrfProductSearchTermInput>;
};


export type QueryGetOrganizationApproversArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOrganizationNameByEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
};


export type QueryGetOrganizationValidityArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPapersArgs = {
  input: PaperInput;
};


export type QueryGetPartnerAddressOnPinnedOrderArgs = {
  input: PinnedAddressSearchInput;
  participantId: Scalars['String']['input'];
};


export type QueryGetPartnerAddressesArgs = {
  addressBook?: InputMaybe<Scalars['Boolean']['input']>;
  cartType?: InputMaybe<CartRequestAction>;
  country?: InputMaybe<Scalars['String']['input']>;
  input: GetPartnersInput;
  requestSource?: InputMaybe<RequestSource>;
};


export type QueryGetPaymentHistoryArgs = {
  input: PaymentHistorySearchInput;
};


export type QueryGetPaymentMetadataArgs = {
  input?: InputMaybe<PaymentMetadataInput>;
};


export type QueryGetPinnedAddressesArgs = {
  soldTo: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetPipelineDepartmentsArgs = {
  parentOrgID: Scalars['String']['input'];
};


export type QueryGetPlatePriceCallArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetPlateTotalValidationArgs = {
  input: Array<InputMaybe<PlatesTotalValidationInput>>;
  productInput: ConfiguratorProductInput;
};


export type QueryGetPriceKicqStartArgs = {
  input?: InputMaybe<PriceInputKicqstart>;
};


export type QueryGetPriceSiRnaArgs = {
  input?: InputMaybe<PriceInputSiRna>;
};


export type QueryGetPricingForMaterialArgs = {
  input: GetPricingForMaterialInput;
};


export type QueryGetPricingForMultiCountryProductsArgs = {
  input: GetPricingForProductInput;
};


export type QueryGetPricingForMultipleProductsArgs = {
  input: GetPricingForMultipleProductInput;
};


export type QueryGetPricingForProductArgs = {
  input: GetPricingForProductInput;
};


export type QueryGetPricingForPromotionalBundleArgs = {
  input: GetPricingForPromotionalBundle;
};


export type QueryGetPrimerSessionDataArgs = {
  product?: InputMaybe<SemiConfiguratorProductInput>;
};


export type QueryGetPrintInvoiceArgs = {
  input: PrintInvoiceInput;
};


export type QueryGetProductComparisonArgs = {
  input: GetProductComparisonInput;
};


export type QueryGetProductDetailArgs = {
  input: GetProductInput;
};


export type QueryGetProductDocumentsArgs = {
  brand: Scalars['String']['input'];
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};


export type QueryGetProductInformationArgs = {
  input?: InputMaybe<GetProductInformationInput>;
};


export type QueryGetProductNumberSearchSuggestionsArgs = {
  input: GetProductNumberSearchSuggestionsInput;
};


export type QueryGetProductPapersArgs = {
  input: GetProductPapersInput;
};


export type QueryGetProductProtocolsAndArticlesArgs = {
  input: GetProductProtocolsAndArticlesInput;
};


export type QueryGetProductSearchResultsArgs = {
  input: ProductSearchInput;
};


export type QueryGetProfileTokenArgs = {
  idToken?: InputMaybe<Scalars['String']['input']>;
  updateProfile?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPromoItemsArgs = {
  input: PromoItemsRequestInput;
};


export type QueryGetPromoItemsPricingAvailabilityArgs = {
  input: PromoItemsPricingAvailabilityRequestInput;
};


export type QueryGetPromoTermsArgs = {
  input: PromoTermsRequestInput;
};


export type QueryGetPromotionalBundlesForProductArgs = {
  input: GetPromotionalBundlesForProduct;
};


export type QueryGetQualityDocumentArgs = {
  input: GetQualityDocumentInput;
};


export type QueryGetQualityDocumentSearchArgs = {
  input: GetQualityDocumentSearchInput;
};


export type QueryGetQualityDocumentsArgs = {
  input: GetQualityDocumentInput;
};


export type QueryGetQuickOrderRecommendedProductsArgs = {
  input?: InputMaybe<GetQuickOrderRecommendedProductsInput>;
};


export type QueryGetRecentlyViewedDocsArgs = {
  input: GetRecentlyViewedProductsInput;
};


export type QueryGetRecentlyViewedProductsArgs = {
  input: GetRecentlyViewedProductsInput;
};


export type QueryGetRecommendedProductsArgs = {
  input: GetRecommendedProductsInput;
};


export type QueryGetRecommendedProductsAltArgs = {
  input: GetRecommendedProductsAltInput;
};


export type QueryGetRelatedProductsArgs = {
  input: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetRequestersArgs = {
  input?: InputMaybe<GetRequestersInput>;
};


export type QueryGetSampleCertificateArgs = {
  input: SampleCertificateInput;
};


export type QueryGetSangerDropDownListArgs = {
  input?: InputMaybe<SangerDropDownListInput>;
};


export type QueryGetSangerSearchTermArgs = {
  input?: InputMaybe<SangerProductSearchTermInput>;
};


export type QueryGetSavedCartArgs = {
  action?: InputMaybe<SavedCartAction>;
  cartId: Scalars['ID']['input'];
};


export type QueryGetSavedCartsArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSavedForLaterArgs = {
  input?: InputMaybe<SavedForLaterInput>;
};


export type QueryGetSavedRegistrationInfoArgs = {
  input?: InputMaybe<RegistrationInput>;
};


export type QueryGetSdsBulkCertificateSearchArgs = {
  input: SdsBulkSearchInput;
};


export type QueryGetSdsCertificateRetrieveArgs = {
  input: SdsRetrieveInput;
};


export type QueryGetSdsCertificateSearchArgs = {
  input: SdsSearchInput;
};


export type QueryGetSearchKicqStartArgs = {
  input?: InputMaybe<ProductSearchKicqStart>;
};


export type QueryGetSearchKicqStartPrimersDataArgs = {
  input?: InputMaybe<ProductSearchKicqStartPrimers>;
};


export type QueryGetSearchSiRnaArgs = {
  input?: InputMaybe<ProductSearchSiRna>;
};


export type QueryGetSearchSuggestionsArgs = {
  input: GetSearchSuggestionsInput;
};


export type QueryGetSearchTermArgs = {
  input?: InputMaybe<ProductSearchTermInput>;
};


export type QueryGetSemiConfSessionDataArgs = {
  product?: InputMaybe<SemiConfiguratorProductInput>;
};


export type QueryGetSemiConfigDropDownListArgs = {
  input?: InputMaybe<DropDownListInput>;
};


export type QueryGetSemiConfigPriceArgs = {
  input?: InputMaybe<SemiConfigPriceCallInput>;
};


export type QueryGetSemiConfigSearchArgs = {
  input?: InputMaybe<ProductSearchTermInput>;
};


export type QueryGetSessionDataArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetSessionDataForPlatesArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetSharedListArgs = {
  listId: Scalars['ID']['input'];
  showPricing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetSharedListsArgs = {
  input?: InputMaybe<GetSharedListsInput>;
};


export type QueryGetShipmentTrackingInfoArgs = {
  carrierId: CarrierId;
  trackingNumber: Scalars['String']['input'];
};


export type QueryGetShipmentTrackingRecommendedProductsArgs = {
  input: GetShipmentTrackingRecommendedProductsInput;
};


export type QueryGetShrnaDropDownListArgs = {
  input?: InputMaybe<ShrnaDropDownListInput>;
};


export type QueryGetShrnaSearchTermArgs = {
  input?: InputMaybe<ShrnaProductSearchTermInput>;
};


export type QueryGetSoldToAccountsArgs = {
  addressBook?: InputMaybe<Scalars['Boolean']['input']>;
  cartType?: InputMaybe<CartRequestAction>;
  requestSource?: InputMaybe<RequestSource>;
  requestType?: InputMaybe<RequestType>;
  soldTos?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetSpecificationCalculationArgs = {
  input: SpecificationsInput;
  product: ConfiguratorProductInput;
};


export type QueryGetSpecificationSheetArgs = {
  input?: InputMaybe<SpecSheetInput>;
};


export type QueryGetSpecificationsArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetSpecificationsForCustomCrisprArgs = {
  product: ConfiguratorProductInput;
};


export type QueryGetSpotDataArgs = {
  materials?: InputMaybe<Array<InputMaybe<MaterialOfferInput>>>;
};


export type QueryGetSrpRecommendedProductsArgs = {
  input: GetSrpRecommendedProductsInput;
};


export type QueryGetStockAvailabilityArgs = {
  input: StockAvailabilityInput;
};


export type QueryGetStructureSearchResultsArgs = {
  input: StructureSearchInput;
};


export type QueryGetSubItemPriceSiRnaArgs = {
  input?: InputMaybe<SubItemPriceInputSiRna>;
};


export type QueryGetSubscriptionByIdArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryGetSubstanceByIdArgs = {
  input: GetSubstanceByIdInput;
};


export type QueryGetTrackingInfoArgs = {
  input: GetTrackingInfoInput;
};


export type QueryGetTubeRuleValidateFieldsArgs = {
  input: RuleValidateInput;
  productInput: ConfiguratorProductUserInput;
};


export type QueryGetTubeTotalValidationArgs = {
  input: Array<InputMaybe<SessionInput>>;
  productInput: ConfiguratorProductInput;
};


export type QueryGetUserDetailByTokenArgs = {
  input: GetUserByToken;
};


export type QueryGetVectorDocumentArgs = {
  input: VectorDocumentInput;
};


export type QueryGetWimsTokenInfoArgs = {
  participantId: Scalars['String']['input'];
};


export type QueryGetWebinarsLearningCenterArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetplatePriceCalculationArgs = {
  input: Array<InputMaybe<PlatesTotalValidationInput>>;
  productInput: ConfiguratorProductInput;
};


export type QueryInvoicePdfArgs = {
  input: InvoicePdfInput;
};


export type QueryMilliplexSearchAnalytesArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
  product: ConfiguratorProductInput;
};


export type QueryMultipleQuoteDetailsArgs = {
  input?: InputMaybe<WebQuotesInput>;
};


export type QueryOmsAccessTokenArgs = {
  logonId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOmsCurrentUserArgs = {
  input?: InputMaybe<OmsGuestInput>;
};


export type QueryOrderConfirmationPdfArgs = {
  input: OrderConfirmationPdfInput;
};


export type QueryOrderDetailArgs = {
  input: GetOrderDetailInput;
};


export type QueryOrderSearchArgs = {
  input?: InputMaybe<OrderSearchInput>;
};


export type QueryOrderShareableLinkArgs = {
  input: OrderShareableLinkInput;
};


export type QueryPdfDownloadArgs = {
  input: PdfDownloadInput;
};


export type QueryQuoteDetailArgs = {
  input: QuoteDetailInput;
};


export type QueryQuotePdfArgs = {
  input: QuotePdfInput;
};


export type QueryQuoteSearchArgs = {
  input?: InputMaybe<QuoteSearchInput>;
};


export type QueryQuoteShareableLinkArgs = {
  input: QuoteShareableLinkInput;
};


export type QueryRecentOrderItemsArgs = {
  input?: InputMaybe<RecentOrderItemsInput>;
};


export type QuerySearchGeneArrayDataArgs = {
  input?: InputMaybe<GeneArraySearchInput>;
};


export type QuerySearchPapersArgs = {
  input: PaperSearchInput;
};


export type QuerySellerContactContentArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySellerStaticContentArgs = {
  sellerId: Scalars['String']['input'];
};


export type QuerySiteWideMessagesArgs = {
  input: SitewideMessageInput;
};


export type QuerySubmitTrialLicenseArgs = {
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTubeEditLinkArgs = {
  product?: InputMaybe<TubeEditInput>;
};


export type QueryVerifySoftwareLicenseArgs = {
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWebOrdersArgs = {
  input: WebOrdersInput;
};


export type QueryWebQuotesArgs = {
  input: WebQuotesInput;
};

export type QuickOrderItem = {
  materialNumber: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type QuickOrderItemsResponse = {
  __typename?: 'QuickOrderItemsResponse';
  itemId: Scalars['String']['output'];
  materialNumber: Scalars['String']['output'];
  participantId?: Maybe<Scalars['String']['output']>;
  promoCode: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  storeId?: Maybe<Scalars['Int']['output']>;
};

export type Quote = {
  __typename?: 'Quote';
  currency?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['Date']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  orderedBy: Scalars['String']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['ID']['output']>;
  quoteName?: Maybe<Scalars['String']['output']>;
  quotePriceItemExists?: Maybe<Scalars['Boolean']['output']>;
  quoteType?: Maybe<Scalars['String']['output']>;
  readableQuoteId?: Maybe<Scalars['String']['output']>;
  salesDocNumber?: Maybe<Scalars['ID']['output']>;
  sfdcReference?: Maybe<Scalars['String']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  validFrom: Scalars['Date']['output'];
  validTo: Scalars['Date']['output'];
};

export type QuoteConversionInput = {
  isCsr?: InputMaybe<Scalars['Boolean']['input']>;
  isFullQuoteConversion?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CartItemInput>;
  quoteIdentifier: Scalars['String']['input'];
};

export type QuoteDetailInput = {
  isConfirmation: Scalars['Boolean']['input'];
  quoteIdentifier: Scalars['String']['input'];
  sharedToken?: InputMaybe<Scalars['String']['input']>;
  sysId?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteDetailPayload = {
  __typename?: 'QuoteDetailPayload';
  quote: QuoteDetails;
};

export type QuoteDetails = {
  __typename?: 'QuoteDetails';
  alcTax?: Maybe<Scalars['Float']['output']>;
  billingInfo: OrderContactInfo;
  canReturnOrder: Scalars['Boolean']['output'];
  complianceFee?: Maybe<Scalars['Float']['output']>;
  contactInfo: OrderContactDetail;
  createdDate: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  customerServiceNote?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  dutyTotal?: Maybe<Scalars['Float']['output']>;
  electricalFee?: Maybe<Scalars['Float']['output']>;
  eligibleForBuyItNow?: Maybe<Scalars['Boolean']['output']>;
  eurVolatileMassCharge?: Maybe<Scalars['Float']['output']>;
  expirationDate: Scalars['Date']['output'];
  hasQuotePriceItem: Scalars['Boolean']['output'];
  ice?: Maybe<Scalars['Float']['output']>;
  isConvertQuoteToOrderEnabled: Scalars['Boolean']['output'];
  isReorderEnabled: Scalars['Boolean']['output'];
  isRequestNewQuoteEnabled: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  orderedBy: Scalars['String']['output'];
  packingSlipNote?: Maybe<Scalars['String']['output']>;
  pkg?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['ID']['output']>;
  quoteItems: Array<QuoteItem>;
  quoteName?: Maybe<Scalars['String']['output']>;
  quoteType?: Maybe<Scalars['String']['output']>;
  quoteUUID?: Maybe<Scalars['ID']['output']>;
  requisitionNumber?: Maybe<Scalars['String']['output']>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  sfdcReference?: Maybe<Scalars['String']['output']>;
  shippingInfo: OrderContactInfo;
  shippingTransportation?: Maybe<Scalars['Float']['output']>;
  soldTo?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  tariffSurcharge?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  transHandlingCharge?: Maybe<Scalars['Float']['output']>;
  transSurchargeMessage?: Maybe<Scalars['String']['output']>;
};

export type QuoteGenerationResponse = {
  __typename?: 'QuoteGenerationResponse';
  orderNumber: Scalars['String']['output'];
  orderStatus: Scalars['String']['output'];
  sapOrderNumber: Scalars['String']['output'];
};

export type QuoteItem = {
  __typename?: 'QuoteItem';
  additionalInfo?: Maybe<OrderAdditionalInfo>;
  availabilityMessages?: Maybe<Array<Maybe<OrderItemAvailabilityMessages>>>;
  brandId?: Maybe<Scalars['String']['output']>;
  complianceMessages?: Maybe<Array<Scalars['String']['output']>>;
  configuration: Array<ProductConfiguration>;
  configurationId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  itemPrice: Scalars['Float']['output'];
  kitItems: Array<CartKitItem>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  linePrice: Scalars['Float']['output'];
  listPrice?: Maybe<Scalars['Float']['output']>;
  listPriceCurrency?: Maybe<Scalars['String']['output']>;
  materialInfo: Material;
  materialNumber: Scalars['String']['output'];
  originalQty?: Maybe<Scalars['Int']['output']>;
  pricePerUnit: Scalars['Float']['output'];
  product?: Maybe<Scalars['String']['output']>;
  productDetails?: Maybe<Product>;
  productNote?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  remainingQty?: Maybe<Scalars['Int']['output']>;
  scheduleLines: Array<OrderItemScheduleLine>;
  status?: Maybe<Scalars['String']['output']>;
  type: CartItemType;
  yourPrice?: Maybe<Scalars['Float']['output']>;
};

export type QuoteItemToUpdate = {
  itemToUpdate: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuotePdfInput = {
  quoteNumber: Scalars['String']['input'];
  soldTo: Scalars['String']['input'];
};

export type QuoteSearchInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderByType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatusType>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type QuoteSearchPayload = {
  __typename?: 'QuoteSearchPayload';
  count: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<OrderByType>;
  orderTotal?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
  quotes: Array<Quote>;
  soldTo?: Maybe<Scalars['String']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type QuoteShareableLinkInput = {
  quoteNumber: Scalars['String']['input'];
};

export type ReadyToShipNotificationInput = {
  brand: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  materialNumber: Scalars['String']['input'];
  productNumber: Scalars['String']['input'];
};

export type ReadyToShipNotificationResponse = {
  __typename?: 'ReadyToShipNotificationResponse';
  brand?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type Reagents = {
  __typename?: 'Reagents';
  currency?: Maybe<Scalars['String']['output']>;
  efficiencyScore?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  grnaId?: Maybe<Scalars['String']['output']>;
  moreInformation?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  recommendedStatus?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  specificityScore?: Maybe<Scalars['String']['output']>;
};

export type ReagentsInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  efficiencyScore?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  grnaId?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  moreInformation?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recommendedStatus?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  specificityScore?: InputMaybe<Scalars['String']['input']>;
};

export type Reasons = {
  __typename?: 'Reasons';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RecentOrderItem = {
  __typename?: 'RecentOrderItem';
  brand: Scalars['String']['output'];
  material: Material;
  orderDate: Scalars['Date']['output'];
  orderId: Scalars['String']['output'];
  orderItemId: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  product: Scalars['String']['output'];
  purchaseCount: Scalars['Int']['output'];
  quantity: Scalars['String']['output'];
  storeId?: Maybe<Scalars['String']['output']>;
  type: CartItemType;
};

export type RecentOrderItemsInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  createdfromdate?: InputMaybe<Scalars['Date']['input']>;
  createdtodate?: InputMaybe<Scalars['Date']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  orderby?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perpage?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  sortcolumn?: InputMaybe<Scalars['String']['input']>;
};

export type RecentOrderItemsPayload = {
  __typename?: 'RecentOrderItemsPayload';
  count: Scalars['Int']['output'];
  orderItems: Array<RecentOrderItem>;
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  brand: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayProductNumber?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productNumber: Scalars['String']['output'];
};

export type RegionInput = {
  region: Scalars['String']['input'];
};

export type RegionResponse = {
  __typename?: 'RegionResponse';
  countries: Array<CountryResponse>;
  regionCode: Scalars['String']['output'];
  regionName: Scalars['String']['output'];
};

export type RegisterBlanketPoInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  blanketPoNumber: Scalars['String']['input'];
  contractAmount: Scalars['String']['input'];
  contractPin: Scalars['String']['input'];
  contractValidTo: Scalars['String']['input'];
  email: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payer?: InputMaybe<Scalars['String']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredBlanketPoResponse = {
  __typename?: 'RegisteredBlanketPoResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  orderStatus: Scalars['String']['output'];
  sapOrderNumber: Scalars['String']['output'];
};

export type RegisteredUser = {
  __typename?: 'RegisteredUser';
  billingAddress?: Maybe<UserAddress>;
  contactAddress?: Maybe<UserAddress>;
  officeAddress?: Maybe<UserAddress>;
  participantComplianceInformation?: Maybe<UserParticipantComplianceInformation>;
  paymentAddress?: Maybe<UserAddress>;
  shippingAddress?: Maybe<UserAddress>;
  userProfile?: Maybe<UserProfile>;
};

export type RegisteredUserProfile = {
  __typename?: 'RegisteredUserProfile';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  guestShoppingType?: Maybe<Scalars['String']['output']>;
  isLogonIdChanged?: Maybe<Scalars['Boolean']['output']>;
  isOffersAndPromotionsEmail?: Maybe<Scalars['Boolean']['output']>;
  logonId?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<ProfileType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RegistrationInput = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  omsGuestToken?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
};

export enum RejectDealerRequestAction {
  Reject = 'reject',
  RejectAll = 'rejectAll'
}

export type RejectDealerRequestsInput = {
  action: RejectDealerRequestAction;
  cartId: Scalars['ID']['input'];
  rejectionComments: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type RelatedCategory = {
  __typename?: 'RelatedCategory';
  facetId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RelatedProduct = {
  __typename?: 'RelatedProduct';
  productId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RequestApprovalInput = {
  emailId: Scalars['String']['input'];
};

export type RequestQuoteForMilliplexInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  emailId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  selectedAssayList: Array<SelectedAssayInput>;
};

export enum RequestSource {
  Order = 'order',
  Quote = 'quote'
}

export enum RequestType {
  All = 'ALL',
  Contact = 'CONTACT',
  Search = 'SEARCH',
  Soldto = 'SOLDTO'
}

export type Requester = {
  __typename?: 'Requester';
  approvalAmount?: Maybe<Scalars['Float']['output']>;
  approvalProductType?: Maybe<Scalars['String']['output']>;
  approvalTypeId: Scalars['String']['output'];
  approverId: Scalars['String']['output'];
  emailId: Scalars['String']['output'];
  logonId: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
};

export type RestrictedPartnersObjectInput = {
  restricedHiddenpartnersIndexId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Results = {
  __typename?: 'Results';
  refseqId?: Maybe<Scalars['String']['output']>;
  siRNAType?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  subSetInfo?: Maybe<Array<Maybe<SemiConfSubSetInfo>>>;
};

export type ResultsInput = {
  refseqId?: InputMaybe<Scalars['String']['input']>;
  siRNAType?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  subSetInfo?: InputMaybe<Array<InputMaybe<SemiConfSubSetInfoInput>>>;
};

export type Roles = {
  __typename?: 'Roles';
  isApprovee: Scalars['Boolean']['output'];
  isBuyingNetworkManager: Scalars['Boolean']['output'];
  isCCRUser: Scalars['Boolean']['output'];
  isCustomProductCSR: Scalars['Boolean']['output'];
  isCustomerServiceRep: Scalars['Boolean']['output'];
  isDTAQFTBUser: Scalars['Boolean']['output'];
  isDealer: Scalars['Boolean']['output'];
  isExternalSalesAgent: Scalars['Boolean']['output'];
  isInventoryViewUser: Scalars['Boolean']['output'];
  isInvoicePaymentCustomer: Scalars['Boolean']['output'];
  isJapanDealer: Scalars['Boolean']['output'];
  isKoreaPrePayment: Scalars['Boolean']['output'];
  isKoreaStandardCustomer: Scalars['Boolean']['output'];
  isMaterialsDirectCustomer: Scalars['Boolean']['output'];
  isMultiCountryUser: Scalars['Boolean']['output'];
  isOrderApprover: Scalars['Boolean']['output'];
  isOrderConsolidationRequester: Scalars['Boolean']['output'];
  isOrderConsolidator: Scalars['Boolean']['output'];
  isOrderRequester: Scalars['Boolean']['output'];
  isOrderStatusCustomer: Scalars['Boolean']['output'];
  isPackForExportUser: Scalars['Boolean']['output'];
  isPublicOrderingCustomer: Scalars['Boolean']['output'];
  isPurchasingAgent: Scalars['Boolean']['output'];
  isQuoteConverter: Scalars['Boolean']['output'];
  isQuoteRequester: Scalars['Boolean']['output'];
  isRegisteredCustomer: Scalars['Boolean']['output'];
  isSourcingUser: Scalars['Boolean']['output'];
};

export type RuleValidateDuplexInput = {
  antisenceBaseCount?: InputMaybe<Scalars['Int']['input']>;
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  autoGenerateOligo?: InputMaybe<Scalars['Boolean']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['Int']['input']>;
};

export type RuleValidateInput = {
  additionalCarrierProtein?: InputMaybe<Scalars['String']['input']>;
  additionalServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<Scalars['String']['input']>;
  antisenceBaseCount?: InputMaybe<Scalars['Int']['input']>;
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  conjugation?: InputMaybe<Scalars['String']['input']>;
  conjugationAmount?: InputMaybe<Scalars['String']['input']>;
  conjugationChemistry?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cterminalMod?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  fullSOligoBackbone?: InputMaybe<Scalars['Boolean']['input']>;
  internalMod?: InputMaybe<Scalars['String']['input']>;
  isLabelledAminoAcid?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nterminalMod?: InputMaybe<Scalars['String']['input']>;
  otherValue?: InputMaybe<Scalars['String']['input']>;
  probeType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  purityLevel?: InputMaybe<Scalars['String']['input']>;
  quantitation?: InputMaybe<Scalars['String']['input']>;
  researcher?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  senseNameCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['String']['input']>;
};

export type RuleValidatePlateInput = {
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  mixed?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['Int']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type RuleValidateResponse = {
  __typename?: 'RuleValidateResponse';
  additionalServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  epsilon?: Maybe<Scalars['Float']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  fullSOligoBackbone?: Maybe<Scalars['Boolean']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  internalMod?: Maybe<Scalars['String']['output']>;
  isLNABaseEnable?: Maybe<Scalars['Boolean']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listAdditionalCarrierProtein?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listAdditionalServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConcentration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConjugation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConjugationAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConjugationChemistry?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listCterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listErrors?: Maybe<Array<Maybe<ListError>>>;
  listFiveMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listFormat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listInternalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listLabeledAminoAcids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMinimumYield?: Maybe<Scalars['Float']['output']>;
  listModification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listNterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurityLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listQuantitation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listThreeMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listTubes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listWarnings?: Maybe<Array<Maybe<ListWarning>>>;
  material?: Maybe<Scalars['String']['output']>;
  meltingTemperature?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  threeMod?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['String']['output']>;
};

export type RuleValidateResponsePlate = {
  __typename?: 'RuleValidateResponsePlate';
  antisenseBaseCount?: Maybe<Scalars['Int']['output']>;
  antisenseGcContent?: Maybe<Scalars['String']['output']>;
  antisenseMeltingTemperature?: Maybe<Scalars['String']['output']>;
  antisenseMolecularWeight?: Maybe<Scalars['String']['output']>;
  antisensePrimerDimer?: Maybe<Scalars['String']['output']>;
  antisenseSecondaryStructure?: Maybe<Scalars['String']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listConcentration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listCterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listErrors?: Maybe<Array<Maybe<ListError>>>;
  listFiveMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listFormat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listInternalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMinimumYield?: Maybe<Scalars['Float']['output']>;
  listModification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listNterminalMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOverhang?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurityLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listQuantitation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listThreeMod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listTubes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listWarning?: Maybe<Array<Maybe<ListWarning>>>;
  meltingTemperature?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  technicalSequence?: Maybe<Scalars['String']['output']>;
};

export type SapError = {
  __typename?: 'SAPError';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorNumber?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SdsLanuguageOptions = {
  __typename?: 'SDSLanuguageOptions';
  altLanguages: Array<Scalars['String']['output']>;
  primaryLanguage: Scalars['String']['output'];
};

export type SkuItem = {
  __typename?: 'SKUItem';
  description?: Maybe<Scalars['String']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SkuItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum SalesOrderSource {
  SalesOrderSrcEmailVal = 'SALES_ORDER_SRC_EMAIL_VAL',
  SalesOrderSrcFaxVal = 'SALES_ORDER_SRC_FAX_VAL',
  SalesOrderSrcPhoneVal = 'SALES_ORDER_SRC_PHONE_VAL'
}

export type SampleCertificateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  control?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
  useCount?: InputMaybe<Scalars['Boolean']['input']>;
  useFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SangerConfigurations = {
  __typename?: 'SangerConfigurations';
  count?: Maybe<Scalars['Int']['output']>;
  reagents?: Maybe<Array<Maybe<SangerReagents>>>;
  requestDate?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SangerCrisprAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  reagents?: InputMaybe<Array<InputMaybe<SangerReagentsInput>>>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type SangerCrisprAddToCartResponse = {
  __typename?: 'SangerCrisprAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type SangerCrisprPriceCall = {
  __typename?: 'SangerCrisprPriceCall';
  result?: Maybe<Array<Maybe<SangerCrisprPriceCallResponse>>>;
  serverError?: Maybe<ServerError>;
};

export type SangerCrisprPriceCallInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  reagents?: InputMaybe<Array<InputMaybe<SangerReagentsInput>>>;
};

export type SangerCrisprPriceCallResponse = {
  __typename?: 'SangerCrisprPriceCallResponse';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  ensemblGeneId?: Maybe<Scalars['String']['output']>;
  ensemblGeneSymbol?: Maybe<Scalars['String']['output']>;
  exonId?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  ncbiGeneId?: Maybe<Scalars['String']['output']>;
  ncbiGeneSymbol?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  sangerCloneId?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  targetSeq?: Maybe<Scalars['String']['output']>;
};

export type SangerCrisprSpecificatios = {
  __typename?: 'SangerCrisprSpecificatios';
  aliquot?: Maybe<Array<Maybe<Aliquot>>>;
  amount?: Maybe<Array<Maybe<Amount>>>;
  physicalMaterial?: Maybe<Array<Maybe<SangerPhysicalMaterial>>>;
  serverError?: Maybe<ServerError>;
  titer?: Maybe<Array<Maybe<Titer>>>;
  volume?: Maybe<Array<Maybe<Volume>>>;
};

export type SangerDropDownListInput = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type SangerPhysicalMaterial = {
  __typename?: 'SangerPhysicalMaterial';
  DNA?: Maybe<Scalars['String']['output']>;
  GLYCEROL?: Maybe<Scalars['String']['output']>;
  VIRUS?: Maybe<Scalars['String']['output']>;
  noSelection?: Maybe<Scalars['String']['output']>;
};

export type SangerProductSearchTermInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type SangerReagents = {
  __typename?: 'SangerReagents';
  currency?: Maybe<Scalars['String']['output']>;
  ensemblGeneId?: Maybe<Scalars['String']['output']>;
  ensemblGeneSymbol?: Maybe<Scalars['String']['output']>;
  exonId?: Maybe<Scalars['String']['output']>;
  ncbiGeneId?: Maybe<Scalars['String']['output']>;
  ncbiGeneSymbol?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  sangerCloneId?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  targetSeq?: Maybe<Scalars['String']['output']>;
};

export type SangerReagentsInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  ensemblGeneId?: InputMaybe<Scalars['String']['input']>;
  ensemblGeneSymbol?: InputMaybe<Scalars['String']['input']>;
  exonId?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  ncbiGeneId?: InputMaybe<Scalars['String']['input']>;
  ncbiGeneSymbol?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sangerCloneId?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  targetSeq?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCartId = {
  __typename?: 'SaveCartId';
  cartId: Scalars['String']['output'];
};

export type SaveCartInput = {
  cartComment?: InputMaybe<Scalars['String']['input']>;
  cartName: Scalars['String']['input'];
  cartType?: InputMaybe<Scalars['String']['input']>;
};

export type SaveForLaterInput = {
  items: Array<SaveForLaterItem>;
};

export type SaveForLaterItem = {
  cartType: Scalars['String']['input'];
  itemType: Scalars['String']['input'];
  marketplaceOfferId?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
};

export type SaveForLaterResponse = {
  __typename?: 'SaveForLaterResponse';
  brand?: Maybe<Scalars['String']['output']>;
  cartType: Scalars['String']['output'];
  catalogId?: Maybe<Scalars['String']['output']>;
  configurationDetail?: Maybe<Scalars['String']['output']>;
  configurationId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  material: Material;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
};

export type SaveLabWaterSession = {
  accessories?: InputMaybe<Array<InputMaybe<LabWaterAccessoryConsumableAndService>>>;
  applications?: InputMaybe<Array<InputMaybe<LabWaterSessionApplicationsInput>>>;
  commentForLWSpecialist?: InputMaybe<Scalars['String']['input']>;
  consumables?: InputMaybe<Array<InputMaybe<LabWaterAccessoryConsumableAndService>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dailyWaterUsage?: InputMaybe<Scalars['String']['input']>;
  feedWaterType?: InputMaybe<Scalars['String']['input']>;
  listApplication?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listErrors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listMaxwaterUsage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listOutputWater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listRegulated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSubapplication?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSystem?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listWarnings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listfeed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otherApplication?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  regulatedEnvironment?: InputMaybe<Scalars['String']['input']>;
  regulatoryRequirement?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<InputMaybe<LabWaterAccessoryConsumableAndService>>>;
  subApplication?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  system?: InputMaybe<Scalars['String']['input']>;
  systemPrice?: InputMaybe<Scalars['Float']['input']>;
  typeOfWater?: InputMaybe<Scalars['String']['input']>;
};

export type SaveLabWaterSessionInput = {
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isSialCSRUser?: InputMaybe<Scalars['Boolean']['input']>;
  labWaterSession?: InputMaybe<SaveLabWaterSession>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMilliqSqSessionInput = {
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isSialCSRUser?: InputMaybe<Scalars['Boolean']['input']>;
  milliqSqSession?: InputMaybe<MilliqSqSessionInput>;
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOrderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  soldTo: Scalars['String']['input'];
};

export type SaveToSessionResponse = {
  __typename?: 'SaveToSessionResponse';
  result?: Maybe<Scalars['Int']['output']>;
};

export type SavedCart = {
  __typename?: 'SavedCart';
  cartId: Scalars['String']['output'];
  cartName: Scalars['String']['output'];
  cartType?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  hiddenCheckoutButton?: Maybe<Scalars['Boolean']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  products: Scalars['Int']['output'];
  savedDate: Scalars['Float']['output'];
  storeId?: Maybe<Scalars['Int']['output']>;
};

export enum SavedCartAction {
  Price = 'price'
}

export type SavedCartData = {
  __typename?: 'SavedCartData';
  billingAddress?: Maybe<CartAddress>;
  cartType?: Maybe<Scalars['String']['output']>;
  ccCardNumber?: Maybe<Scalars['String']['output']>;
  ccCardType?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerServiceInstructions?: Maybe<Scalars['String']['output']>;
  dealers: Array<Dealer>;
  displayPromoCode: Scalars['Boolean']['output'];
  hasQuotePriceItem: Scalars['Boolean']['output'];
  hiddenCheckoutButton?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  items: Array<SavedCartItem>;
  lastUpdatedDate: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  orderingPartyAddress?: Maybe<CartAddress>;
  packingSlipNote?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<CartPartners>;
  poNumber?: Maybe<Scalars['String']['output']>;
  requisitionNumber?: Maybe<Scalars['String']['output']>;
  salesOrderSource?: Maybe<SalesOrderSource>;
  shippingAddress?: Maybe<CartAddress>;
  totals?: Maybe<CartTotals>;
};

export type SavedCartItem = {
  __typename?: 'SavedCartItem';
  additionalInfo?: Maybe<CartAdditionalInfo>;
  availabilityMessages: Array<Maybe<CartItemAvailabilityMessages>>;
  availabilityOverwriteMessage?: Maybe<BbeMaterialAvailability>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  bundleItems: Array<Maybe<PromotionalBundleItemPricing>>;
  complianceMessages: Array<Maybe<Scalars['String']['output']>>;
  configuration: Array<ProductConfiguration>;
  configurationId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  displayEditButton: Scalars['Boolean']['output'];
  displaySellerName?: Maybe<Scalars['String']['output']>;
  erpType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: CatalogImage;
  isQuotePriceItem?: Maybe<Scalars['Boolean']['output']>;
  itemSAPError: Array<Maybe<SapError>>;
  kitItems?: Maybe<Array<Maybe<CartKitItem>>>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  materialBrand: Brand;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialId: Scalars['String']['output'];
  materialName?: Maybe<Scalars['String']['output']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product: Scalars['String']['output'];
  productNote?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promotionalMessage?: Maybe<CartItemPromotionalMessage>;
  quantity: Scalars['Int']['output'];
  quoteDocType?: Maybe<Scalars['String']['output']>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
  redirectLinkForEdit?: Maybe<Scalars['String']['output']>;
  remainingReserveQuantity?: Maybe<Scalars['Int']['output']>;
  subscriptionFrequency?: Maybe<Scalars['String']['output']>;
  supplementaryMessage?: Maybe<SupplementaryMessage>;
  totalReserveQuantity?: Maybe<Scalars['Int']['output']>;
  type: CartItemType;
  vendorNumber?: Maybe<Scalars['String']['output']>;
  yourReference?: Maybe<Scalars['String']['output']>;
};

export type SavedCartItemInput = {
  materialNumber: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type SavedCartsDataResponse = {
  __typename?: 'SavedCartsDataResponse';
  count?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  savedCartSearchModels?: Maybe<Array<SavedCart>>;
};

/** The same inputs are needed to modify any given saved document. Be it to add it, or remove it from your library. Was: SavedDocumentInput */
export type SavedDocumentInput = {
  brand: Scalars['String']['input'];
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['String']['input'];
};

export type SavedForLaterInput = {
  cartType?: InputMaybe<Scalars['String']['input']>;
};

export type SavedOrderResponse = {
  __typename?: 'SavedOrderResponse';
  createdDate: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  soldTo: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SavedProtocolsResponse = {
  __typename?: 'SavedProtocolsResponse';
  description?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  savedDate?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Scale = {
  __typename?: 'Scale';
  five?: Maybe<Scalars['String']['output']>;
  three?: Maybe<Scalars['String']['output']>;
  two?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export enum ScheduleLineStatusType {
  Cancelled = 'CANCELLED',
  CancelledDropShip = 'CANCELLED_DROP_SHIP',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  CompletedDropShip = 'COMPLETED_DROP_SHIP',
  ContactForAvailability = 'CONTACT_FOR_AVAILABILITY',
  Delayed = 'DELAYED',
  Empty = 'EMPTY',
  FulfilmentDeliveryDelayed = 'FULFILMENT_DELIVERY_DELAYED',
  Invoiced = 'INVOICED',
  InProcess = 'IN_PROCESS',
  Open = 'OPEN',
  PartiallyCancelled = 'PARTIALLY_CANCELLED',
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  PendingDropShip = 'PENDING_DROP_SHIP',
  PendingRefund = 'PENDING_REFUND',
  PendingReview = 'PENDING_REVIEW',
  Processing = 'PROCESSING',
  Received = 'RECEIVED',
  Refunded = 'REFUNDED',
  Rejected = 'REJECTED',
  Shipped = 'SHIPPED',
  ShippingInProgress = 'SHIPPING_IN_PROGRESS'
}

export type SdsBulkSearchInput = {
  products: Array<SdsBulkSearchProduct>;
};

export type SdsBulkSearchProduct = {
  brand: Scalars['String']['input'];
  productNumber: Scalars['String']['input'];
};

export type SdsBulkSearchResponse = {
  __typename?: 'SdsBulkSearchResponse';
  items: Array<SdsSearchResponse>;
};

export type SdsData = {
  __typename?: 'SdsData';
  brand: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  languages: SdsLanuguageOptions;
  productNumber: Scalars['String']['output'];
};

export type SdsResponseNew = {
  __typename?: 'SdsResponseNew';
  locale?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SdsRetrieveData = {
  __typename?: 'SdsRetrieveData';
  brand: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  languages?: Maybe<SdsLanuguageOptions>;
  pdfDocument: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
};

export type SdsRetrieveInput = {
  brand: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type SdsRetrieveResponse = {
  __typename?: 'SdsRetrieveResponse';
  locale: Scalars['String']['output'];
  region: Scalars['String']['output'];
  sds: Array<Maybe<SdsRetrieveData>>;
};

export type SdsSearchInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
};

export type SdsSearchResponse = {
  __typename?: 'SdsSearchResponse';
  brands: Array<Maybe<Scalars['String']['output']>>;
  locale: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
  region: Scalars['String']['output'];
  sds: Array<Maybe<SdsData>>;
};

export type SearchResponseKicqStart = {
  __typename?: 'SearchResponseKicqStart';
  assays?: Maybe<Array<Maybe<Assay>>>;
  configurable_options?: Maybe<Array<Maybe<ConfigurableOption>>>;
  count?: Maybe<Scalars['Int']['output']>;
  pricing?: Maybe<Pricing>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchResponseKicqStartPrimers = {
  __typename?: 'SearchResponseKicqStartPrimers';
  count?: Maybe<Scalars['Int']['output']>;
  pricing?: Maybe<Pricing>;
  results?: Maybe<Array<Maybe<Primer>>>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchResponseSiRna = {
  __typename?: 'SearchResponseSiRNA';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<SiRnaResults>>>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchResults = {
  facets: Array<Facet>;
  items: Array<SearchResultsItems>;
  metadata: SearchResultsMetadata;
};

export type SearchResultsItems = Gene | Paper | Product | Substance | TechnicalDocument;

export type SearchResultsMetadata = {
  __typename?: 'SearchResultsMetadata';
  count?: Maybe<Scalars['Int']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  numPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  redirect?: Maybe<Scalars['String']['output']>;
  setsCount?: Maybe<Scalars['Int']['output']>;
  suggestedType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum SearchSuggestionType {
  CasNumber = 'CAS_NUMBER',
  Category = 'CATEGORY',
  MaterialNumber = 'MATERIAL_NUMBER',
  Pinyin = 'PINYIN',
  ProductName = 'PRODUCT_NAME',
  ProductNumber = 'PRODUCT_NUMBER'
}

export type SelectedAssayInput = {
  customPremixSelection?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  panelName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampleType?: InputMaybe<Scalars['String']['input']>;
  selectedAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceSaverSelection?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type SelectedDealerInput = {
  cartId: Scalars['ID']['input'];
  selectedDealer?: InputMaybe<DealerInput>;
};

export type SellerContactContent = {
  __typename?: 'SellerContactContent';
  reasons?: Maybe<Array<Maybe<Reasons>>>;
};

export type SellerDocuments = {
  __typename?: 'SellerDocuments';
  mktBanner1: Scalars['String']['output'];
  mktBanner2: Scalars['String']['output'];
  mktBanner3: Scalars['String']['output'];
  pdfPrivacyPolicy: Scalars['String']['output'];
  pdfReturnPolicy: Scalars['String']['output'];
  pdfTermsConditions: Scalars['String']['output'];
};

export type SellerMessage = {
  body: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  sellerId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SellerResponse = {
  __typename?: 'SellerResponse';
  city: Scalars['String']['output'];
  civility: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: SellerDocuments;
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneSecondary: Scalars['String']['output'];
  shopAdditionalFields: ShopAdditionalFields;
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  webSite: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type SemiConfSessionData = {
  __typename?: 'SemiConfSessionData';
  count?: Maybe<Scalars['Int']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Results>>>;
  selectedItems?: Maybe<Array<Maybe<Results>>>;
  serverError?: Maybe<ServerError>;
  stepNo?: Maybe<Scalars['Int']['output']>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SemiConfSubSetInfo = {
  __typename?: 'SemiConfSubSetInfo';
  brand?: Maybe<Scalars['String']['output']>;
  checked?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  fuzzyEnd?: Maybe<Scalars['Int']['output']>;
  fuzzyStart?: Maybe<Scalars['Int']['output']>;
  geneId?: Maybe<Scalars['Int']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  refseqEnd?: Maybe<Scalars['Int']['output']>;
  refseqId?: Maybe<Scalars['String']['output']>;
  refseqStart?: Maybe<Scalars['Int']['output']>;
  siRNAAntiSenseSeq?: Maybe<Scalars['String']['output']>;
  siRNAId?: Maybe<Scalars['String']['output']>;
  siRNASenseSeq?: Maybe<Scalars['String']['output']>;
  siRNATargetSeq?: Maybe<Scalars['String']['output']>;
  siRNAType?: Maybe<Scalars['String']['output']>;
  sirnaProdType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type SemiConfSubSetInfoInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  fuzzyEnd?: InputMaybe<Scalars['Int']['input']>;
  fuzzyStart?: InputMaybe<Scalars['Int']['input']>;
  geneId?: InputMaybe<Scalars['Int']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  refseqEnd?: InputMaybe<Scalars['Int']['input']>;
  refseqId?: InputMaybe<Scalars['String']['input']>;
  refseqStart?: InputMaybe<Scalars['Int']['input']>;
  siRNAAntiSenseSeq?: InputMaybe<Scalars['String']['input']>;
  siRNAId?: InputMaybe<Scalars['String']['input']>;
  siRNASenseSeq?: InputMaybe<Scalars['String']['input']>;
  siRNATargetSeq?: InputMaybe<Scalars['String']['input']>;
  siRNAType?: InputMaybe<Scalars['String']['input']>;
  sirnaProdType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type SemiConfigInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  cloneId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  efficiencyScore?: InputMaybe<Scalars['String']['input']>;
  ensemblGeneId?: InputMaybe<Scalars['String']['input']>;
  ensemblGeneSymbol?: InputMaybe<Scalars['String']['input']>;
  exonId?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  grnaId?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  moreInformation?: InputMaybe<Scalars['String']['input']>;
  ncbiGeneId?: InputMaybe<Scalars['String']['input']>;
  ncbiGeneSymbol?: InputMaybe<Scalars['String']['input']>;
  orfLength?: InputMaybe<Scalars['String']['input']>;
  orfSequence?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recommendedStatus?: InputMaybe<Scalars['String']['input']>;
  sangerCloneId?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  specificityScore?: InputMaybe<Scalars['String']['input']>;
  subSetInfo?: InputMaybe<Array<InputMaybe<SubSetInfoInput>>>;
  targetSeq?: InputMaybe<Scalars['String']['input']>;
  vector?: InputMaybe<Scalars['String']['input']>;
};

export type SemiConfigPriceCall = {
  __typename?: 'SemiConfigPriceCall';
  result?: Maybe<Array<Maybe<SemiConfigPriceCallResponse>>>;
  serverError?: Maybe<ServerError>;
};

export type SemiConfigPriceCallInput = {
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  product?: InputMaybe<Scalars['String']['input']>;
  reagents?: InputMaybe<Array<InputMaybe<SemiConfigInput>>>;
  results?: InputMaybe<Array<InputMaybe<SemiConfigInput>>>;
};

export type SemiConfigPriceCallResponse = {
  __typename?: 'SemiConfigPriceCallResponse';
  brand?: Maybe<Scalars['String']['output']>;
  cloneId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  efficiencyScore?: Maybe<Scalars['String']['output']>;
  ensemblGeneId?: Maybe<Scalars['String']['output']>;
  ensemblGeneSymbol?: Maybe<Scalars['String']['output']>;
  exonId?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  grnaId?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  moreInformation?: Maybe<Scalars['String']['output']>;
  ncbiGeneId?: Maybe<Scalars['String']['output']>;
  ncbiGeneSymbol?: Maybe<Scalars['String']['output']>;
  orfLength?: Maybe<Scalars['String']['output']>;
  orfSequence?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  recommendedStatus?: Maybe<Scalars['String']['output']>;
  sangerCloneId?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  specificityScore?: Maybe<Scalars['String']['output']>;
  subSetInfo?: Maybe<Array<Maybe<SubSetInfo>>>;
  targetSeq?: Maybe<Scalars['String']['output']>;
  vector?: Maybe<Scalars['String']['output']>;
};

export type SemiConfigSearchResult = {
  __typename?: 'SemiConfigSearchResult';
  controls?: Maybe<Array<SemiConfigSearchResultReagents>>;
  count: Scalars['Int']['output'];
  reagents?: Maybe<Array<SemiConfigSearchResultReagents>>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Scalars['String']['output']>>;
};

export type SemiConfigSearchResultReagents = {
  __typename?: 'SemiConfigSearchResultReagents';
  efficiencyScore: Scalars['String']['output'];
  geneId: Scalars['String']['output'];
  geneSymbol: Scalars['String']['output'];
  grnaId: Scalars['String']['output'];
  moreInformation: Scalars['String']['output'];
  recommendedStatus: Scalars['String']['output'];
  species: Scalars['String']['output'];
  specificityScore: Scalars['String']['output'];
};

export type SemiConfigSpecifications = {
  __typename?: 'SemiConfigSpecifications';
  aliquot?: Maybe<Array<SemiConfigSpecificationsItem>>;
  amount?: Maybe<Array<SemiConfigSpecificationsItem>>;
  companionProducts?: Maybe<Array<SemiConfigSpecificationsItem>>;
  format?: Maybe<Array<SemiConfigSpecificationsItem>>;
  lentivirusBackbone?: Maybe<Array<SemiConfigSpecificationsItem>>;
  modification?: Maybe<Array<SemiConfigSpecificationsItem>>;
  physicalMaterial?: Maybe<Array<SemiConfigSpecificationsItem>>;
  purification?: Maybe<Array<SemiConfigSpecificationsItem>>;
  scale?: Maybe<Array<SemiConfigSpecificationsItem>>;
  species?: Maybe<Array<SemiConfigSpecificationsItem>>;
  structure?: Maybe<Array<SemiConfigSpecificationsItem>>;
  titer?: Maybe<Array<SemiConfigSpecificationsItem>>;
  vector?: Maybe<Array<SemiConfigSpecificationsItem>>;
  volume?: Maybe<Array<SemiConfigSpecificationsItem>>;
};

export type SemiConfigSpecificationsItem = {
  __typename?: 'SemiConfigSpecificationsItem';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SemiConfigurations = {
  __typename?: 'SemiConfigurations';
  controls?: Maybe<Array<Maybe<Controls>>>;
  count?: Maybe<Scalars['Int']['output']>;
  reagents?: Maybe<Array<Maybe<Reagents>>>;
  requestDate?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SemiConfiguratorAddToMiniCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type SemiConfiguratorMiniCartResponse = {
  __typename?: 'SemiConfiguratorMiniCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type SemiConfiguratorProductInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guestParticipantId?: InputMaybe<Scalars['String']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isRegUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type SendNotificationResult = {
  __typename?: 'SendNotificationResult';
  result?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ServerError = {
  __typename?: 'ServerError';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SessionInput = {
  additionalCarrierProtein?: InputMaybe<Scalars['String']['input']>;
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  additionalServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<Scalars['String']['input']>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  antisenceBaseCount?: InputMaybe<Scalars['Int']['input']>;
  antisenceFiveMod?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  antisenceThreeMod?: InputMaybe<Scalars['String']['input']>;
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateOligo?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidation?: InputMaybe<Scalars['String']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  carrierProtein?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  columnConstruction?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  conjugation?: InputMaybe<Scalars['String']['input']>;
  conjugationAmount?: InputMaybe<Scalars['String']['input']>;
  conjugationChemistry?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  crRnaType?: InputMaybe<Scalars['String']['input']>;
  crossContamination?: InputMaybe<Scalars['String']['input']>;
  cterminalMod?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  customPeptideType?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  elisaAnalysis?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  epsilon?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  fiveModCategory?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  fullSOligoBackbone?: InputMaybe<Scalars['Boolean']['input']>;
  gcContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  immunizationTerm?: InputMaybe<Scalars['String']['input']>;
  internalMod?: InputMaybe<Scalars['String']['input']>;
  internalModCategory?: InputMaybe<Scalars['String']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isLNABaseEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isLabelledAminoAcid?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isoCode?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  listAntiseraPeptideModel?: InputMaybe<Array<InputMaybe<AntiseraPeptideModel>>>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listProductPackage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listShippingOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listWarning?: InputMaybe<Array<InputMaybe<ListWarningInput>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  meltingTemparature?: InputMaybe<Scalars['String']['input']>;
  minimumYield?: InputMaybe<Scalars['String']['input']>;
  molecularWeight?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfColumns?: InputMaybe<Scalars['String']['input']>;
  nterminalMod?: InputMaybe<Scalars['String']['input']>;
  numberOfAnimals?: InputMaybe<Scalars['String']['input']>;
  numberOfPeptides?: InputMaybe<Scalars['String']['input']>;
  oligoId?: InputMaybe<Scalars['Int']['input']>;
  orderItemId?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  otherValue?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  peptide?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  priceHeaderError?: InputMaybe<Scalars['String']['input']>;
  primerDimer?: InputMaybe<Scalars['String']['input']>;
  probeType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  purificationAntisera?: InputMaybe<Scalars['String']['input']>;
  purificationBuffer?: InputMaybe<Scalars['String']['input']>;
  purificationColQuantity?: InputMaybe<Scalars['String']['input']>;
  purificationColumn?: InputMaybe<Scalars['String']['input']>;
  purificationGlycAddition?: InputMaybe<Scalars['String']['input']>;
  purificationOption?: InputMaybe<Scalars['String']['input']>;
  purificationProcAddition?: InputMaybe<Scalars['String']['input']>;
  purificationType?: InputMaybe<Scalars['String']['input']>;
  purityLevel?: InputMaybe<Scalars['String']['input']>;
  quantitation?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  secondaryStructure?: InputMaybe<Scalars['String']['input']>;
  senseNameCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  sequenceLocation?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  threeModCategory?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['String']['input']>;
};

export type SessionResponse = {
  __typename?: 'SessionResponse';
  result?: Maybe<Scalars['Int']['output']>;
};

export type SessionResults = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  exons?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isChecked?: InputMaybe<Scalars['Boolean']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  oligoId?: InputMaybe<Scalars['Int']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  primerPairId?: InputMaybe<Scalars['String']['input']>;
  primerSeqFwd?: InputMaybe<Scalars['String']['input']>;
  primerSeqRev?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  refSeqId?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  technicalSequence?: InputMaybe<Scalars['String']['input']>;
};

export type Sessions = {
  __typename?: 'Sessions';
  sessionUrl?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type ShareProductDetailsInput = {
  brand: Scalars['String']['input'];
  catalogType: CatalogType;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  productNumber: Scalars['String']['input'];
  toEmail: Array<Scalars['String']['input']>;
};

export type SharedList = {
  __typename?: 'SharedList';
  coOwners?: Maybe<Array<Scalars['String']['output']>>;
  createdDate: Scalars['Date']['output'];
  deadline?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  invitations?: Maybe<Array<Scalars['String']['output']>>;
  lastUpdatedDate: Scalars['Date']['output'];
  listId: Scalars['ID']['output'];
  members?: Maybe<Array<Scalars['ID']['output']>>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  ownerName: Scalars['String']['output'];
};

export type SharedListDetail = {
  __typename?: 'SharedListDetail';
  coOwners?: Maybe<Array<Scalars['String']['output']>>;
  createdDate: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySubmitQuoteButton?: Maybe<Scalars['Boolean']['output']>;
  invitations?: Maybe<Array<Scalars['String']['output']>>;
  lastUpdatedDate: Scalars['Date']['output'];
  listId: Scalars['ID']['output'];
  membersDetail?: Maybe<Array<SharedListMember>>;
  membersDone?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  ownerDetail: SharedListMember;
  ownerId: Scalars['ID']['output'];
  reminderFrequencyDays?: Maybe<Array<Scalars['Int']['output']>>;
  sharedListItems: Array<SharedListItem>;
};

export type SharedListItem = {
  __typename?: 'SharedListItem';
  availabilityMessages?: Maybe<Array<MaterialAvailability>>;
  brand?: Maybe<Scalars['String']['output']>;
  configurationDetail?: Maybe<ProductConfigurationDetail>;
  configurationId?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['ID']['output'];
  createdByName: Scalars['String']['output'];
  createdDate: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['Date']['output'];
  listItemId: Scalars['ID']['output'];
  listPrice?: Maybe<Scalars['Float']['output']>;
  material: Material;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  netPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productConfiguration?: Maybe<Scalars['JSONObject']['output']>;
  quantity: Scalars['Int']['output'];
  type: CartItemType;
};

export type SharedListItemInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  configurationDetail?: InputMaybe<Scalars['JSONObject']['input']>;
  configurationId?: InputMaybe<Scalars['String']['input']>;
  itemNote?: InputMaybe<Scalars['String']['input']>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['String']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  productConfiguration?: InputMaybe<Scalars['JSONObject']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<CartItemType>;
};

export type SharedListMember = {
  __typename?: 'SharedListMember';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SharedListsPayload = {
  __typename?: 'SharedListsPayload';
  count: Scalars['Int']['output'];
  sharedLists: Array<SharedList>;
};

export type ShipmentTrackingResponse = {
  __typename?: 'ShipmentTrackingResponse';
  deliveryDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ShippingPreference = {
  __typename?: 'ShippingPreference';
  participantId: Scalars['String']['output'];
  participantShippingMethods?: Maybe<Array<Maybe<ParticipantShippingMethods>>>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
};

export type ShopAdditionalFields = {
  __typename?: 'ShopAdditionalFields';
  colDesc1: Scalars['String']['output'];
  colDesc2: Scalars['String']['output'];
  colDesc3: Scalars['String']['output'];
  colHeading1: Scalars['String']['output'];
  colHeading2: Scalars['String']['output'];
  colHeading3: Scalars['String']['output'];
  contentPanel: Scalars['String']['output'];
  csDesc1: Scalars['String']['output'];
  csDesc2: Scalars['String']['output'];
  csTitle1: Scalars['String']['output'];
  csTitle2: Scalars['String']['output'];
  customerServiceEmail: Scalars['String']['output'];
  customerServicePhone: Scalars['String']['output'];
};

export type ShrnaAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  cloneInformation?: InputMaybe<Array<InputMaybe<ShrnaCloneInformationInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ShrnaAddToCartResponse = {
  __typename?: 'ShrnaAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type ShrnaCloneInformationInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  cellType?: InputMaybe<Scalars['String']['input']>;
  cloneName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  knockdown?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  oligoSeq?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  refSeq?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  searchTrcVersion?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetSeq?: InputMaybe<Scalars['String']['input']>;
  trcId?: InputMaybe<Scalars['String']['input']>;
  trcVersion?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['String']['input']>;
};

export type ShrnaDropDownListInput = {
  aliquot?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  physicalMaterial?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  titer?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type ShrnaPhysicalMaterial = {
  __typename?: 'ShrnaPhysicalMaterial';
  DNA?: Maybe<Scalars['String']['output']>;
  GLYCEROL?: Maybe<Scalars['String']['output']>;
  VIRUS?: Maybe<Scalars['String']['output']>;
  noSelection?: Maybe<Scalars['String']['output']>;
};

export type ShrnaPriceCall = {
  __typename?: 'ShrnaPriceCall';
  serverError?: Maybe<ServerError>;
  shrnaResult?: Maybe<Array<Maybe<ShrnaPriceCallResponse>>>;
};

export type ShrnaPriceCallInput = {
  cloneInformation?: InputMaybe<Array<InputMaybe<ShrnaCloneInformationInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  physicalFormat?: InputMaybe<PhysicalFormatInput>;
};

export type ShrnaPriceCallResponse = {
  __typename?: 'ShrnaPriceCallResponse';
  brand?: Maybe<Scalars['String']['output']>;
  cellType?: Maybe<Scalars['String']['output']>;
  cloneName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  knockdown?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  oligoSeq?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  refSeq?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  searchTrcVersion?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetSeq?: Maybe<Scalars['String']['output']>;
  trcId?: Maybe<Scalars['String']['output']>;
  trcVersion?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['String']['output']>;
};

export type ShrnaProductSearchTermInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type ShrnaSemiConfigurations = {
  __typename?: 'ShrnaSemiConfigurations';
  cloneInformation?: Maybe<Array<Maybe<CloneInformation>>>;
  count?: Maybe<Scalars['Int']['output']>;
  requestDate?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ServerError>;
  term?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ShrnaSpecifications = {
  __typename?: 'ShrnaSpecifications';
  aliquot?: Maybe<Array<Maybe<Aliquot>>>;
  amount?: Maybe<Array<Maybe<Amount>>>;
  physicalMaterial?: Maybe<Array<Maybe<ShrnaPhysicalMaterial>>>;
  serverError?: Maybe<ServerError>;
  titer?: Maybe<Array<Maybe<Titer>>>;
  vector?: Maybe<Array<Maybe<ShrnaVector>>>;
  volume?: Maybe<Array<Maybe<Volume>>>;
};

export type ShrnaVector = {
  __typename?: 'ShrnaVector';
  CMVNeo?: Maybe<Scalars['String']['output']>;
  CMVtGFP?: Maybe<Scalars['String']['output']>;
  hPGKNeo?: Maybe<Scalars['String']['output']>;
  hPGKNeoCMVtGFP?: Maybe<Scalars['String']['output']>;
  hPGKPuroCMVtGFP?: Maybe<Scalars['String']['output']>;
  pLKO1?: Maybe<Scalars['String']['output']>;
};

export type SiRnaResults = {
  __typename?: 'SiRNAResults';
  refseqId?: Maybe<Scalars['String']['output']>;
  siRNAType?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  subSetInfo?: Maybe<Array<Maybe<SirnaSubSetInfo>>>;
};

export type SirnaAddToCartInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<InputMaybe<SirnaAddToCartResults>>>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type SirnaAddToCartResponse = {
  __typename?: 'SirnaAddToCartResponse';
  result?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
};

export type SirnaAddToCartResults = {
  fuzzyEnd?: InputMaybe<Scalars['String']['input']>;
  fuzzyStart?: InputMaybe<Scalars['String']['input']>;
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['String']['input']>;
  refseqEnd?: InputMaybe<Scalars['String']['input']>;
  refseqId?: InputMaybe<Scalars['String']['input']>;
  refseqStart?: InputMaybe<Scalars['String']['input']>;
  siRNAAntiSenseSeq?: InputMaybe<Scalars['String']['input']>;
  siRNAId?: InputMaybe<Scalars['String']['input']>;
  siRNASenseSeq?: InputMaybe<Scalars['String']['input']>;
  siRNATargetSeq?: InputMaybe<Scalars['String']['input']>;
  siRNAType?: InputMaybe<Scalars['String']['input']>;
  sirnaProdType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type SirnaSubSetInfo = {
  __typename?: 'SirnaSubSetInfo';
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  fuzzyEnd?: Maybe<Scalars['Int']['output']>;
  fuzzyStart?: Maybe<Scalars['Int']['output']>;
  geneId?: Maybe<Scalars['Int']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  refseqEnd?: Maybe<Scalars['Int']['output']>;
  refseqId?: Maybe<Scalars['String']['output']>;
  refseqStart?: Maybe<Scalars['Int']['output']>;
  siRNAAntiSenseSeq?: Maybe<Scalars['String']['output']>;
  siRNAId?: Maybe<Scalars['String']['output']>;
  siRNASenseSeq?: Maybe<Scalars['String']['output']>;
  siRNATargetSeq?: Maybe<Scalars['String']['output']>;
  siRNAType?: Maybe<Scalars['String']['output']>;
  sirnaProdType?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type SitewideMessage = {
  __typename?: 'SitewideMessage';
  id: Scalars['ID']['output'];
  priority: Priority;
  text: Scalars['String']['output'];
};

export type SitewideMessageInput = {
  loggedIn: Scalars['Boolean']['input'];
  path: Scalars['String']['input'];
};

export type SoftwareLicense = {
  __typename?: 'SoftwareLicense';
  createdDate: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['String']['output']>;
  isTrialLicense: Scalars['Boolean']['output'];
  licenseKey: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  participantId: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Int']['output']>;
};

export type SoftwareLicensesResponse = {
  __typename?: 'SoftwareLicensesResponse';
  purchasedLicenses: Array<SoftwareLicense>;
  trialLicenses: Array<SoftwareLicense>;
};

export type SoldToPartner = {
  __typename?: 'SoldToPartner';
  billTo: Scalars['String']['output'];
  contact?: Maybe<Scalars['String']['output']>;
  e1Partner?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  participantId: Scalars['String']['output'];
  payer: Scalars['String']['output'];
  salesOrg?: Maybe<Scalars['String']['output']>;
  shipTo: Scalars['String']['output'];
  soldTo: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
};

export enum Sort {
  Genenameasc = 'genenameasc',
  Genenamedesc = 'genenamedesc',
  Molwtasc = 'molwtasc',
  Molwtdesc = 'molwtdesc',
  Nameasc = 'nameasc',
  Namedesc = 'namedesc',
  Relevance = 'relevance',
  StorageDateDesc = 'storageDateDesc'
}

export type SpeakerImage = {
  __typename?: 'SpeakerImage';
  alt?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  widths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Speakers = {
  __typename?: 'Speakers';
  company?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SpeakerImage>;
  name?: Maybe<Scalars['String']['output']>;
  speakerBio?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecSheetInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  control?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  useCount?: InputMaybe<Scalars['Boolean']['input']>;
  useFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Species = {
  __typename?: 'Species';
  FnCas9?: Maybe<Scalars['String']['output']>;
  SpCas9?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type SpeciesItem = {
  __typename?: 'SpeciesItem';
  researchAreasList: Array<Scalars['String']['output']>;
  species: Scalars['String']['output'];
};

export type SpecificationModifications = {
  __typename?: 'SpecificationModifications';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SpecificationResponse = {
  __typename?: 'SpecificationResponse';
  brandName: Scalars['String']['output'];
  lineNumber?: Maybe<Scalars['Int']['output']>;
  productNumber: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  specCd?: Maybe<Scalars['Int']['output']>;
  specId?: Maybe<Scalars['Int']['output']>;
  testSpecTable?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpecificationSheet = {
  __typename?: 'SpecificationSheet';
  documentType?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Specifications = {
  __typename?: 'Specifications';
  categoryDisplayName: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  categoryType?: Maybe<Scalars['String']['output']>;
  specificationModifications?: Maybe<Array<SpecificationModifications>>;
};

export type SpecificationsInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  daughterPlateNumber?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  isAmountChanged?: InputMaybe<Scalars['Boolean']['input']>;
  isConcentrationChanged?: InputMaybe<Scalars['Boolean']['input']>;
  isConcentrationValidate?: InputMaybe<Scalars['Boolean']['input']>;
  isOverriden?: InputMaybe<Scalars['Boolean']['input']>;
  isVolumeChanged?: InputMaybe<Scalars['Boolean']['input']>;
  isamountValidate?: InputMaybe<Scalars['Boolean']['input']>;
  listScaleFromRules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxConcentration?: InputMaybe<Scalars['Float']['input']>;
  maxVolume?: InputMaybe<Scalars['Float']['input']>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecificationsResponse = {
  __typename?: 'SpecificationsResponse';
  calculatedValues?: Maybe<CalculatedValues>;
  errorValues?: Maybe<Array<Maybe<ErrorValues>>>;
};

export type SpotOffer = {
  __typename?: 'SpotOffer';
  discount?: Maybe<Offer>;
  isEligible: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
};

export type Standard = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  antisenceBaseCount?: InputMaybe<Scalars['String']['input']>;
  antisenceName?: InputMaybe<Scalars['String']['input']>;
  antisenceSequence?: InputMaybe<Scalars['String']['input']>;
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateOligo?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidation?: InputMaybe<Scalars['String']['input']>;
  baseCount?: InputMaybe<Scalars['String']['input']>;
  carrierProtein?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  crRnaType?: InputMaybe<Scalars['String']['input']>;
  crossContamination?: InputMaybe<Scalars['String']['input']>;
  cterminalMod?: InputMaybe<Scalars['String']['input']>;
  customPeptideType?: InputMaybe<Scalars['String']['input']>;
  customerAntisenseOverHang?: InputMaybe<Scalars['String']['input']>;
  customerOverhang?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  fiveModCategory?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  fullSOligoBackbone?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalModCategory?: InputMaybe<Scalars['String']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  isCSRSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isLabelledAminoAcid?: InputMaybe<Scalars['Boolean']['input']>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  isoCode?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  listProductPackage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listShippingOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nterminalMod?: InputMaybe<Scalars['String']['input']>;
  oligoId?: InputMaybe<Scalars['Int']['input']>;
  orderItemId?: InputMaybe<Scalars['String']['input']>;
  otherValue?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  plateType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  sequenceLocation?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  threeModCategory?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['String']['input']>;
};

export type StockAvailabilityInput = {
  product: Scalars['String']['input'];
};

export type StockAvailabilityResults = {
  __typename?: 'StockAvailabilityResults';
  errorMessage?: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<StockItem>>;
};

export type StockItem = {
  __typename?: 'StockItem';
  brand: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  materials: Array<StockItemMaterial>;
  product: Scalars['String']['output'];
};

export type StockItemMaterial = {
  __typename?: 'StockItemMaterial';
  description: Scalars['String']['output'];
  inventoryDetails: Array<InventoryDetail>;
  materialNumber: Scalars['String']['output'];
};

export type Structure = {
  __typename?: 'Structure';
  crRNA?: Maybe<Scalars['String']['output']>;
  sgRNA?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type StructureSearchFilters = {
  cutoff?: InputMaybe<Scalars['Int']['input']>;
  maxhits?: InputMaybe<Scalars['Int']['input']>;
  stereo?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StructureSearchFormat {
  Molfile = 'molfile',
  Smarts = 'smarts',
  Smiles = 'smiles'
}

export type StructureSearchFormattedInput = {
  catalogType?: InputMaybe<CatalogType>;
  facets?: InputMaybe<Array<FacetInput>>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  format: StructureSearchFormat;
  pagination?: Pagination;
  sort?: InputMaybe<Sort>;
  term: Scalars['String']['input'];
  type: Array<StructureSearchType>;
};

export type StructureSearchInput = {
  catalogType?: InputMaybe<CatalogType>;
  facets?: InputMaybe<Array<FacetInput>>;
  filters?: InputMaybe<StructureSearchFilters>;
  format: StructureSearchFormat;
  pagination?: Pagination;
  sort?: InputMaybe<Sort>;
  term: Scalars['String']['input'];
  type: Array<StructureSearchType>;
};

export type StructureSearchResults = {
  __typename?: 'StructureSearchResults';
  facets: Array<Facet>;
  items: Array<Substance>;
  metadata: SearchResultsMetadata;
};

export enum StructureSearchType {
  Exact = 'exact',
  Fragment = 'fragment',
  Identity = 'identity',
  Similarity = 'similarity',
  Substructure = 'substructure'
}

export type SubItemPriceInputSiRna = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  subSetItems?: InputMaybe<Array<InputMaybe<SubItemSiRnaArray>>>;
};

export type SubItemSiRnaArray = {
  purification?: InputMaybe<Scalars['String']['input']>;
  siRNAId?: InputMaybe<Scalars['String']['input']>;
  siRNAType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type SubSetInfo = {
  __typename?: 'SubSetInfo';
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  refSeqId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SubSetInfoInput = {
  geneId?: InputMaybe<Scalars['String']['input']>;
  geneSymbol?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  refSeqId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubmitFullRegistrationResponse = {
  __typename?: 'SubmitFullRegistrationResponse';
  participantId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionCreditCard = {
  __typename?: 'SubscriptionCreditCard';
  cardExpiry?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionIdData = {
  __typename?: 'SubscriptionIdData';
  createdDate: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  materialName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  canSkip?: Maybe<Scalars['Boolean']['output']>;
  createdDate: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['String']['output'];
  material: Material;
  materialNumber: Scalars['String']['output'];
  nextOrderDate?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<SubscriptionPayment>;
  quantity: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type SubscriptionPayment = {
  __typename?: 'SubscriptionPayment';
  creditCard?: Maybe<SubscriptionCreditCard>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
};

export type SubsetItemPrice = {
  __typename?: 'SubsetItemPrice';
  result?: Maybe<Array<Maybe<SubsetPricingInfo>>>;
};

export type SubsetPricingInfo = {
  __typename?: 'SubsetPricingInfo';
  checked?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  siRNAId?: Maybe<Scalars['String']['output']>;
  siRNAType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type Substance = {
  __typename?: 'Substance';
  _id: Scalars['ID']['output'];
  aliases: Array<Alias>;
  attributeList: Array<KeyValue>;
  casNumber?: Maybe<Scalars['String']['output']>;
  empiricalFormula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<CatalogImage>;
  key: Scalars['String']['output'];
  keyAttributes?: Maybe<Array<ProductAttribute>>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNameSuffix?: Maybe<Scalars['String']['output']>;
  linearFormula?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  products: Array<Product>;
  synonyms: Array<Scalars['String']['output']>;
};

export type Suggestion = {
  __typename?: 'Suggestion';
  brandKey?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  productKey?: Maybe<Scalars['String']['output']>;
  substanceKey?: Maybe<Scalars['String']['output']>;
};

export type SupplementaryMessage = {
  __typename?: 'SupplementaryMessage';
  messageKey?: Maybe<Scalars['String']['output']>;
  messageValue?: Maybe<Scalars['String']['output']>;
  messageVariable1?: Maybe<Scalars['String']['output']>;
  messageVariable2?: Maybe<Scalars['String']['output']>;
  messageVariable3?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type SymbolInput = {
  symbol: Scalars['String']['input'];
};

export type TechnicalDocument = {
  __typename?: 'TechnicalDocument';
  documentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TermConditionResponse = {
  __typename?: 'TermConditionResponse';
  requireTermConditionUpdate: Scalars['Boolean']['output'];
  terms: Array<Maybe<TermConditionItem>>;
};

export type TermsCount = {
  __typename?: 'TermsCount';
  term?: Maybe<Scalars['String']['output']>;
};

export type TestSpec = {
  __typename?: 'TestSpec';
  name: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyTokenInput = {
  auth_token?: InputMaybe<Scalars['String']['input']>;
  client_id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  redirect_uri: Scalars['String']['input'];
  response_type: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyTokenResponse = {
  __typename?: 'ThirdPartyTokenResponse';
  client_name?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  error_description?: Maybe<Scalars['String']['output']>;
  response_status_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Titer = {
  __typename?: 'Titer';
  powerof6?: Maybe<Scalars['String']['output']>;
  powerof7?: Maybe<Scalars['String']['output']>;
  powerof8?: Maybe<Scalars['String']['output']>;
  powerof9?: Maybe<Scalars['String']['output']>;
};

export type TrackingTracesDetail = {
  __typename?: 'TrackingTracesDetail';
  acceptStation: Scalars['String']['output'];
  acceptTime: Scalars['String']['output'];
  action: Scalars['String']['output'];
  location: Scalars['String']['output'];
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  displayAmtInParenthesis: Scalars['Boolean']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Scalars['String']['output']>;
};

export type TubeDataFromSession = {
  __typename?: 'TubeDataFromSession';
  data: Array<TubeSessionData>;
};

export type TubeListError = {
  __typename?: 'TubeListError';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TubePriceCall = {
  __typename?: 'TubePriceCall';
  result?: Maybe<Array<Maybe<RuleValidateResponse>>>;
};

export type TubeRuleValidateResponse = {
  __typename?: 'TubeRuleValidateResponse';
  additionalServices?: Maybe<Array<Scalars['String']['output']>>;
  antisenceName?: Maybe<Scalars['String']['output']>;
  antisenseBaseCount?: Maybe<Scalars['String']['output']>;
  antisenseGcContent?: Maybe<Scalars['String']['output']>;
  antisenseMeltingTemperature?: Maybe<Scalars['String']['output']>;
  antisenseMolecularWeight?: Maybe<Scalars['String']['output']>;
  antisensePrimerDimer?: Maybe<Scalars['String']['output']>;
  antisenseSecondaryStructure?: Maybe<Scalars['String']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  epsilon?: Maybe<Scalars['Float']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  fullSOligoBackbone?: Maybe<Scalars['Boolean']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  internalMod?: Maybe<Scalars['String']['output']>;
  isLNABaseEnable?: Maybe<Scalars['Boolean']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listAdditionalCarrierProtein?: Maybe<Array<Scalars['String']['output']>>;
  listAdditionalServices?: Maybe<Array<Scalars['String']['output']>>;
  listAmount?: Maybe<Array<Scalars['String']['output']>>;
  listConcentration?: Maybe<Array<Scalars['String']['output']>>;
  listConjugation?: Maybe<Array<Scalars['String']['output']>>;
  listConjugationAmount?: Maybe<Array<Scalars['String']['output']>>;
  listConjugationChemistry?: Maybe<Array<Scalars['String']['output']>>;
  listCterminalMod?: Maybe<Array<Scalars['String']['output']>>;
  listErrors?: Maybe<Array<TubeListError>>;
  listFiveMod?: Maybe<Array<Scalars['String']['output']>>;
  listFormat?: Maybe<Array<Scalars['String']['output']>>;
  listInternalMod?: Maybe<Array<Scalars['String']['output']>>;
  listLabeledAminoAcids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMinimumYield?: Maybe<Scalars['Float']['output']>;
  listModification?: Maybe<Array<Scalars['String']['output']>>;
  listNterminalMod?: Maybe<Array<Scalars['String']['output']>>;
  listPurification?: Maybe<Array<Scalars['String']['output']>>;
  listPurityLevel?: Maybe<Array<Scalars['String']['output']>>;
  listQuantitation?: Maybe<Array<Scalars['String']['output']>>;
  listScale?: Maybe<Array<Scalars['String']['output']>>;
  listServices?: Maybe<Array<Scalars['String']['output']>>;
  listThreeMod?: Maybe<Array<Scalars['String']['output']>>;
  listTubes?: Maybe<Array<Scalars['String']['output']>>;
  listWarnings?: Maybe<Array<ListWarning>>;
  material?: Maybe<Scalars['String']['output']>;
  meltingTemperature?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  threeMod?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['String']['output']>;
};

export type TubeSessionData = {
  __typename?: 'TubeSessionData';
  additionalCarrierProtein?: Maybe<Scalars['String']['output']>;
  additionalComments?: Maybe<Scalars['String']['output']>;
  additionalServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  amount?: Maybe<Scalars['String']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  autoValidation?: Maybe<Scalars['String']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  carrierProtein?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  conjugation?: Maybe<Scalars['String']['output']>;
  conjugationAmount?: Maybe<Scalars['String']['output']>;
  conjugationChemistry?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  crRnaType?: Maybe<Scalars['String']['output']>;
  crossContamination?: Maybe<Scalars['String']['output']>;
  cterminalMod?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  customPeptideType?: Maybe<Scalars['String']['output']>;
  epsilon?: Maybe<Scalars['Float']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  fiveModCategory?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  fullSOligoBackbone?: Maybe<Scalars['Boolean']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalMod?: Maybe<Scalars['String']['output']>;
  internalModCategory?: Maybe<Scalars['String']['output']>;
  isCSR?: Maybe<Scalars['Boolean']['output']>;
  isCSRSupervisor?: Maybe<Scalars['Boolean']['output']>;
  isLabelledAminoAcid?: Maybe<Scalars['Boolean']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  isoCode?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listProductPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listShippingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  material?: Maybe<Scalars['String']['output']>;
  meltingTemparature?: Maybe<Scalars['String']['output']>;
  minimumYield?: Maybe<Scalars['String']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nterminalMod?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  orderItemId?: Maybe<Scalars['String']['output']>;
  otherValue?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  plateType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  probeType?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  purityLevel?: Maybe<Scalars['String']['output']>;
  quantitation?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  sequenceLocation?: Maybe<Scalars['String']['output']>;
  threeMod?: Maybe<Scalars['String']['output']>;
  threeModCategory?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['String']['output']>;
};

export type TxnBadge = {
  __typename?: 'TxnBadge';
  label: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  salesOrgIds: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type UpdateCartInput = {
  billingAddress?: InputMaybe<CartAddressInput>;
  blanketPoNumber?: InputMaybe<Scalars['String']['input']>;
  chargebackCodes?: InputMaybe<ChargebackCodeInput>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<NewCreditCardInput>;
  customerServiceInstructions?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  orderingPartyAddress?: InputMaybe<CartAddressInput>;
  packingSlipNote?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<CartPartnersInput>;
  paymentMethods?: InputMaybe<CartPaymentMethodsInput>;
  pin?: InputMaybe<Scalars['String']['input']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  salesOrderSource?: InputMaybe<SalesOrderSource>;
  saveAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  selectedPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<CartAddressInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};

/** Used to update an existing cart item's quantity or promo code (Slow) */
export type UpdateCartItemInput = {
  cartItemId: Scalars['ID']['input'];
  deviceSerialNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSingleLotSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not required, but if null, will override the previous value to null */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  subscriptionFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCoworkerGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<GroupPartner>;
};

export type UpdateCoworkerRolesInput = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type UpdateOrDeleteRequesterInput = {
  approvalAmount?: InputMaybe<Scalars['Float']['input']>;
  approvalProductType?: InputMaybe<Scalars['String']['input']>;
  approvalTypeId?: InputMaybe<Scalars['String']['input']>;
  approverId?: InputMaybe<Scalars['String']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  logonId?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrdersPendingApprovalInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  orderIds: Array<Scalars['String']['input']>;
};

export type UpdatePinnedAddress = {
  addresses: Array<PinnedAddressInputItem>;
};

export type UpdateProfileNameContactInfoInput = {
  addressId: Scalars['String']['input'];
  logonId: Scalars['String']['input'];
  mobileNumber: Scalars['String']['input'];
  telephoneNumber: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateQuickOrderItemInput = {
  itemId: Scalars['String']['input'];
  quickOrderItems: Array<QuickOrderItem>;
};

export type UpdateSavedCartInput = {
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSharedListInput = {
  coOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Array<Scalars['String']['input']>>;
  listId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reminderFrequencyDays?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateSharedListItemInput = {
  itemNote?: InputMaybe<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
  listItemId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTermsAndConditionsInput = {
  generalTermsCondition: Scalars['Boolean']['input'];
  participantId: Scalars['String']['input'];
  siteAgreement: Scalars['Boolean']['input'];
};

export type UpdateUserProfileInput = {
  billingAddress?: InputMaybe<AddressInput>;
  contactAddress?: InputMaybe<AddressInput>;
  inviteeId?: InputMaybe<Scalars['String']['input']>;
  participantCommunicationSetting?: InputMaybe<UserParticipantCommunicationSettingInput>;
  participantShippingPreference?: InputMaybe<UserParticipantShippingPreferenceInput>;
  participantSitePreference?: InputMaybe<UserParticipantSitePreferenceInput>;
  paymentMethods?: InputMaybe<PaymentMethodsInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  updateApproverRole?: InputMaybe<Scalars['Boolean']['input']>;
  useShipToAddressForAllOrders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserSitePreferenceInput = {
  dealerId: Scalars['String']['input'];
  dealerTcs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWimsAccessCodeResponse = {
  __typename?: 'UpdateWIMSAccessCodeResponse';
  success: Scalars['Boolean']['output'];
};

export type UploadCopyPasteResponse = {
  __typename?: 'UploadCopyPasteResponse';
  key?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  key?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UpsertDropshipAddressInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  buildingRoom?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type User = GuestUser | LoggedInUser;

export type UserActivityEntry = {
  __typename?: 'UserActivityEntry';
  featureType: Scalars['String']['output'];
  trackingData?: Maybe<Scalars['JSONObject']['output']>;
};

export type UserActivityInput = {
  featureType: Scalars['String']['input'];
  trackingData: Scalars['JSONObject']['input'];
};

export type UserAddress = {
  __typename?: 'UserAddress';
  addressId: Scalars['String']['output'];
  attentionTo: LockableValue;
  buildingRoom: LockableValue;
  city: Scalars['String']['output'];
  cityLockable: LockableValue;
  country: Scalars['String']['output'];
  countryLockable: LockableValue;
  countryName: Scalars['String']['output'];
  countryNameLockable: LockableValue;
  department: LockableValue;
  district: Scalars['String']['output'];
  email: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName: Scalars['String']['output'];
  mobilePhone: Scalars['String']['output'];
  officeRegistrationNumber: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  organizationNameLockable: LockableValue;
  organizationProperty?: Maybe<Scalars['String']['output']>;
  postOfficeBox: Scalars['String']['output'];
  postOfficeBoxLockable: LockableValue;
  postalCode: Scalars['String']['output'];
  postalCodeLockable: LockableValue;
  principalInvestigator?: Maybe<Scalars['String']['output']>;
  salesRepresentative?: Maybe<Scalars['String']['output']>;
  salutation: Scalars['String']['output'];
  state: Scalars['String']['output'];
  stateLockable: LockableValue;
  street: Scalars['String']['output'];
  street2: Scalars['String']['output'];
  street3: Scalars['String']['output'];
  street4: Scalars['String']['output'];
  streetLockable: LockableValue;
  telephone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UserByToken = {
  __typename?: 'UserByToken';
  metadata: UserMetadata;
  participantSitePreference?: Maybe<UserParticipantSitePreference>;
  userProfile?: Maybe<UserByTokenProflie>;
};

export type UserByTokenProflie = {
  __typename?: 'UserByTokenProflie';
  logonId?: Maybe<Scalars['String']['output']>;
};

export type UserChargebackInput = {
  chargebacks?: InputMaybe<Array<InputMaybe<ChargebackInputList>>>;
};

export type UserChargebackPartner = {
  __typename?: 'UserChargebackPartner';
  chargeback_bill_to?: Maybe<Scalars['String']['output']>;
  chargeback_payer?: Maybe<Scalars['String']['output']>;
  chargeback_ship_to?: Maybe<Scalars['String']['output']>;
  chargeback_sold_to?: Maybe<Scalars['String']['output']>;
};

export type UserChargebacks = {
  __typename?: 'UserChargebacks';
  chargebackCode?: Maybe<Scalars['String']['output']>;
  chargebackLabel?: Maybe<Scalars['String']['output']>;
  isDisplay?: Maybe<Scalars['Boolean']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isOnEmail?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  partners?: Maybe<UserChargebackPartner>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UserCreditCard = {
  __typename?: 'UserCreditCard';
  cardExpiryDate?: Maybe<Scalars['String']['output']>;
  cardNameLabel?: Maybe<Scalars['String']['output']>;
  cardNameValue?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  ccLegalTermsAcceptance?: Maybe<Scalars['Boolean']['output']>;
  displayableInCart?: Maybe<Scalars['Boolean']['output']>;
  displayableInEmail?: Maybe<Scalars['Boolean']['output']>;
  editableInCart?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  saveAsDefault?: Maybe<Scalars['Boolean']['output']>;
  tokenizedCCNumber?: Maybe<Scalars['String']['output']>;
  transientCCToken?: Maybe<Scalars['String']['output']>;
};

export enum UserErpType {
  Anonymous = 'ANONYMOUS',
  Blue = 'BLUE',
  NewUser = 'NEW_USER',
  Purple = 'PURPLE',
  Red = 'RED'
}

export type UserMessage = {
  content: Scalars['String']['input'];
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  country: Scalars['String']['output'];
  emproveDomainStatus?: Maybe<Scalars['String']['output']>;
  erpSystemId: Scalars['String']['output'];
  fddLevel?: Maybe<Scalars['String']['output']>;
  guestShoppingType?: Maybe<Scalars['String']['output']>;
  hasOnlyBlueERP?: Maybe<Scalars['Boolean']['output']>;
  helpLinkURL?: Maybe<Scalars['String']['output']>;
  invoicePdfDisplay?: Maybe<Scalars['Boolean']['output']>;
  isBigFormFilled?: Maybe<Scalars['Boolean']['output']>;
  isBlanketPOEnabled?: Maybe<Scalars['Boolean']['output']>;
  isBlueErpIntegrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  isBuildingBlockEnabled?: Maybe<Scalars['Boolean']['output']>;
  isChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  isContractEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCreditCardEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDTAQZuCustomer: Scalars['Boolean']['output'];
  isDejaEnabled: Scalars['Boolean']['output'];
  isDigitalProductEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFddEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFullQuoteConversionEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInvoiceCenterEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMarketplaceCartEnabled: Scalars['Boolean']['output'];
  isMarketplaceCatalogEnabled: Scalars['Boolean']['output'];
  isNewPNASrpEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderNotesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isQuoteEnabled?: Maybe<Scalars['Boolean']['output']>;
  isRandRenabled?: Maybe<Scalars['Boolean']['output']>;
  isRememberMeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSAPNextEnabled?: Maybe<Scalars['Boolean']['output']>;
  isScanNowEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSingleLotEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSwitchAccountsEnabled?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  oneCIAMEnabled?: Maybe<Scalars['Boolean']['output']>;
  passwordPatternModel?: Maybe<PasswordPatternModelType>;
  salesOrg?: Maybe<Scalars['String']['output']>;
  wimsBlueOnRedEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type UserParticipantCommunicationSetting = {
  __typename?: 'UserParticipantCommunicationSetting';
  attachmentConfirmationEmail: Scalars['Boolean']['output'];
  bccOrderConfirmationEmailIds: Array<Scalars['String']['output']>;
  ccOrderConfirmationEmailIds: Array<Scalars['String']['output']>;
  emproveEmailVerification: Scalars['Boolean']['output'];
  emproveTermsConditions: Scalars['Boolean']['output'];
  invitationSent: Scalars['Boolean']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  isOffersPromotionsEmail: Scalars['Boolean']['output'];
  orderConfirmationEmail: Scalars['Boolean']['output'];
  repromiseTrackingEmail: Scalars['Boolean']['output'];
  shipmentTrackingEmail: Scalars['Boolean']['output'];
  unpricedCcEmails: Array<Scalars['String']['output']>;
};

export type UserParticipantCommunicationSettingInput = {
  attachmentConfirmationEmail: Scalars['Boolean']['input'];
  bccOrderConfirmationEmailIds: Array<Scalars['String']['input']>;
  ccOrderConfirmationEmailIds: Array<Scalars['String']['input']>;
  emproveEmailVerification: Scalars['Boolean']['input'];
  invitationSent: Scalars['Boolean']['input'];
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isOffersPromotionsEmail: Scalars['Boolean']['input'];
  orderConfirmationEmail: Scalars['Boolean']['input'];
  repromiseTrackingEmail: Scalars['Boolean']['input'];
  shipmentTrackingEmail: Scalars['Boolean']['input'];
  unpricedCcEmails: Array<Scalars['String']['input']>;
};

export type UserParticipantComplianceInformation = {
  __typename?: 'UserParticipantComplianceInformation';
  bankName?: Maybe<Scalars['String']['output']>;
  bankNo?: Maybe<Scalars['String']['output']>;
  complianceTerms?: Maybe<Scalars['Boolean']['output']>;
  dealerTerms?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  invoiceAddress?: Maybe<Scalars['String']['output']>;
  invoiceContactPhoneNo?: Maybe<Scalars['String']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<Scalars['String']['output']>;
  invoiceTypeReason?: Maybe<Scalars['String']['output']>;
  labAndWarehouseFacilities?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  organizationWebsite?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  primaryBusinessActivity?: Maybe<UserPrimaryBusinessActivity>;
  productUsage?: Maybe<Scalars['String']['output']>;
  safetyEquipment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  salesVATTaxApplicable?: Maybe<Scalars['Boolean']['output']>;
  termsOfSale?: Maybe<Scalars['Boolean']['output']>;
  vatTaxNumber?: Maybe<Scalars['String']['output']>;
};

export type UserParticipantComplianceInformationInput = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankNo?: InputMaybe<Scalars['String']['input']>;
  complianceTerms?: InputMaybe<Scalars['Boolean']['input']>;
  dealerTerms?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  invoiceAddress?: InputMaybe<Scalars['String']['input']>;
  invoiceContactPhoneNo?: InputMaybe<Scalars['String']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoiceTypeReason?: InputMaybe<Scalars['String']['input']>;
  labAndWarehouseFacilities?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  organizationWebsite?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  primaryBusinessActivity?: InputMaybe<UserPrimaryBusinessActivityInput>;
  productUsage?: InputMaybe<Scalars['String']['input']>;
  safetyEquipment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesVATTaxApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  termsOfSale?: InputMaybe<Scalars['Boolean']['input']>;
  vatTaxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserParticipantShippingMethods = {
  __typename?: 'UserParticipantShippingMethods';
  description: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDisplay: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  shipModeId: Scalars['Int']['output'];
  shippingMethodCode?: Maybe<Scalars['String']['output']>;
};

export type UserParticipantShippingMethodsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  shipModeId: Scalars['Int']['input'];
  shippingMethodCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserParticipantShippingPreference = {
  __typename?: 'UserParticipantShippingPreference';
  countryDefaultShippingEnabled: Scalars['Boolean']['output'];
  countryDefaultShippingLocked: Scalars['Boolean']['output'];
  participantId: Scalars['String']['output'];
  participantShippingMethods?: Maybe<Array<Maybe<UserParticipantShippingMethods>>>;
};

export type UserParticipantShippingPreferenceInput = {
  countryDefaultShippingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  countryDefaultShippingLocked?: InputMaybe<Scalars['Boolean']['input']>;
  participantId: Scalars['String']['input'];
  participantShippingMethods?: InputMaybe<Array<InputMaybe<UserParticipantShippingMethodsInput>>>;
};

export type UserParticipantSitePreference = {
  __typename?: 'UserParticipantSitePreference';
  catalogFilter?: Maybe<Scalars['String']['output']>;
  dealerTcs?: Maybe<Scalars['Boolean']['output']>;
  generalTermsCondition?: Maybe<Scalars['Boolean']['output']>;
  hideAddToCartForPrepackItems: Scalars['Boolean']['output'];
  hideBuildingBlocks?: Maybe<Scalars['Boolean']['output']>;
  hideContractOption?: Maybe<Scalars['Boolean']['output']>;
  hideCustomProductBlanketPoOrdering?: Maybe<Scalars['Boolean']['output']>;
  hideOligoPeptideDesign?: Maybe<Scalars['Boolean']['output']>;
  isRedirectToProductDetail: Scalars['Boolean']['output'];
  legacyLogin?: Maybe<Scalars['Boolean']['output']>;
  numberOfEntryFields: Scalars['Int']['output'];
  numberOfRecentOrders: Scalars['Int']['output'];
  numberOfRecentQuotes: Scalars['Int']['output'];
  piiDataConsentAcceptance?: Maybe<Scalars['Boolean']['output']>;
  preferredDealerId?: Maybe<Scalars['String']['output']>;
  preferredDealerInfo?: Maybe<UserPreferredDealerInfo>;
  productEntryPreference: Scalars['String']['output'];
  sdsLocale: Scalars['String']['output'];
  siteAgreement?: Maybe<Scalars['Boolean']['output']>;
  websiteLocale: Scalars['String']['output'];
};

export type UserParticipantSitePreferenceInput = {
  isRedirectToProductDetail: Scalars['Boolean']['input'];
  numberOfEntryFields: Scalars['Int']['input'];
  numberOfRecentOrders: Scalars['Int']['input'];
  numberOfRecentQuotes: Scalars['Int']['input'];
  productEntryPreference: Scalars['String']['input'];
  sdsLocale: Scalars['String']['input'];
  websiteLocale: Scalars['String']['input'];
};

export type UserPaymentMethods = {
  __typename?: 'UserPaymentMethods';
  chargebacks: Array<Maybe<UserChargebacks>>;
  creditCard: Array<UserCreditCard>;
  defaultPaymentMethod: Scalars['String']['output'];
  purchaseOrderNumber: PaymentLabelValue;
  requisitionNumber: PaymentLabelValue;
};

export type UserPreferredDealerInfo = {
  __typename?: 'UserPreferredDealerInfo';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  dealerId: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
};

export type UserPrimaryBusinessActivity = {
  __typename?: 'UserPrimaryBusinessActivity';
  cellCulture?: Maybe<Scalars['Boolean']['output']>;
  consultant?: Maybe<Scalars['Boolean']['output']>;
  cosmetics?: Maybe<Scalars['Boolean']['output']>;
  diagnosticsInVitro?: Maybe<Scalars['Boolean']['output']>;
  dogTrainer?: Maybe<Scalars['Boolean']['output']>;
  drugsAnimal?: Maybe<Scalars['Boolean']['output']>;
  drugsHuman?: Maybe<Scalars['Boolean']['output']>;
  electronics?: Maybe<Scalars['Boolean']['output']>;
  exporter?: Maybe<Scalars['Boolean']['output']>;
  exporterText?: Maybe<Scalars['String']['output']>;
  foods?: Maybe<Scalars['Boolean']['output']>;
  government?: Maybe<Scalars['Boolean']['output']>;
  laboratory?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['Boolean']['output']>;
  manufacturerText?: Maybe<Scalars['String']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  otherText?: Maybe<Scalars['String']['output']>;
  resaleUnderOtherLabel?: Maybe<Scalars['Boolean']['output']>;
  resaleUnderSigmaAldrich?: Maybe<Scalars['Boolean']['output']>;
  resellerDistributor?: Maybe<Scalars['Boolean']['output']>;
  retailer?: Maybe<Scalars['Boolean']['output']>;
  testing?: Maybe<Scalars['Boolean']['output']>;
  university?: Maybe<Scalars['Boolean']['output']>;
  veterinaryClinic?: Maybe<Scalars['Boolean']['output']>;
};

export type UserPrimaryBusinessActivityInput = {
  cellCulture?: InputMaybe<Scalars['Boolean']['input']>;
  consultant?: InputMaybe<Scalars['Boolean']['input']>;
  cosmetics?: InputMaybe<Scalars['Boolean']['input']>;
  diagnosticsInVitro?: InputMaybe<Scalars['Boolean']['input']>;
  dogTrainer?: InputMaybe<Scalars['Boolean']['input']>;
  drugsAnimal?: InputMaybe<Scalars['Boolean']['input']>;
  drugsHuman?: InputMaybe<Scalars['Boolean']['input']>;
  electronics?: InputMaybe<Scalars['Boolean']['input']>;
  exporter?: InputMaybe<Scalars['Boolean']['input']>;
  exporterText?: InputMaybe<Scalars['String']['input']>;
  foods?: InputMaybe<Scalars['Boolean']['input']>;
  government?: InputMaybe<Scalars['Boolean']['input']>;
  laboratory?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerText?: InputMaybe<Scalars['String']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  otherText?: InputMaybe<Scalars['String']['input']>;
  resaleUnderOtherLabel?: InputMaybe<Scalars['Boolean']['input']>;
  resaleUnderSigmaAldrich?: InputMaybe<Scalars['Boolean']['input']>;
  resellerDistributor?: InputMaybe<Scalars['Boolean']['input']>;
  retailer?: InputMaybe<Scalars['Boolean']['input']>;
  testing?: InputMaybe<Scalars['Boolean']['input']>;
  university?: InputMaybe<Scalars['Boolean']['input']>;
  veterinaryClinic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  accountNumber?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
};

export type UserPushSubscription = {
  __typename?: 'UserPushSubscription';
  /** TODO: deviceLabel only needed for PoC, not needed for production */
  deviceLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subscription: PushSubscription;
  userId: Scalars['String']['output'];
};

export type UserSavedRegistration = {
  __typename?: 'UserSavedRegistration';
  accountNumber?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<UserAddress>;
  contactAddress?: Maybe<UserAddress>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  logonId?: Maybe<Scalars['String']['output']>;
  officeAddress?: Maybe<UserAddress>;
  participantComplianceInformation?: Maybe<UserParticipantComplianceInformation>;
  paymentAddress?: Maybe<UserAddress>;
  shippingAddress?: Maybe<UserAddress>;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  userAffiliated?: Maybe<Scalars['Boolean']['output']>;
  userFTBOrderStatus?: Maybe<Scalars['String']['output']>;
  userFullRegistrationFormCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserType {
  Guest = 'Guest',
  LoggedIn = 'LoggedIn',
  RememberMe = 'RememberMe'
}

export type ValidMaterialAvailability = {
  __typename?: 'ValidMaterialAvailability';
  availabilities: Array<MaterialAvailability>;
};

export type ValidMaterialPricing = {
  __typename?: 'ValidMaterialPricing';
  additionalInfo: CartAdditionalInfo;
  availabilities: Array<MaterialAvailability>;
  availableQtyInStock?: Maybe<Scalars['Int']['output']>;
  brand: Scalars['String']['output'];
  catalogType?: Maybe<CatalogType>;
  currency: Scalars['String']['output'];
  dealerId?: Maybe<Scalars['String']['output']>;
  ecomStrikeThroughPrice?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  freeFreight?: Maybe<Scalars['Boolean']['output']>;
  hidePriceMessageKey?: Maybe<Scalars['String']['output']>;
  isBlockedProduct: Scalars['Boolean']['output'];
  isBuyNow?: Maybe<Scalars['Boolean']['output']>;
  isPBAvailable: Scalars['Boolean']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  listPriceCurrency?: Maybe<Scalars['String']['output']>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  marketplaceSellerId?: Maybe<Scalars['String']['output']>;
  materialDescription: Scalars['String']['output'];
  materialId?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  minOrderQuantity?: Maybe<Scalars['Int']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  packageQuantity?: Maybe<Scalars['String']['output']>;
  packageSize?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product: Scalars['String']['output'];
  productGroupSBU?: Maybe<Scalars['String']['output']>;
  productHierarchy?: Maybe<Scalars['String']['output']>;
  promotionalMessage?: Maybe<PromotionalMessage>;
  quantity: Scalars['Int']['output'];
  sdsLanguages: Array<Maybe<Scalars['String']['output']>>;
  shipsToday?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<CartItemType>;
  vendorSKU?: Maybe<Scalars['String']['output']>;
};

export type VatInfoItem = {
  __typename?: 'VatInfoItem';
  companyName: Scalars['String']['output'];
  vatNumber: Scalars['String']['output'];
};

export type Vector = {
  __typename?: 'Vector';
  LV01?: Maybe<Scalars['String']['output']>;
  LV02?: Maybe<Scalars['String']['output']>;
  LV03?: Maybe<Scalars['String']['output']>;
  LV04?: Maybe<Scalars['String']['output']>;
  LV05?: Maybe<Scalars['String']['output']>;
  LV08?: Maybe<Scalars['String']['output']>;
  LV13?: Maybe<Scalars['String']['output']>;
  LV14?: Maybe<Scalars['String']['output']>;
  LV15?: Maybe<Scalars['String']['output']>;
  LV16?: Maybe<Scalars['String']['output']>;
  LV17?: Maybe<Scalars['String']['output']>;
  p01?: Maybe<Scalars['String']['output']>;
  p02?: Maybe<Scalars['String']['output']>;
  p03?: Maybe<Scalars['String']['output']>;
  p04?: Maybe<Scalars['String']['output']>;
  p05?: Maybe<Scalars['String']['output']>;
};

export type VectorDocument = {
  __typename?: 'VectorDocument';
  fileContent?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type VectorDocumentInput = {
  owner: Scalars['String']['input'];
  term: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

export type VectorDocumentResponse = {
  __typename?: 'VectorDocumentResponse';
  file_name?: Maybe<Scalars['String']['output']>;
  responseStream?: Maybe<Scalars['String']['output']>;
};

export type VerificationResponse = {
  __typename?: 'VerificationResponse';
  emailAddress: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Volume = {
  __typename?: 'Volume';
  pointOne?: Maybe<Scalars['String']['output']>;
  pointTwo?: Maybe<Scalars['String']['output']>;
  volFive?: Maybe<Scalars['String']['output']>;
  volOne?: Maybe<Scalars['String']['output']>;
  volTen?: Maybe<Scalars['String']['output']>;
  volTwo?: Maybe<Scalars['String']['output']>;
};

export type WaterSystem = {
  __typename?: 'WaterSystem';
  imageId?: Maybe<Scalars['String']['output']>;
  skuList?: Maybe<Array<Maybe<SkuItem>>>;
};

export type WaterSystemInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  skuList?: InputMaybe<Array<InputMaybe<SkuItemInput>>>;
};

export type WebOrdersInput = {
  numberOfRecentOrders: Scalars['Int']['input'];
  statusCategory?: InputMaybe<Scalars['String']['input']>;
};

export type WebOrdersPayload = {
  __typename?: 'WebOrdersPayload';
  count?: Maybe<Scalars['Int']['output']>;
  orders: Array<Order>;
};

export type WebQuotesInput = {
  numberOfRecentQuotes: Scalars['Int']['input'];
  productNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WebQuotesPayload = {
  __typename?: 'WebQuotesPayload';
  count: Scalars['Int']['output'];
  quotes: Array<Quote>;
};

export type Webinars = {
  __typename?: 'Webinars';
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pagePath?: Maybe<Scalars['String']['output']>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primarySubCategory?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Maybe<Sessions>>>;
  speakers?: Maybe<Array<Maybe<Speakers>>>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upcoming?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WechatInfo = {
  __typename?: 'WechatInfo';
  unionId?: Maybe<Scalars['String']['output']>;
};

export type WechatLoginResponse = {
  __typename?: 'WechatLoginResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type WellListPrice = {
  __typename?: 'WellListPrice';
  baseCount?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  formattedPrice?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Scalars['String']['output']>;
};

export type WellListUploadInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
};

export type WellSpecificationResponse = {
  __typename?: 'WellSpecificationResponse';
  response?: Maybe<Array<Maybe<WellSpecifications>>>;
  serverError?: Maybe<ListError>;
};

export type WellSpecifications = {
  __typename?: 'WellSpecifications';
  id: Scalars['Int']['output'];
  listAmount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listFormat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listPurification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listScale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WelllItemInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  mixed?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  technicalSequence?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['Int']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type Welllist = {
  __typename?: 'Welllist';
  additionalComments?: Maybe<Scalars['String']['output']>;
  additionalServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  amount?: Maybe<Scalars['String']['output']>;
  analyticalHPLC?: Maybe<Scalars['String']['output']>;
  baseCount?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  certificateOfAnalysis?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  concentration?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  crossContamination?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  epsilon?: Maybe<Scalars['Float']['output']>;
  excessMaterial?: Maybe<Scalars['Boolean']['output']>;
  fiveMod?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  gcContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  listAdditionalServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listISO?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listNgso?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listWarning?: Maybe<Array<Maybe<ListWarning>>>;
  meltingTemparature?: Maybe<Scalars['String']['output']>;
  mixed?: Maybe<Scalars['Int']['output']>;
  molecularWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ngsoType?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  orderItemId?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  primerDimer?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  qualitySystem?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  secondaryStructure?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Scalars['String']['output']>;
  technicalSequence?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['Boolean']['output']>;
  threeMod?: Maybe<Scalars['String']['output']>;
  tubes?: Maybe<Scalars['Int']['output']>;
  wellType?: Maybe<Scalars['Int']['output']>;
};

export type WelllistInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  additionalServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<Scalars['String']['input']>;
  analyticalHPLC?: InputMaybe<Scalars['String']['input']>;
  baseCount?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  certificateOfAnalysis?: InputMaybe<Scalars['String']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  crossContamination?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  epsilon?: InputMaybe<Scalars['Float']['input']>;
  excessMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  fiveMod?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  gcContent?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  listAdditionalServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listISO?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listNgso?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listWarning?: InputMaybe<Array<InputMaybe<ListWarningInput>>>;
  meltingTemparature?: InputMaybe<Scalars['String']['input']>;
  mixed?: InputMaybe<Scalars['Int']['input']>;
  molecularWeight?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ngsoType?: InputMaybe<Scalars['String']['input']>;
  oligoId?: InputMaybe<Scalars['Int']['input']>;
  orderItemId?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  priceHeaderError?: InputMaybe<Scalars['String']['input']>;
  primerDimer?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purification?: InputMaybe<Scalars['String']['input']>;
  qualitySystem?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  secondaryStructure?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['String']['input']>;
  technicalSequence?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  threeMod?: InputMaybe<Scalars['String']['input']>;
  tubes?: InputMaybe<Scalars['Int']['input']>;
  wellType?: InputMaybe<Scalars['Int']['input']>;
};

export type WelllistResponse = {
  __typename?: 'WelllistResponse';
  countryCode?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listNgso?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  oligoId?: Maybe<Scalars['Int']['output']>;
};

export type WimsTokenInfoResponse = {
  __typename?: 'WimsTokenInfoResponse';
  blueOAuthURL: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  userIsAuthenticatedBlueSystem?: Maybe<Scalars['Boolean']['output']>;
  userOAuthTokenExpired?: Maybe<Scalars['Boolean']['output']>;
  wimsBlueOnRedEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfiguratorAddToMiniCartInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ConfiguratorMilliplexAddToCartInput = {
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appendToMaterialNumber?: InputMaybe<Scalars['String']['input']>;
  assayType?: InputMaybe<Scalars['String']['input']>;
  customPremixSelection?: InputMaybe<Scalars['String']['input']>;
  customPremixedAvailable?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listSampleType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  material?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  panelName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requireSample?: InputMaybe<Scalars['String']['input']>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampleType?: InputMaybe<Scalars['String']['input']>;
  selectedAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceSaver?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetProductInformationInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  hideOligoPeptideDesign?: InputMaybe<Scalars['Boolean']['input']>;
  isCsr?: InputMaybe<Scalars['Boolean']['input']>;
  isCsrSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderableCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  regUser?: InputMaybe<Scalars['Boolean']['input']>;
  sapNextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MilliQWaterSystemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  filterAndCatridges: Array<Scalars['String']['input']>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  pointOfDispense: Array<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  waterSystem?: InputMaybe<Scalars['String']['input']>;
};

export type MilliQWaterSystemSkuItemInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productNumber?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MilliplexDataInput = {
  Bovineplatform?: InputMaybe<Scalars['String']['input']>;
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  analytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  checkedProductIdList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comments?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  listAnalytes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listError?: InputMaybe<Array<InputMaybe<ListErrorInput>>>;
  listMilliplexAssayModel?: InputMaybe<Array<InputMaybe<MilliplexAssayModel>>>;
  listResearchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSensitivity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listSpecies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listWarning?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mapMates?: InputMaybe<Scalars['String']['input']>;
  milliplexcheckedProductIdList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  oligoId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  priceHeaderError?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  researchAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  researcher?: InputMaybe<Scalars['String']['input']>;
  sampleVolume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sensitivity?: InputMaybe<Scalars['String']['input']>;
  singlePlexPlatform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type MilliplexTotalValidationResponse = {
  __typename?: 'milliplexTotalValidationResponse';
  additionalComments?: Maybe<Scalars['String']['output']>;
  analytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  checkedProductIdList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  comments?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  listAnalytes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listError?: Maybe<Array<Maybe<ListError>>>;
  listMilliplexAssayModel?: Maybe<Array<Maybe<MilliplexSearchResponse>>>;
  listResearchAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSensitivity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listSpecies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listWarning?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mapMates?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  priceHeaderError?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  researchAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  researcher?: Maybe<Scalars['String']['output']>;
  sensitivity?: Maybe<Scalars['String']['output']>;
  serverError?: Maybe<ListError>;
  species?: Maybe<Scalars['String']['output']>;
};

export type PasswordPatternModelType = {
  __typename?: 'passwordPatternModelType';
  mandatoryPattern: Scalars['String']['output'];
  minimumCountMatch: Scalars['String']['output'];
  patterns: Array<Scalars['String']['output']>;
};

export type RestrictedPartnersObject = {
  __typename?: 'restrictedPartnersObject';
  restricedHiddenpartnersIndexId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SemiConfSaveToSessionInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<InputMaybe<ResultsInput>>>;
  selectedItems?: InputMaybe<Array<InputMaybe<ResultsInput>>>;
  stepNo?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SessionResponseResults = {
  __typename?: 'sessionResponseResults';
  countryCode?: Maybe<Scalars['String']['output']>;
  exons?: Maybe<Scalars['String']['output']>;
  geneId?: Maybe<Scalars['String']['output']>;
  geneSymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  primerPairId?: Maybe<Scalars['String']['output']>;
  primerSeqFwd?: Maybe<Scalars['String']['output']>;
  primerSeqRev?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purification?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  refSeqId?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  technicalSequence?: Maybe<Scalars['String']['output']>;
};

export type TermConditionItem = {
  __typename?: 'termConditionItem';
  agree: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  termKey: Scalars['String']['output'];
  termUrl: Scalars['String']['output'];
};

export type TubeEditInput = {
  cartId?: InputMaybe<Scalars['String']['input']>;
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
};

export type TubeTotalValidationResponse = {
  __typename?: 'tubeTotalValidationResponse';
  epsilon?: Maybe<Scalars['Float']['output']>;
  listErrors?: Maybe<Array<Maybe<ListError>>>;
  oligoId?: Maybe<Scalars['Int']['output']>;
  serverError?: Maybe<ListError>;
};

export type ValidateMobileSecurityCodeResponse = {
  __typename?: 'validateMobileSecurityCodeResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};
